(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ux/button")["default"], require("@ux/checkbox")["default"], require("@ux/collapsible")["default"], require("@ux/component")["default"], require("@ux/dropdown")["default"], require("@ux/form-element")["default"], require("@ux/icon")["default"], require("@ux/modal")["default"], require("@ux/namespace-component")["default"], require("@ux/quantity-selector")["default"], require("@ux/radio")["default"], require("@ux/radio-group")["default"], require("@ux/spinner")["default"], require("@ux/tooltip")["default"], require("@ux/util")["default"], require("prop-types"), require("react"), require("react-dom"), require("react-intl")["default"], require("react-trfq")["default"]);
	else if(typeof define === 'function' && define.amd)
		define("UtilityHeader", ["@ux/button", "@ux/checkbox", "@ux/collapsible", "@ux/component", "@ux/dropdown", "@ux/form-element", "@ux/icon", "@ux/modal", "@ux/namespace-component", "@ux/quantity-selector", "@ux/radio", "@ux/radio-group", "@ux/spinner", "@ux/tooltip", "@ux/util", "prop-types", "react", "react-dom", "react-intl", "react-trfq"], factory);
	else if(typeof exports === 'object')
		exports["UtilityHeader"] = factory(require("@ux/button")["default"], require("@ux/checkbox")["default"], require("@ux/collapsible")["default"], require("@ux/component")["default"], require("@ux/dropdown")["default"], require("@ux/form-element")["default"], require("@ux/icon")["default"], require("@ux/modal")["default"], require("@ux/namespace-component")["default"], require("@ux/quantity-selector")["default"], require("@ux/radio")["default"], require("@ux/radio-group")["default"], require("@ux/spinner")["default"], require("@ux/tooltip")["default"], require("@ux/util")["default"], require("prop-types"), require("react"), require("react-dom"), require("react-intl")["default"], require("react-trfq")["default"]);
	else
		root["UtilityHeader"] = factory(root["ux"]["Button"], root["ux"]["Checkbox"], root["ux"]["Collapsible"], root["ux"]["Component"], root["ux"]["Dropdown"], root["ux"]["FormElement"], root["ux"]["Icon"], root["ux"]["Modal"], root["ux"]["NamespaceComponent"], root["ux"]["QuantitySelector"], root["ux"]["Radio"], root["ux"]["RadioGroup"], root["ux"]["Spinner"], root["ux"]["Tooltip"], root["ux"]["utils"], root["PropTypes"], root["React"], root["ReactDOM"], root["ux"]["intl"], root["ux"]["trfq"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__ux_button__, __WEBPACK_EXTERNAL_MODULE__ux_checkbox__, __WEBPACK_EXTERNAL_MODULE__ux_collapsible__, __WEBPACK_EXTERNAL_MODULE__ux_component__, __WEBPACK_EXTERNAL_MODULE__ux_dropdown__, __WEBPACK_EXTERNAL_MODULE__ux_form_element__, __WEBPACK_EXTERNAL_MODULE__ux_icon__, __WEBPACK_EXTERNAL_MODULE__ux_modal__, __WEBPACK_EXTERNAL_MODULE__ux_namespace_component__, __WEBPACK_EXTERNAL_MODULE__ux_quantity_selector__, __WEBPACK_EXTERNAL_MODULE__ux_radio__, __WEBPACK_EXTERNAL_MODULE__ux_radio_group__, __WEBPACK_EXTERNAL_MODULE__ux_spinner__, __WEBPACK_EXTERNAL_MODULE__ux_tooltip__, __WEBPACK_EXTERNAL_MODULE__ux_util__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE_react_intl__, __WEBPACK_EXTERNAL_MODULE_react_trfq__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		"main": 0
/******/ 	};
/******/
/******/
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 		return __webpack_require__.p + "" + ({"vendors~browser-deprecation-banner":"vendors~browser-deprecation-banner","vendors~header-cart":"vendors~header-cart","vendors~notifications":"vendors~notifications"}[chunkId]||chunkId) + ".header-chunk.js"
/******/ 	}
/******/ 	// WebpackRequireFrom - monkey-patching
/******/ 	if (typeof jsonpScriptSrc === 'function') {
/******/ 	  var original_jsonpScriptSrc = jsonpScriptSrc;
/******/ 	  function patchJsonpScriptSrc () {
/******/ 	    try {
/******/ 	      if (typeof ux.getCDNPath !== "function") {
/******/ 	        throw new Error("WebpackRequireFrom: 'ux.getCDNPath' is not a function or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
/******/ 	      }
/******/ 	      var newSrc = ux.getCDNPath(original_jsonpScriptSrc.apply(this, arguments));
/******/ 	      if (!newSrc || typeof newSrc !== 'string') {
/******/ 	        throw new Error("WebpackRequireFrom: 'ux.getCDNPath' does not return string. See https://github.com/agoldis/webpack-require-from#troubleshooting");
/******/ 	      }
/******/ 	      return newSrc;
/******/ 	    } catch (e) {
/******/ 	      if (!false) {
/******/ 	        console.error(e);
/******/ 	      }
/******/ 	      return original_jsonpScriptSrc.apply(this, arguments);
/******/ 	    }
/******/ 	  }
/******/ 	  jsonpScriptSrc = patchJsonpScriptSrc
/******/ 	}
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var promises = [];
/******/
/******/
/******/ 		// JSONP chunk loading for javascript
/******/
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData !== 0) { // 0 means "already installed".
/******/
/******/ 			// a Promise means "currently loading".
/******/ 			if(installedChunkData) {
/******/ 				promises.push(installedChunkData[2]);
/******/ 			} else {
/******/ 				// setup Promise in chunk cache
/******/ 				var promise = new Promise(function(resolve, reject) {
/******/ 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 				});
/******/ 				promises.push(installedChunkData[2] = promise);
/******/
/******/ 				// start chunk loading
/******/ 				var script = document.createElement('script');
/******/ 				var onScriptComplete;
/******/
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.src = jsonpScriptSrc(chunkId);
/******/
/******/ 				// create error before stack unwound to get useful stacktrace later
/******/ 				var error = new Error();
/******/ 				onScriptComplete = function (event) {
/******/ 					// avoid mem leaks in IE.
/******/ 					script.onerror = script.onload = null;
/******/ 					clearTimeout(timeout);
/******/ 					var chunk = installedChunks[chunkId];
/******/ 					if(chunk !== 0) {
/******/ 						if(chunk) {
/******/ 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 							var realSrc = event && event.target && event.target.src;
/******/ 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 							error.name = 'ChunkLoadError';
/******/ 							error.type = errorType;
/******/ 							error.request = realSrc;
/******/ 							chunk[1](error);
/******/ 						}
/******/ 						installedChunks[chunkId] = undefined;
/******/ 					}
/******/ 				};
/******/ 				var timeout = setTimeout(function(){
/******/ 					onScriptComplete({ type: 'timeout', target: script });
/******/ 				}, 120000);
/******/ 				script.onerror = script.onload = onScriptComplete;
/******/ 				document.head.appendChild(script);
/******/ 			}
/******/ 		}
/******/ 		return Promise.all(promises);
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	var jsonpArray = window["webpackJsonpUtilityHeader"] = window["webpackJsonpUtilityHeader"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/extends.js":
/*!********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/extends.js ***!
  \********************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "./node_modules/@godaddy/fetch/browser.js":
/*!************************************************!*\
  !*** ./node_modules/@godaddy/fetch/browser.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

const fetch = window.fetch;
/**
 * Latest evergreen browsers define these API's globally.
 * Add the constructors to `fetch` for a consistent cross-platform experience.
 * Technically client-side only code could directly use these API's. Code that
 * is used both client and server-side will benefit from consistency.
 */

fetch.Headers = window.Headers;
fetch.Request = window.Request;
fetch.Response = window.Response;
fetch.AbortController = window.AbortController;
module.exports = fetch;

/***/ }),

/***/ "./node_modules/@px/header-cart/src/utils/constants.js":
/*!*************************************************************!*\
  !*** ./node_modules/@px/header-cart/src/utils/constants.js ***!
  \*************************************************************/
/*! exports provided: Events, PeriodUnits, MarketConstants, CurrencyConstants, StringConstants, DisplayTaxesAndFees, DomainProductTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return Events; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeriodUnits", function() { return PeriodUnits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarketConstants", function() { return MarketConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrencyConstants", function() { return CurrencyConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StringConstants", function() { return StringConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisplayTaxesAndFees", function() { return DisplayTaxesAndFees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomainProductTypes", function() { return DomainProductTypes; });
const Events = {
  ADD_ITEM: 'px.headerCart.add',
  REMOVE_ITEM: 'px.headerCart.remove',
  ENABLE: 'px.headerCart.enable',
  PROPS: 'px.headerCart.props',
  ADD_PENDING: 'px.headerCart.addPending',
  REFRESH: 'px.headerCart.refresh',
  OPEN: 'px.headerCart.open',
  CLOSE: 'px.headerCart.close'
};
const PeriodUnits = {
  MONTH: 'MONTH',
  ONE_TIME: 'ONE_TIME',
  QUARTER: 'QUARTER',
  SEMI_ANNUAL: 'SEMI_ANNUAL',
  YEAR: 'YEAR'
};
const MarketConstants = {
  COOKIE_KEY: 'market',
  DEFAULT_MARKET_KEY: 'en'
};
const CurrencyConstants = {
  COOKIE_KEY: 'currency',
  DEFAULT_CURRENCY_KEY: 'USD'
};
const StringConstants = {
  BUNDLE_OFFER: 'BUNDLE OFFER',
  WITH_DOMAIN_PRIVACY: 'Private',
  NO_DOMAIN_PRIVACY: 'Public'
};
const DisplayTaxesAndFees = {
  NONE: 0,
  ALL: 1,
  ICANN: 2,
  TAXES: 3
};
const DomainProductTypes = [2, 3, 4, 5, 19, 20, 38, 93, 378];

/***/ }),

/***/ "./node_modules/@ux/cart/src/index.js":
/*!********************************************!*\
  !*** ./node_modules/@ux/cart/src/index.js ***!
  \********************************************/
/*! exports provided: Cart, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cart", function() { return Cart; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ux_namespace_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ux/namespace-component */ "@ux/namespace-component");
/* harmony import */ var _ux_namespace_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ux_namespace_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-intl */ "react-intl");
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ux_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ux/component */ "@ux/component");
/* harmony import */ var _ux_component__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ux_component__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ux_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ux/link */ "./node_modules/@ux/link/src/index.js");
/* harmony import */ var _ux_icon_cart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @ux/icon/cart */ "./node_modules/@ux/icon/cart/index.js");
/* harmony import */ var _ux_icon_cart__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ux_icon_cart__WEBPACK_IMPORTED_MODULE_7__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







 //
// Get all predefined breakpoints for media-specific behavior. Doing a map will
// prevent us from adding more unminifable strings.
//

const breakpoints = _ux_component__WEBPACK_IMPORTED_MODULE_3___default.a.breakpoints.specification.map(point => point.name);
/**
 * Render the checkout link with optional text.
 *
 * @Constructor
 * @class Cart
 * @api public
 */

class Cart extends _ux_namespace_component__WEBPACK_IMPORTED_MODULE_1__["NamespaceConsumer"] {
  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */
  componentDidMount() {
    this.breakpoint(...breakpoints);
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */


  componentWillUnmount() {
    this.breakup();
  }
  /**
   * Render the cart icon, only show the cart if the customer has items in the cart.
   * Only show the icon (no message) if mobile.
   *
   * @returns {ReactElement} Translated cart icon and optional message.
   * @api private
   */


  render() {
    const props = this.props;
    const items = typeof this.state.items === 'number' ? this.state.items : props.items;
    const messageId = items ? 'Shared:UtilityBar:Cart:ItemsInCartMessage' : 'Shared:UtilityBar:Cart:EmptyCartMessage';
    const icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("span", {
      "aria-label": props.messages[messageId],
      className: this.namespace('cart-icon', this.classNames({
        'cart-empty': !items
      }))
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(_ux_icon_cart__WEBPACK_IMPORTED_MODULE_7___default.a, {
      width: 30,
      height: 30
    }));

    if (!props.showEmpty && !items) {
      return null;
    }

    if (props.iconOnly) {
      return icon;
    } // Show just the icon if the cart is empty or if we're in mobile


    if (props.showEmpty && !items || this.isMobile || props.hideCheckoutNow) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(_ux_link__WEBPACK_IMPORTED_MODULE_6__["default"], {
        ariaLabel: props.messages[messageId],
        urlArgs: props.urlArgs,
        href: props.checkout,
        "data-eid": props.eid,
        className: props.className
      }, icon);
    } // In non-mobile when the cart has items, show the full "Checkout Now" link


    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(react_intl__WEBPACK_IMPORTED_MODULE_2__["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(_ux_link__WEBPACK_IMPORTED_MODULE_6__["default"], {
      urlArgs: props.urlArgs,
      href: props.checkout,
      "data-eid": props.eid,
      className: props.className
    }, icon, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("span", {
      className: this.namespace('checkout-now-text')
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(react_intl__WEBPACK_IMPORTED_MODULE_2__["FormattedMessage"], {
      id: messageId
    }))));
  }

}
/**
 * Helper to update cart items, needs to be bound to proper scope that has state
 * on the number of items before the function can be used.
 *
 * @param {Number} items Updated cart count.
 * @param {Function} done Optional completion callback.
 * @api public
 */

Cart.update = function update(items, done = () => {}) {
  this.setState({
    items: parseInt(items, 10) || 0
  }, done);
};
/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */


Cart.defaultProps = {
  eid: 'uxp.hyd.app_header.header.cart.cart_link.link.click',
  market: 'en',
  items: 0,
  showEmpty: false,
  iconOnly: false
};
/**
 * Property definitions.
 *
 * @type {Object}
 * @api private
 */

Cart.propTypes = _objectSpread(_objectSpread({}, _ux_namespace_component__WEBPACK_IMPORTED_MODULE_1__["NamespaceShape"]), {}, {
  /** eid to be used link click events */
  eid: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Item count representing how many items are in the cart */
  items: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.number,

  /** If the customer is logged in */
  loggedIn: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Market needed for IntlProvider  */
  market: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Checkout url for the cart */
  checkout: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string.isRequired,

  /** Messages for IntlProvider */
  messages: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object.isRequired,

  /** Show the empty cart icon, default false */
  showEmpty: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Render the icon only, no link, default false */
  iconOnly: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool
});
/* harmony default export */ __webpack_exports__["default"] = (Object(_ux_namespace_component__WEBPACK_IMPORTED_MODULE_1__["withNamespace"])(Cart));

/***/ }),

/***/ "./node_modules/@ux/header-util/src/index.js":
/*!****************************************************************!*\
  !*** ./node_modules/@ux/header-util/src/index.js + 13 modules ***!
  \****************************************************************/
/*! exports provided: Cookies, events, data, User, Customer, Delegate, Employee, traffic2, url, shopperDataLoader */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@babel/runtime/helpers/defineProperty.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@godaddy/fetch/browser.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/eventemitter3/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/querystringify/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"} (<- Module is not an ECMAScript module) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Cookies", function() { return /* reexport */ cookies_Cookies; });
__webpack_require__.d(__webpack_exports__, "events", function() { return /* reexport */ src_events; });
__webpack_require__.d(__webpack_exports__, "data", function() { return /* reexport */ state_data; });
__webpack_require__.d(__webpack_exports__, "User", function() { return /* reexport */ user_User; });
__webpack_require__.d(__webpack_exports__, "Customer", function() { return /* reexport */ customer_Customer; });
__webpack_require__.d(__webpack_exports__, "Delegate", function() { return /* reexport */ delegate_Delegate; });
__webpack_require__.d(__webpack_exports__, "Employee", function() { return /* reexport */ employee_Employee; });
__webpack_require__.d(__webpack_exports__, "traffic2", function() { return /* reexport */ traffic2; });
__webpack_require__.d(__webpack_exports__, "url", function() { return /* reexport */ url_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "shopperDataLoader", function() { return /* reexport */ shopperDataLoader; });

// NAMESPACE OBJECT: ./node_modules/@ux/header-util/src/url.js
var url_namespaceObject = {};
__webpack_require__.r(url_namespaceObject);
__webpack_require__.d(url_namespaceObject, "updateQuery", function() { return updateQuery; });
__webpack_require__.d(url_namespaceObject, "updateCurrentHref", function() { return updateCurrentHref; });

// EXTERNAL MODULE: ./node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("./node_modules/eventemitter3/index.js");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/events.js
 //
// Singleton EventEmitter instance to track manifest events.
//

const events = new eventemitter3_default.a();
/* harmony default export */ var src_events = (events);
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/instance.js
 //
// Keep track of mounted manifest instances.
//

const instances = {};
/**
 * Setup listener for mount of React manifest instance.
 *
 * @param {String} type Expected mount of instance.
 * @returns {Function} Completion callback.
 * @api public
 */

function getInstance(type = 'header') {
  const event = "mount:".concat(type); //
  // Listen early to intercept the event before the helper is called and store the
  // instance for later calls to the helper.
  //

  src_events.once(event, instance => {
    instances[type] = instance;
  });
  return function getMountedInstance(done) {
    if (type in instances) {
      return done(null, instances[type]);
    }

    src_events.once(event, instance => {
      return done(null, instance);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("./node_modules/@babel/runtime/helpers/defineProperty.js");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"}
var util_ = __webpack_require__("@ux/util");

// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/data.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


const qs = util_["URL"].qs;
/**
 * Expose 'smart' data object.
 *
 * @class Data
 * @api public
 */

class Data {
  constructor() {
    this.set(...arguments);
  }
  /**
   * Set property and value on the object. Unpack property if passed as object.
   *
   * @param {String} property Identifier.
   * @param {Mixed} value property values.
   * @returns {Data} Fluent interface
   * @api public
   */


  set(property, value) {
    if (!property) {
      return this;
    }

    if (property === 'urlArgs') {
      return this.setUrlArgs(value);
    }

    if (typeof property === 'object') {
      return Object.keys(property).forEach(prop => {
        this.set(prop, property[prop]);
      });
    }

    this[property] = value;
    return this;
  }
  /**
   * Performs a simple shallow merge of the value into property setting any default value.
   *
   * @param {String} property Identifier.
   * @param {Object} value property values.
   * @returns {Data} Fluent interface
   * @api public
   */


  merge(property, value) {
    if (!property || !value || typeof value !== 'object') {
      return this;
    }

    this[property] = _objectSpread(_objectSpread({}, this[property] || {}), value);
    return this;
  }
  /**
   * Safely sets `urlArgs` as an Object, converting any partial or complete
   * querystrings into objects as necessary.
   *
   * @param {Object|String} value Attempted value for urlArgs.
   * @returns {Data} Fluent interface
   * @api private
   */


  setUrlArgs(value) {
    const type = typeof value;

    if (type === 'string') {
      this.urlArgs = qs.parse(value);
      return this;
    }

    if (!value || type !== 'object') {
      this.urlArgs = {};
      return this;
    }

    this.urlArgs = value;
    return this;
  }
  /**
   * Returns sealed props object with keys and values, prevents React warnings.
   *
   * @returns {Object} Values.
   * @api public
   */


  get props() {
    return Object.seal(Object.getOwnPropertyNames(this).reduce((clone, key) => {
      clone[key] = this[key];
      return clone;
    }, {}));
  }

}
// EXTERNAL MODULE: ./node_modules/@godaddy/fetch/browser.js
var browser = __webpack_require__("./node_modules/@godaddy/fetch/browser.js");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/querystringify/index.js
var querystringify = __webpack_require__("./node_modules/querystringify/index.js");
var querystringify_default = /*#__PURE__*/__webpack_require__.n(querystringify);

// EXTERNAL MODULE: external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"}
var external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_ = __webpack_require__("react-trfq");
var external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default = /*#__PURE__*/__webpack_require__.n(external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_);

// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/shopper-data.js




/**
 * Loader for shopper data from the GUI API
 *
 * Data load is triggered by the header, but this class allows for other components to subscribe to the response
 * @class ShopperDataLoader
 * @public
 */

class shopper_data_ShopperDataLoader {
  constructor() {
    this._requestTriggered = false;
    this._data = null;
  }
  /**
   * Request the shopper data from GUI and notify subscribers.
   *
   * @memberof ShopperDataLoader
   * @private
   */


  _requestShopperData() {
    if (this._requestTriggered) return;
    this._requestTriggered = true;
    const queryParams = {
      plId: this._privateLabelId,
      shopperId: this._shopperId,
      sid: this._shopperId
    };
    const url = this._url + querystringify_default.a.stringify(queryParams, true);
    browser_default()(url, {
      method: 'GET',
      credentials: 'include'
    }).then(response => {
      if (response.status >= 400) {
        const error = new Error(response.statusText);
        error.status = response.status;
        return Promise.reject(error);
      }

      return response.json();
    }).then(data => {
      this._data = data;
      src_events.emit('shopperData', null, data);
    }).catch(error => {
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent('uxp.hyd.header_util.shopper_data_loader.gui_request', 'request', {
        error: JSON.stringify(error),
        sidMeta: this._shopperId ? {
          length: this._shopperId.length
        } : this._shopperId
      });
      src_events.emit('shopperData', error);
    });
  }
  /**
   * Configure this loader
   *
   * @param {Object} opts Options for the call
   *    @param {String} opts.url URL to the GUI service
   *    @param {Number|String} [opts.privateLabelId=1] Private Label id (e.g. 1 for GoDaddy, 2 for BlueRazor, etc.)
   *    @param {Number|String} opts.shopperId Shopper id number
   * @returns {Boolean} true if configuration succeeded, false if there was missing data
   *
   * @memberof ShopperDataLoader
   * @private
   */


  _configure(opts) {
    if (!opts.url) {
      return false;
    }

    this._url = opts.url;
    this._shopperId = opts.shopperId;
    this._privateLabelId = opts.privateLabelId || 1;
    return true;
  }
  /**
   * Callback for shopper data subscriptions
   * @callback ShopperDataCallback
   * @param {Object|String} err Error, if any
   * @param {Object} data Shopper data object
   */

  /**
   * Subscribe for shopper data when it becomes available.
   *
   * Guaranteed to be async -- if data is immediately available, callback is run on next tick.
   * @param {Object} [opts] Optional options for the call -- typically only passed in from UX Platform headers
   * @param {String}        opts.url URL to the GUI service
   * @param {Number|String} opts.privateLabelId Private Label id (e.g. 1 for GoDaddy, 2 for BlueRazor, etc.)
   * @param {Number|String} opts.shopperId Shopper id number
   * @param {ShopperDataCallback} cb Callback
   *
   * @memberof ShopperDataLoader
   * @public
   */


  shopperData(opts, cb) {
    if (typeof opts === 'function') {
      cb = opts;
      opts = null;
    }

    if (this._data) {
      setTimeout(cb.bind(undefined, null, this._data), 0); // eslint-disable-line no-undefined

      return;
    }

    src_events.once('shopperData', cb);

    if (opts) {
      if (!this._configure(opts)) {
        setTimeout(cb.bind(undefined, {
          // eslint-disable-line no-undefined
          error: 'opts object is incomplete'
        }), 0);
        return;
      }

      this._requestShopperData();
    } else if (this._url && this._shopperId && this._privateLabelId) {
      // Loader is already configured, so kick off the request now
      this._requestShopperData();
    }
  }
  /**
   * Configure this loader only, but do not request data unless something else on the page needs it
   * This is only used by the UXP headers when the header itself doesn't need GUI data.
   * If the header does need data, it should call {@link shopperData}(opts, cb) instead.
   *
   * @param {Object} opts Options for the call
   *    @param {String} opts.url URL to the GUI service
   *    @param {Number|String} [opts.privateLabelId=1] Private Label id (e.g. 1 for GoDaddy, 2 for BlueRazor, etc.)
   *    @param {Number|String} opts.shopperId Shopper id number
   * @returns {Boolean} true if configuration succeeded, false if there was missing data
   *
   * @memberof ShopperDataLoader
   * @public
   */


  configureOnly(opts) {
    if (!this._configure(opts)) {
      return false;
    } // If there are queued requests, kick off the GUI call


    if (src_events.listeners('shopperData', true)) {
      this._requestShopperData();
    }

    return true;
  }

} // Export a singleton ShopperDataLoader object


const shopperDataLoader = new shopper_data_ShopperDataLoader();

// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/state.js




const state_target = typeof document !== 'undefined' ? window : {};
const state_data = new Data();
const eldorado = {};
state_target.ux = state_target.ux || {};
state_target.ux.eldorado = state_target.ux.eldorado || eldorado; //
// Allow external JS to listen to events emitted from the manifests and prepare
// data object.
//

state_target.ux.eldorado.events = eldorado.events || src_events;
state_target.ux.eldorado.data = eldorado.data || state_data; //
// Setup listeners to expose mounted instances.
//

state_target.ux.eldorado.header = getInstance('header');
state_target.ux.eldorado.footer = getInstance('footer'); // To keep backwards compatibility with Eldorado

if (typeof state_target.jQuery === 'function') {
  state_target.ux.jQuery = state_target.ux.eldorado.jQuery = state_target.jQuery;
}
/**
 * If jQuery is present on the page, run the specified callback when jQuery is ready.
 * Otherwise, run the callback synchronously
 *
 * @param {Function} cb The callback to run
 * @api private
 */


state_target.ux._runOnJQueryReady = function runOnJQueryReady(cb) {
  if (state_target.ux.jQuery) {
    state_target.ux.jQuery(document).ready(cb);
  } else {
    cb(); // eslint-disable-line callback-return
  }
}; // When the header mounts, make all subsequent calls to ux.eldorado.ready synchronous


state_target.ux.eldorado.events.once('mount:header', function uxEldoradoReadyOnMountHeader() {
  state_target.ux.eldorado.ready = function uxEldoradoReadyImmediate(cb) {
    state_target.ux._runOnJQueryReady(cb);
  };
});
/**
 * Register the specified callback to run when UXCore1 is loaded.
 *
 * Note: If UXCore1 is never loaded (e.g. if the page is using UXCore2), the callback will never run.
 *
 * @param {Function} cb The callback to run
 * @api public
 */

state_target.ux.ready = function uxReady(cb) {
  state_target.ux.fns = state_target.ux.fns || [];
  state_target.ux.fns.push(cb);
};
/**
 * Register the specified callback to run when the header is mounted.
 *
 * @param {Function} cb The callback to run
 * @api public
 */


state_target.ux.eldorado.ready = function uxEldoradoReady(cb) {
  state_target.ux.eldorado.events.once('mount:header', function () {
    state_target.ux._runOnJQueryReady(cb);
  });
}; // Transfer over all the callbacks that queued up before this script loaded


if (Array.isArray(state_target.ux.eldorado.readyFns)) {
  state_target.ux.eldorado.readyFns.forEach(function (fn) {
    state_target.ux.eldorado.ready(fn);
  });
  state_target.ux.eldorado.readyFns = null;
} // Set up shopperData API and handle pre-queued callbacks


if (!state_target.ux.eldorado._shopperDataLoader) {
  // Create a new ShopperDataLoader
  state_target.ux.eldorado._shopperDataLoader = shopperDataLoader; // Attach it to the existing `shopperData` function

  state_target.ux.eldorado.shopperData = shopperDataLoader.shopperData.bind(shopperDataLoader); // Run all pre-queued callbacks in order

  if (state_target.ux.eldorado._shopperDataFns) {
    state_target.ux.eldorado._shopperDataFns.forEach(fn => {
      state_target.ux.eldorado.shopperData(fn);
    });
  }
}


// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/helpers.js
/**
 * Scope method to data.
 *
 * @param {Object} data Dataset.
 * @returns {Function} Getter.
 * @api public
 */
function get(data = {}) {
  /**
   * Get property from data, fallback to lowercased or uppercased.
   *
   * @param {String} property Name.
   * @param {Boolean} fallback Return property name if no value was found.
   * @returns {Mixed} property value.
   * @api private
   */
  return function propGet(property, fallback) {
    const result = data[property] || data[property.toLowerCase()] || data[property.toUpperCase()];
    return !fallback ? result : result || property;
  };
}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/cookies.js


const cookies_browser = typeof document !== 'undefined';
/**
 * Collection of cookies, read out cookie info_idp on construction.
 *
 * @Constructor Cookies.
 * @param {Object} options Optional configuration.
 * @api public
 */

class cookies_Cookies {
  constructor() {
    this.idp = {};
    this.getIdpProperty = get(this.idp);
    this.updateRealm('idp');
    this.jomax = {};
    this.getJomaxProperty = get(this.jomax);
    this.updateRealm('jomax');
  }
  /**
   * Get the customers shopper id from the cookie.
   *
   * @returns {String} Shopper id.
   * @api public
   */


  get shopperId() {
    return this.getIdpProperty('info_shopperId');
  }
  /**
   * Get the encrypted shopper ID from the ShopperId<plid> cookie
   * @param {String} env Environment (e.g. prod, test, dev)
   * @param {Number} plid Private label ID
   * @returns {String|Undefined} encrypted shopper ID or undefined
   * @public
   */


  getEncryptedShopperId(env, plid) {
    const cookieEnv = env === 'prod' ? '' : env;
    return util_["cookie"].get("".concat(cookieEnv, "ShopperId").concat(plid)) || undefined; // eslint-disable-line no-undefined
  }
  /**
   * Update the cached cookies values.
   * (For backwards compatibility since this was previously marked as public)
   *
   * @returns {Cookies} fluent interface.
   * @api public
   */


  updateIdp() {
    return this.updateRealm('idp');
  }
  /**
   * Update the cached cookies values.
   *
   * @param {String} [realm='idp'] The authentication realm to update
   * @returns {Cookies} fluent interface.
   * @api private
   */


  updateRealm(realm = 'idp') {
    if (!cookies_browser) {
      return this;
    }

    const titleCaseRealm = realm[0].toUpperCase() + realm.substr(1);
    this[realm] = util_["json"].parse(util_["cookie"].get("info_".concat(realm))) || {};
    this["get".concat(titleCaseRealm, "Property")] = get(this[realm]);
    return this;
  }
  /**
   * Get the requested properties from the cookie for the specified realm.
   *
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @api public
   */


  getIdpProperties(properties, replace) {
    return cookies_Cookies.getRealmPropertiesFromObject(this.idp, properties, replace);
  }
  /**
   * Get the requested properties from the specified object
   *
   * @param {Object} obj The object to extract properties from
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @package
   */


  static getRealmPropertiesFromObject(obj, properties, replace = {}) {
    const getProp = get(replace);

    if (!Array.isArray(properties)) {
      properties = [properties];
    }

    return properties.reduce((result, property) => {
      if (Array.isArray(property)) {
        result[getProp(property[property.length - 1], true)] = property.reduce((o, i) => o && o[i], obj);
        const desiredProp = property[property.length - 1];

        if (obj[desiredProp] && !result[desiredProp]) {
          result[desiredProp] = obj[desiredProp];
        }

        return result;
      }

      result[getProp(property, true)] = obj[property];
      return result;
    }, {});
  }
  /**
   * Get the requested properties from the jomax cookie.
   *
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @api public
   */


  getJomaxProperties(properties, replace) {
    return cookies_Cookies.getRealmPropertiesFromObject(this.jomax, properties, replace);
  }

}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/user.js


function user_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function user_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { user_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { user_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




const user_status = ['partial', 'full', 'manager'];
const inverseNameOrderMarkets = ['ja-JP', 'ko-KR', 'vi-VN', 'zh-SG', 'zh-TW', 'zh-HK'];
/**
 * User details.
 *
 * @Constructor User.
 * @param {Object} options Optional configuration.
 * @api public
 */

class user_User {
  constructor(options = {}) {
    this.options = options;
    this.market = options.market || 'en-US';
    this.cookies = new cookies_Cookies();
    this.set(options.data);
  }
  /**
   * Update user data and getter.
   *
   * @param {Object} data Dataset.
   * @api private
   */


  set(data) {
    this.data = data || {};
    this.get = get(data);
  }
  /**
   * Gets all store data as an object
   *
   * @returns {Object} User data
   * @api private
   */


  getAll() {
    return this.data;
  }
  /**
   * Makes a request against a url which expects shopper information.
   *
   * @param {String} url Request target.
   * @param {Function} done Continuation to respond to when complete
   * @api private
   */


  shopperRequest(url, done) {
    shopperDataLoader.shopperData({
      url,
      privateLabelId: this.options.privateLabelId,
      shopperId: this.shopperId
    }, done);
  }
  /**
   * Fetch all user details, unpack and store locally.
   * TODO: JSONP should not be enforced for details but CORS headers are missing.
   *
   * @param {Object} url Request targets.
   * @param {Function} done Completion callback
   * @api public
   */


  fetch(url, done) {
    this.fetchInternal(url, done);
  }
  /**
   * Fetch all user details, unpack and store locally.
   * TODO: JSONP should not be enforced for details but CORS headers are missing.
   *
   * @param {Object} url Request targets.
   * @param {Function} done Completion callback
   * @param {Function} [parseAdditionalData] Optional function that parses out additional data
   * @api private
   */


  fetchInternal(url, done, parseAdditionalData = null) {
    let additionalData = {};
    this.shopperRequest(url.gui, (error, details) => {
      if (error) {
        return done(error);
      }

      if (parseAdditionalData) {
        additionalData = parseAdditionalData(details);
      }

      details = user_objectSpread(user_objectSpread({}, additionalData), details);
      this.set(details);
      done(null, details);
    });
  }
  /**
   * Return name to be displayed as customer or employee name.
   *
   * @param {Boolean} short Prefer short name.
   * @returns {String} Display name.
   * @api public
   */
  // eslint-disable-next-line complexity


  displayName(short) {
    // Content has already been generated, and we don't need to do so again.
    const name = this.get('displayName') || this.get('disp');

    if (name) {
      return name;
    }

    const firstName = this.get('firstName');
    const lastName = this.get('lastName');
    const fallback = this.get('name') || this.get('userName') || this.get('loginName') || this.shopperId || '';

    if (short) {
      const value = ~inverseNameOrderMarkets.indexOf(this.market) ? lastName : firstName;
      return value || fallback;
    }

    if (firstName) {
      // Some Asian countries are inverse the name order.
      return ~inverseNameOrderMarkets.indexOf(this.market) ? [lastName, firstName].filter(Boolean).join(' ').trim() : [firstName, lastName].filter(Boolean).join(' ').trim();
    } // Fallback to name, username or loginName


    return fallback;
  }
  /**
   * Returns purposefully short name to be used in Account Delegation.
   *
   * @returns {String} Name to use for Account Delegation (see @ux/account-delegation).
   * @api public
   */


  delegateName() {
    return this.get('displayName') || this.get('firstName');
  }
  /**
   * Return Shopper ID of customer.
   *
   * @returns {String} Shopper ID
   * @api public
   */


  get shopperId() {
    return this.get('shopperId') || this.cookies.shopperId;
  }
  /**
   * Return logged in status of user.
   *
   * @returns {Boolean} Logged in or not
   * @api public
   */


  get loggedIn() {
    return !!~user_status.indexOf(this.get('status')) || !!this.get('loginName');
  }
  /**
   * Return VIP details if available.
   *
   * @returns {Object} VIP data.
   * @api public
   */


  get vip() {
    return this.get('vip');
  }
  /**
   * Return number of items in cart.
   *
   * @returns {Number} Number of items in cart.
   * @api public
   */


  get cart() {
    return this.get('cartTotal');
  }

}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/customer.js


function customer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function customer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { customer_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { customer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



const customer_status = ['partial', 'full', 'manager'];
/**
 * Customer details
 *
 * @Constructor Customer
 * @param {Object} options Optional configuration.
 * @api public
 */

class customer_Customer extends user_User {
  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  updateFromCookie() {
    this.cookies.updateIdp();
    const auth = this.cookies.getIdpProperty('auth');
    this.set(this.getIdpProperties(this.cookies.getIdpProperties.bind(this.cookies), auth));

    if (!this.shopperId) {
      // Try getting it from the ShopperId cookie instead
      const encryptedShopperId = this.cookies.getEncryptedShopperId(this.options.env, this.options.privateLabelId);

      if (encryptedShopperId) {
        this.set(customer_objectSpread(customer_objectSpread({}, this.getAll()), {}, {
          shopperId: encryptedShopperId
        }));
      }
    }
  }
  /**
   * Get properties from idp information
   *
   * @param {Function} getIdpPropertiesFn Function to call to get properties from idp
   * @param {String} auth Type of authentication (e.g. e2s, s2s, e2s2s, none of the above)
   * @returns {Object} Extracted properties
   * @package
   */


  getIdpProperties(getIdpPropertiesFn, auth) {
    return getIdpPropertiesFn(['disp', 'firstname', 'lastname', 'info_shopperId', 'plid'].map(property => [auth, property]).concat('jti'), {
      info_shopperId: 'shopperId',
      disp: 'displayName'
    });
  }
  /**
   * Fetch all user details, unpack and store locally.
   * TODO: JSONP should not be enforced for details but CORS headers are missing.
   *
   * @param {Object} url Request targets.
   * @param {Function} done Completion callback
   * @api public
   */


  fetch(url, done) {
    this.cookies.updateIdp();
    this.fetchInternal(url, done, data => {
      let idp;

      try {
        idp = JSON.parse(data.info);
      } catch (e) {
        return {};
      }

      return this.getIdpProperties(cookies_Cookies.getRealmPropertiesFromObject.bind(this, idp), idp.auth);
    });
  }
  /**
   * Return loggedIn status of Customer.
   *
   * @returns {Boolean} LoggedIn.
   * @api public
   */


  get loggedIn() {
    const privateLabelId = this.options.privateLabelId;

    if (privateLabelId && this.data.plid && privateLabelId.toString() !== this.data.plid.toString()) {
      return false;
    }

    return !!~customer_status.indexOf(this.get('status')) || !!this.get('loginName');
  }

}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/delegate.js



/**
 * Delegate details
 *
 * @Constructor Delegate
 * @param {Object} options Optional configuration.
 * @api public
 */

class delegate_Delegate extends user_User {
  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  updateFromCookie() {
    this.cookies.updateIdp();
    const del = this.cookies.getIdpProperty('del');
    const delType = del && del.auth;

    if (delType && delType !== 'basic') {
      // In more complex impersonation scenarios such as e2s2s, we need to dig another layer deeper to get information
      // about the middle customer in a two-layer impersonation/delegation stack. So we store that Customer here and
      // then load their info directly from the parsed `del` section of the cookie.
      this.impersonatedCustomer = new customer_Customer();
      const customerInfo = this.impersonatedCustomer.getIdpProperties((properties, replace) => {
        return cookies_Cookies.getRealmPropertiesFromObject(del, properties, replace);
      }, delType);
      this.impersonatedCustomer.set(customerInfo);
    }

    this.set(this.cookies.getIdpProperties(['firstname', 'lastname', 'info_accountname', 'jti'].map(property => ['del', delType === 'basic' ? null : 'del', property].filter(Boolean)), {
      info_accountname: 'accountName'
    }));
  }

}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/employee.js

/**
 * Employee details
 *
 * @Constructor Employee
 * @param {Object} options Optional configuration.
 * @api public
 */

class employee_Employee extends user_User {
  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  updateFromCookie() {
    this.cookies.updateRealm('jomax');
    this.set(this.getJomaxProperties(this.cookies.getJomaxProperties.bind(this.cookies)));
  }
  /**
   * Get properties from jomax information
   *
   * @param {Function} getJomaxPropertiesFn Function to call to get properties from jomax
   * @returns {Object} Extracted properties
   * @api private
   */


  getJomaxProperties(getJomaxPropertiesFn) {
    return getJomaxPropertiesFn(['firstname', 'lastname', 'info_accountName', 'loggedIn'].map(property => [property]).concat('jti'), {
      info_accountName: 'loginName'
    });
  }
  /**
   * Update user details from cookie
   *
   * @param {Object} url Request targets (not used for this subclass)
   * @param {Function} done Completion callback
   * @api public
   */


  fetch(url, done) {
    this.updateFromCookie();
    done(null, this.getAll());
  }
  /**
   * Always return a null shopper ID for Employees
   *
   * @returns {Undefined} null
   * @api public
   */


  get shopperId() {
    return null;
  }

}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/traffic2.js
/* eslint no-undef: 0 */


/* harmony default export */ var traffic2 = ({
  /**
   * Initialize traffic2.
   *
   * @param {Object} opts options object
   * @param {String} [opts.type=onload] type of initialization. values `disable`, `inline`, `onload`
   * @param {Boolean} [opts.beacon=true] whether to call beacon
   *
   * @private
   */
  init: function init(opts) {
    if (opts.type === 'disable') {
      return;
    }

    if (opts.type !== 'inline') {
      this.inject();
    }

    if (opts.beacon !== false) {
      this.beacon();
    }
  },

  /**
   * If there is a "ux" global (i.e. in the browser), then configure GTM immediately
   * with some values from ux.eldorado.data.props.
   *
   * @private
   */
  inject: function inject() {
    if (typeof ux !== 'undefined' && typeof window !== 'undefined') {
      const data = ux.eldorado && ux.eldorado.data || {};
      const {
        shopperId,
        privateLabelId
      } = data.props || {};
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_["gtm"].configure({
        data: [shopperId && {
          shopperId: shopperId
        }, privateLabelId && {
          privateLabelId: privateLabelId
        }, {
          'tcc.status': 'on'
        }, {
          'tcc.gastatus': 'off'
        }].filter(Boolean)
      });
    }
  },

  /**
   * Logs a Traffic2 "beacon" event for the UX Platform team. This allows us to
   * get a gestalt for the total usage of all headers by all teams to better plan
   * new features and make prioritization features based on usage data.
   *
   * @private
   */
  beacon: function beacon() {
    if (typeof ux !== 'undefined' && typeof window !== 'undefined') {
      const url = new util_["URL"](window.location.href, true);
      const data = ux.eldorado && ux.eldorado.data || {};
      const {
        app,
        split,
        manifest,
        market,
        countryName,
        languageName,
        currency
      } = data.props || {}; // UXCore 1 pages do not load ux.versions onto the page,
      // so we use ux.version's existence as a proxy for
      // "Is this page uxcore 1"?

      const uxcore = ux.versions ? 2 : 1;

      if (manifest && app) {
        external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent("uxp.hyd.int.".concat(manifest.toLowerCase(), ".").concat(app.replace('.', '_'), ".impression").replace(/-/g, '_'), 'impression', {
          market,
          split,
          uxcore,
          currency,
          hostname: url.hostname,
          path: url.path,
          query: url.query,
          country: countryName,
          lang: languageName
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/url.js


function url_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function url_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { url_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { url_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/**
 * Add query parameters from props to the url.
 *
 * @param {String} url Logout or login link.
 * @param {Object} props Properties to merge with the query parameters object.
 * @returns {String} Configured url.
 * @api private
 */

function updateQuery(url, props) {
  url = new util_["URL"](url, true);
  return url.set('query', url_objectSpread(url_objectSpread({}, url.query), props)).href;
}
/**
 * This function takes in a currentHref
 * and will return that with no query parameters OR if a
 * currentPage query parameter is present, it will utilize
 * that value and pass it back.
 *
 * @param {String} currentHref The currentHref usually passed thru props
 * @param {Bool} isBrowser A boolean indicating whether context is a browser
 * @param {String} location A string that represents document.location or window.location
 * @returns {String} A currentHref string without query params -OR- the value of the currentPage query parameter
 */


function updateCurrentHref(currentHref, isBrowser, location) {
  //
  // Logic originally from
  // https://github.secureserver.net/UX/product-nav/blob/119ebd4ffc55e41a4bfebe1c973f55de0c3e35bc/lib/product-nav.js#L37
  //
  if (isBrowser) {
    currentHref = location;
  }

  if (currentHref) {
    const currentUrl = new util_["URL"](currentHref, true);
    const qsCurrentHref = currentUrl.query.currentPage;

    if (qsCurrentHref) {
      currentHref = qsCurrentHref;
    } else {
      // Remove query string for comparisons
      currentUrl.set('query', {});
      currentHref = currentUrl.href;
    }
  }

  return currentHref;
}


// CONCATENATED MODULE: ./node_modules/@ux/header-util/src/index.js








 //
// Add useful methods.
//



/***/ }),

/***/ "./node_modules/@ux/icon/base.js":
/*!***************************************!*\
  !*** ./node_modules/@ux/icon/base.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const React = __webpack_require__(/*! react */ "react");

const PropTypes = __webpack_require__(/*! prop-types */ "prop-types");

const SVGOSM = __webpack_require__(/*! ./svgosm.js */ "./node_modules/@ux/icon/svgosm.js"); //
// Pre-create the SVGOSM instance so it's shared between different icon
// instances that are created from the exported create function.
//


const svgosm = new SVGOSM('icon-svgosm');
/**
 * Generates our dedicated Icon component.
 *
 * @param {String} displayName Name of the Icon.
 * @returns {React.Component} The React Component.
 * @public
 */

module.exports = function create(displayName) {
  /**
   * The base component that renders the Icon.
   *
   * @constructor
   * @param {Object} props All the props
   * @param {Number} props.width Width of the icon.
   * @param {Number} props.height Height of the icon.
   * @param {String} props.title A11y title of the icon.
   * @param {String} props.desc A11y description of the icon.
   * @param {String} props.role A11y role for the icon.
   * @param {Object} props.props The rest of the props that are spread on the <use> tag.
   * @param {React.Ref} ref Forwarding reference
   * @private
   */
  const Fwd = React.forwardRef(function Icon(_ref, ref) {
    let {
      width,
      height,
      title,
      desc,
      role
    } = _ref,
        props = _objectWithoutProperties(_ref, ["width", "height", "title", "desc", "role"]);

    const res = svgosm.get(displayName, function extract() {
      const node = svgosm.node(); //
      // There would be no node available during SSR, bail out early.
      //

      if (!node) return;
      const details = svgosm.extract(node, "uxp-icon-".concat(displayName));
      if (!details) return;
      return Object.assign(details, {
        title: title,
        desc: desc
      });
    });
    if (!res) return null;
    const svg = {
      className: 'uxicon-svg-container',
      height: height || res.height,
      width: width || res.width,
      role,
      ref
    };
    return /*#__PURE__*/React.createElement("svg", svg, /*#__PURE__*/React.createElement("use", _extends({
      fill: "currentColor"
    }, props, {
      xlinkHref: res.link
    })));
  }); //
  // Ease debugging.
  //

  Fwd.displayName = displayName + 'Icon';
  /**
   * PropType validation.
   *
   * @type {Object}
   * @private
   */

  Fwd.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    desc: PropTypes.string,
    title: PropTypes.string,
    role: PropTypes.string
  };
  /**
   * Default properties.
   *
   * @type {Object}
   * @private
   */

  Fwd.defaultProps = {
    role: 'img',
    width: '1.5em',
    height: '1.5em'
  };
  return Fwd;
};

/***/ }),

/***/ "./node_modules/@ux/icon/cart/index.js":
/*!*********************************************!*\
  !*** ./node_modules/@ux/icon/cart/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('cart');

/***/ }),

/***/ "./node_modules/@ux/icon/chevron-down-lt/index.js":
/*!********************************************************!*\
  !*** ./node_modules/@ux/icon/chevron-down-lt/index.js ***!
  \********************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('chevron-down-lt');

/***/ }),

/***/ "./node_modules/@ux/icon/drop-right/index.js":
/*!***************************************************!*\
  !*** ./node_modules/@ux/icon/drop-right/index.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('drop-right');

/***/ }),

/***/ "./node_modules/@ux/icon/grid-horizontal/index.js":
/*!********************************************************!*\
  !*** ./node_modules/@ux/icon/grid-horizontal/index.js ***!
  \********************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('grid-horizontal');

/***/ }),

/***/ "./node_modules/@ux/icon/help/index.js":
/*!*********************************************!*\
  !*** ./node_modules/@ux/icon/help/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('help');

/***/ }),

/***/ "./node_modules/@ux/icon/information/index.js":
/*!****************************************************!*\
  !*** ./node_modules/@ux/icon/information/index.js ***!
  \****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('information');

/***/ }),

/***/ "./node_modules/@ux/icon/magnifying-glass/index.js":
/*!*********************************************************!*\
  !*** ./node_modules/@ux/icon/magnifying-glass/index.js ***!
  \*********************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('magnifying-glass');

/***/ }),

/***/ "./node_modules/@ux/icon/map-pin/index.js":
/*!************************************************!*\
  !*** ./node_modules/@ux/icon/map-pin/index.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('map-pin');

/***/ }),

/***/ "./node_modules/@ux/icon/phone/index.js":
/*!**********************************************!*\
  !*** ./node_modules/@ux/icon/phone/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('phone');

/***/ }),

/***/ "./node_modules/@ux/icon/svgosm.js":
/*!*****************************************!*\
  !*** ./node_modules/@ux/icon/svgosm.js ***!
  \*****************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * SVG Object Storage Manager (SVGOSM) attempts to reduce the SVG DOM footprint
 * by moving all SVG objects into symbols so they can be re-used without having
 * to inject the full SVG structure in multiple places.
 *
 * @class
 * @param {String} name Name, id of the container to inject.
 * @public
 */


class SVGOSM {
  constructor(name) {
    this.id = name; // Name of the container.

    this.svg = null; // Reference to the svg container

    this.tmp = null; // Temp element we can abuse.

    this.tracker = {}; // Storage tracker to reduce DOM lookup.

    this.container = null; // Reference to the root container.

    this.mount(name);
  }
  /**
   * Inject a new SVG element that is going to be used as storage for all
   * our new symbols so they can be referenced in our HTML.
   *
   * @param {String} name The id of the container.
   * @returns {SVGElement|Null} The container if it was created.
   * @private
   */


  mount(name) {
    if (typeof document === 'undefined') return null;
    const container = document.createElement('div');
    container.style = 'display:none';
    container.id = name;
    const svg = document.createElementNS(SVGOSM.xmlns, 'svg');
    const tmp = document.createElement('div');
    container.appendChild(tmp);
    container.appendChild(svg); //
    // We don't know WHEN this script is being executed, it could be in the
    // head or body of a page, so we need to figure out the most ideal location
    // for the svg container to be injected in.
    //

    (document.body || document.documentElement).appendChild(container);
    this.container = container;
    this.tmp = tmp;
    this.svg = svg;
  }
  /**
   * Access our tmp node
   *
   * @param {String} className The className that needs to be assigned.
   * @returns {DOMElement} The updated DOM element.
   * @public
   */


  node(className) {
    if (!this.tmp) return null;
    this.tmp.className = className;
    return this.tmp;
  }
  /**
   * Extract information out the CSS of a given HTML element and extract the svg
   * content and the size of the element.
   *
   * @param {DOMElement} node A HTML element that we want to extract from.
   * @param {String} name Name of the CSS variable we need to extract.
   * @returns {Object|Undefined} The resulting information.
   * @public
   */


  extract(node, name) {
    if (!node || !name) return;
    const cssvar = name.startsWith('--') ? name : "--".concat(name);
    const style = window.getComputedStyle(node, ':before');
    const cssvarvalue = style.getPropertyValue(cssvar);
    let content = style.getPropertyValue('content');
    let svg; //
    // BLACK MAGIC WARNING: The following blocks provide the following:
    //
    // - Provide backwards compatibility to content: url(svg)
    // - Bail out of old font based content: "\char" properties
    // - Prefer cssvariable values over old content: url() as they can
    //   be overridden for white labels.
    //
    // The big problem here is that `content` can really be anything, it can
    // be `none`, it can be `''`, even `normal` when nothing is assigned to it
    // depending on the element it receives. So we need to figure out _when_
    // to bail out.
    //
    // Browsers also handle reading out the `content` property differently,
    // literally all over the place. Some encode the content, include the quotes
    // that are wrapped around the content, others just include the actual
    // string. So, we just want to normalize this to what ever we want to
    // validate against, which is a single character.
    //

    if (content.length === 3) content = content.charAt(1);

    if (content) {
      if (content.includes('svg')) {
        svg = content;
      } else if (content.length === 1 && !/[a-z\d]/i.test(content)) {
        //
        // The contents of icon fonts would be a unicode wrapped in quotes. So
        // if it's 3 chars length (not binary size), and the 2nd character is
        // not alphabetical or a number, it must be unicde char and we should
        // proceed to **not** transform anything here.
        //
        return;
      }
    } //
    // If a CSS variable is defined it should always be used as SVG contents.
    // When we found absolutely nothing at this point, bail out.
    //


    if (cssvarvalue && cssvarvalue.includes('svg')) svg = cssvarvalue;
    if (!svg) return;
    return this.parse(svg);
  }
  /**
   * Parses the given SVG string and extracts contents.
   *
   * @param {String} str The encoded SVG string.
   * @returns {Object} Parsed SVG result.
   * @private
   */


  parse(str) {
    if (!~str.indexOf('svg')) return {};
    str = str.replace(/%23/g, '#').replace(/\\"/g, '"');
    const start = str.indexOf('>');
    const finish = str.indexOf('</svg>');
    const result = /viewBox=.*?([\d\s\.]+)/.exec(str.substr(0, start));
    if (!result) return {};
    return {
      shapes: str.slice(start + 1, finish),
      viewBox: result[1]
    };
  }
  /**
   * Returns the correct reference to the object.
   *
   * @param {String} name The name of the object we want to use.
   * @param {Function} [fn] Sets the value if there isn't any.
   * @returns {Object|Null} The value that should be used in the `xlink:href` attr.
   * @public
   */


  get(name, fn) {
    const res = this.tracker[name];
    if (res || !fn) return res;
    this.set(name, fn(name));
    return this.tracker[name];
  }
  /**
   * Store a new Symbol in our managed SVG object.
   *
   * @param {String} name Name of the symbol.
   * @param {Object} data Detailed information about the symbol.
   * @param {String} data.viewBox The viewBox of the symbol.
   * @param {String} data.title Title of the symbol.
   * @param {String} data.desc Description of the symbol.
   * @param {String} data.shapes The actual symbol that need to be stored.
   * @returns {Boolean} Indication if the shape was inserted.
   * @public
   */


  set(name, _ref = {}) {
    let {
      viewBox,
      title,
      desc,
      shapes
    } = _ref,
        data = _objectWithoutProperties(_ref, ["viewBox", "title", "desc", "shapes"]);

    if (!this.svg || !shapes) return false;
    const a11ytitle = "<title>".concat(title || name, "</title>");
    const a11ydesc = desc ? "<desc>".concat(desc, "</desc>") : '';
    const sym = "<symbol id=\"".concat(this.id, "-").concat(name, "\" viewBox=\"").concat(viewBox, "\">").concat(a11ytitle).concat(a11ydesc).concat(shapes, "</symbol>");
    this.tracker[name] = _objectSpread(_objectSpread({}, data), {}, {
      viewBox,
      link: "#".concat(this.id, "-").concat(name)
    }); //
    // REE PeRfOrMaNcE sUx fOr innerHTML: We don't care, this operation only
    // happens once per used icon, and parsing a potential DOM tree costs more
    // in terms in CPU and bundle size than any PeRfOrMaNcE hit we'll take by
    // doing innerHTML's
    //

    this.svg.innerHTML += sym;
    return true;
  }

}
/**
 * The XML namespace.
 *
 * @type {String}
 * @private
 */


SVGOSM.xmlns = 'http://www.w3.org/2000/svg'; //
// Expose the interface.
//

module.exports = SVGOSM;

/***/ }),

/***/ "./node_modules/@ux/icon/user/index.js":
/*!*********************************************!*\
  !*** ./node_modules/@ux/icon/user/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('user');

/***/ }),

/***/ "./node_modules/@ux/icon/world/index.js":
/*!**********************************************!*\
  !*** ./node_modules/@ux/icon/world/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('world');

/***/ }),

/***/ "./node_modules/@ux/icon/x/index.js":
/*!******************************************!*\
  !*** ./node_modules/@ux/icon/x/index.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('x');

/***/ }),

/***/ "./node_modules/@ux/link/src/index.js":
/*!********************************************!*\
  !*** ./node_modules/@ux/link/src/index.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Link; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/extends.js");
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_trfq__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-trfq */ "react-trfq");
/* harmony import */ var react_trfq__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_trfq__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ux_header_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ux/header-util */ "./node_modules/@ux/header-util/src/index.js");





/**
 * Regex for checking for `data-*` attributes
 * @type {RegExp}
 */

const isDataAttr = /^data-/;
/**
 * Returns a generic link component that lazily merges any `props.urlArgs`
 * with `props.href`.
 */

class Link extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  constructor() {
    super(...arguments);
    this.anchor = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createRef();
  }
  /**
   * Redirects to the merge of `props.urlArgs` and `props.href`
   * @param   {React.SyntheticEvent} e onClick event data.
   * @param   {String} loc Target location href to redirect to.
   * @returns {Boolean} false to stop navigation to `props.href`.
   */


  redirect(e, loc) {
    const props = this.props;
    e.preventDefault();
    e.stopPropagation();
    props.onClicked();
    const {
      target
    } = props;
    const eid = props['data-eid'];

    if (eid) {
      //
      // Remark (crobbins): it is ALMOST NEVER desireable to pull from global window
      // state in a React component since it breaks encapsulation. In this case, however,
      // we allow it because:
      //
      // 1. We are purposefully lazy about the existence of data.
      // 2. This will happen at most ONCE on a page since we are about to redirect away
      //    from the page itself.
      //
      const data = window.ux && window.ux.eldorado && window.ux.eldorado.data && window.ux.eldorado.data.props || {}; //
      // Remark (crobbins): it may be desireable use `cb` in `trfq.logEvent` if
      // the navigation to another page happens too quickly for the event to be logged.
      //

      const l = window.location;
      react_trfq__WEBPACK_IMPORTED_MODULE_2___default.a.logEvent(eid, 'click', {
        app: data.app,
        hostname: l.hostname,
        path: l.path,
        query: l.search,
        market: data.market,
        lang: data.languageName,
        country: data.countryName,
        currency: data.currency,
        split: data.split
      });
    }

    const destination = _ux_header_util__WEBPACK_IMPORTED_MODULE_4__["url"].updateQuery(loc, props.urlArgs);

    if (e.metaKey || e.ctrlKey) {
      window.open(destination, '_blank');
    } else if (target && target !== '_self') {
      window.open(destination, target);
    } else {
      window.location = destination;
    }

    return false;
  }
  /**
   * Focuses the `a` tag
   */


  focus() {
    this.anchor.current && this.anchor.current.focus();
  }
  /**
   * Renders the link with the appropriate click handling.
   * @returns {React.ReactElement} Denormalized `anchor` with appropriate properties
   */
  // eslint-disable-next-line complexity


  render() {
    const props = this.props;
    const {
      urlArgs
    } = props;
    let children; //
    // !! IMPORTANT !! Traffic2 (specifically tcc.combined.**.min.js)
    // will intercept ANY click on ANY element with an `href` attribute. Since we wish
    // to set our own `window.location` we must set `data-tcc-ignore` so that
    // no click listener is added by Traffic2.
    //

    const redirectTo = props.redirect || props.href;
    const hasUrlArgs = urlArgs && Object.keys(urlArgs).length;
    const shouldRedirect = props.href.indexOf('tel:') !== 0 && (props.redirect || hasUrlArgs);
    const tccIgnore = props['data-tcc-ignore'] || !!shouldRedirect;
    const dataAttrs = Object.keys(props).reduce((acc, key) => {
      if (isDataAttr.test(key)) {
        acc[key] = props[key];
      }

      return acc;
    }, {});

    if (props.children) {
      children = props.children;
    }

    dataAttrs['data-tcc-ignore'] = tccIgnore || null;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("a", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
      "aria-label": props.ariaLabel,
      id: props.id,
      href: props.href,
      rel: props.rel,
      target: props.target,
      className: props.className,
      title: props.title,
      tabIndex: props.tabIndex,
      ref: this.anchor,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onClick: props.onClick || shouldRedirect && (e => {
        this.redirect(e, redirectTo);
      }) || props.onClicked
    }, dataAttrs), children);
  }

}
Link.defaultProps = {
  onClicked: () => {}
};
/**
 * PropTypes for Link. Most map directly to HTML attributes on the `<a>`.
 * @type {Object}
 */

Link.propTypes = {
  'children': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,
  'className': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'data-eid': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'data-tcc-ignore': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
  'href': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string.isRequired,
  'id': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'redirect': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'rel': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'target': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'urlArgs': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,
  'ariaLabel': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
  'onClick': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  'onMouseEnter': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  'onMouseLeave': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  'onClicked': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
  'tabIndex': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,
  'title': prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};

/***/ }),

/***/ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/base.js":
/*!******************************************************************!*\
  !*** ./node_modules/@ux/tray-menu/node_modules/@ux/icon/base.js ***!
  \******************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const React = __webpack_require__(/*! react */ "react");

const PropTypes = __webpack_require__(/*! prop-types */ "prop-types");

const SVGOSM = __webpack_require__(/*! ./svgosm.js */ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/svgosm.js"); //
// Pre-create the SVGOSM instance so it's shared between different icon
// instances that are created from the exported create function.
//


const svgosm = new SVGOSM('icon-svgosm');
/**
 * Generates our dedicated Icon component.
 *
 * @param {String} displayName Name of the Icon.
 * @returns {React.Component} The React Component.
 * @public
 */

module.exports = function create(displayName) {
  /**
   * The base component that renders the Icon.
   *
   * @constructor
   * @param {Object} props All the props
   * @param {Number} props.width Width of the icon.
   * @param {Number} props.height Height of the icon.
   * @param {String} props.title A11y title of the icon.
   * @param {String} props.desc A11y description of the icon.
   * @param {String} props.role A11y role for the icon.
   * @param {Object} props.props The rest of the props that are spread on the <use> tag.
   * @param {React.Ref} ref Forwarding reference
   * @private
   */
  const Fwd = React.forwardRef(function Icon(_ref, ref) {
    let {
      width,
      height,
      title,
      desc,
      role
    } = _ref,
        props = _objectWithoutProperties(_ref, ["width", "height", "title", "desc", "role"]);

    const res = svgosm.get(displayName, function extract() {
      const node = svgosm.node(); //
      // There would be no node available during SSR, bail out early.
      //

      if (!node) return;
      const details = svgosm.extract(node, "uxp-icon-".concat(displayName));
      if (!details) return;
      return Object.assign(details, {
        title: title,
        desc: desc
      });
    });
    if (!res) return null;
    const svg = {
      className: 'uxicon-svg-container',
      height: height || res.height,
      width: width || res.width,
      role,
      ref
    };
    return /*#__PURE__*/React.createElement("svg", svg, /*#__PURE__*/React.createElement("use", _extends({
      fill: "currentColor"
    }, props, {
      xlinkHref: res.link
    })));
  }); //
  // Ease debugging.
  //

  Fwd.displayName = displayName + 'Icon';
  /**
   * PropType validation.
   *
   * @type {Object}
   * @private
   */

  Fwd.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    desc: PropTypes.string,
    title: PropTypes.string,
    role: PropTypes.string
  };
  /**
   * Default properties.
   *
   * @type {Object}
   * @private
   */

  Fwd.defaultProps = {
    role: 'img',
    width: '1.5em',
    height: '1.5em'
  };
  return Fwd;
};

/***/ }),

/***/ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-down-lt/index.js":
/*!***********************************************************************************!*\
  !*** ./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-down-lt/index.js ***!
  \***********************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('chevron-down-lt');

/***/ }),

/***/ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-up-lt/index.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-up-lt/index.js ***!
  \*********************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */

const create = __webpack_require__(/*! ../base.js */ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/base.js"); //
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//


module.exports = create('chevron-up-lt');

/***/ }),

/***/ "./node_modules/@ux/tray-menu/node_modules/@ux/icon/svgosm.js":
/*!********************************************************************!*\
  !*** ./node_modules/@ux/tray-menu/node_modules/@ux/icon/svgosm.js ***!
  \********************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * SVG Object Storage Manager (SVGOSM) attempts to reduce the SVG DOM footprint
 * by moving all SVG objects into symbols so they can be re-used without having
 * to inject the full SVG structure in multiple places.
 *
 * @class
 * @param {String} name Name, id of the container to inject.
 * @public
 */


class SVGOSM {
  constructor(name) {
    this.id = name; // Name of the container.

    this.svg = null; // Reference to the svg container

    this.tmp = null; // Temp element we can abuse.

    this.tracker = {}; // Storage tracker to reduce DOM lookup.

    this.container = null; // Reference to the root container.

    this.mount(name);
  }
  /**
   * Inject a new SVG element that is going to be used as storage for all
   * our new symbols so they can be referenced in our HTML.
   *
   * @param {String} name The id of the container.
   * @returns {SVGElement|Null} The container if it was created.
   * @private
   */


  mount(name) {
    if (typeof document === 'undefined') return null;
    const container = document.createElement('div');
    container.style = 'display:none';
    container.id = name;
    const svg = document.createElementNS(SVGOSM.xmlns, 'svg');
    const tmp = document.createElement('div');
    container.appendChild(tmp);
    container.appendChild(svg); //
    // We don't know WHEN this script is being executed, it could be in the
    // head or body of a page, so we need to figure out the most ideal location
    // for the svg container to be injected in.
    //

    (document.body || document.documentElement).appendChild(container);
    this.container = container;
    this.tmp = tmp;
    this.svg = svg;
  }
  /**
   * Access our tmp node
   *
   * @param {String} className The className that needs to be assigned.
   * @returns {DOMElement} The updated DOM element.
   * @public
   */


  node(className) {
    if (!this.tmp) return null;
    this.tmp.className = className;
    return this.tmp;
  }
  /**
   * Extract information out the CSS of a given HTML element and extract the svg
   * content and the size of the element.
   *
   * @param {DOMElement} node A HTML element that we want to extract from.
   * @param {String} name Name of the CSS variable we need to extract.
   * @returns {Object|Undefined} The resulting information.
   * @public
   */


  extract(node, name) {
    if (!node || !name) return;
    const cssvar = name.startsWith('--') ? name : "--".concat(name);
    const style = window.getComputedStyle(node, ':before');
    const cssvarvalue = style.getPropertyValue(cssvar);
    let content = style.getPropertyValue('content');
    let svg; //
    // BLACK MAGIC WARNING: The following blocks provide the following:
    //
    // - Provide backwards compatibility to content: url(svg)
    // - Bail out of old font based content: "\char" properties
    // - Prefer cssvariable values over old content: url() as they can
    //   be overridden for white labels.
    //
    // The big problem here is that `content` can really be anything, it can
    // be `none`, it can be `''`, even `normal` when nothing is assigned to it
    // depending on the element it receives. So we need to figure out _when_
    // to bail out.
    //
    // Browsers also handle reading out the `content` property differently,
    // literally all over the place. Some encode the content, include the quotes
    // that are wrapped around the content, others just include the actual
    // string. So, we just want to normalize this to what ever we want to
    // validate against, which is a single character.
    //

    if (content.length === 3) content = content.charAt(1);

    if (content) {
      if (content.includes('svg')) {
        svg = content;
      } else if (content.length === 1 && !/[a-z\d]/i.test(content)) {
        //
        // The contents of icon fonts would be a unicode wrapped in quotes. So
        // if it's 3 chars length (not binary size), and the 2nd character is
        // not alphabetical or a number, it must be unicde char and we should
        // proceed to **not** transform anything here.
        //
        return;
      }
    } //
    // If a CSS variable is defined it should always be used as SVG contents.
    // When we found absolutely nothing at this point, bail out.
    //


    if (cssvarvalue && cssvarvalue.includes('svg')) svg = cssvarvalue;
    if (!svg) return;
    return this.parse(svg);
  }
  /**
   * Parses the given SVG string and extracts contents.
   *
   * @param {String} str The encoded SVG string.
   * @returns {Object} Parsed SVG result.
   * @private
   */


  parse(str) {
    if (!~str.indexOf('svg')) return {};
    str = str.replace(/%23/g, '#').replace(/\\"/g, '"');
    const start = str.indexOf('>');
    const finish = str.indexOf('</svg>');
    const result = /viewBox=.*?([\d\s\.]+)/.exec(str.substr(0, start));
    if (!result) return {};
    return {
      shapes: str.slice(start + 1, finish),
      viewBox: result[1]
    };
  }
  /**
   * Returns the correct reference to the object.
   *
   * @param {String} name The name of the object we want to use.
   * @param {Function} [fn] Sets the value if there isn't any.
   * @returns {Object|Null} The value that should be used in the `xlink:href` attr.
   * @public
   */


  get(name, fn) {
    const res = this.tracker[name];
    if (res || !fn) return res;
    this.set(name, fn(name));
    return this.tracker[name];
  }
  /**
   * Store a new Symbol in our managed SVG object.
   *
   * @param {String} name Name of the symbol.
   * @param {Object} data Detailed information about the symbol.
   * @param {String} data.viewBox The viewBox of the symbol.
   * @param {String} data.title Title of the symbol.
   * @param {String} data.desc Description of the symbol.
   * @param {String} data.shapes The actual symbol that need to be stored.
   * @returns {Boolean} Indication if the shape was inserted.
   * @public
   */


  set(name, _ref = {}) {
    let {
      viewBox,
      title,
      desc,
      shapes
    } = _ref,
        data = _objectWithoutProperties(_ref, ["viewBox", "title", "desc", "shapes"]);

    if (!this.svg || !shapes) return false;
    const a11ytitle = "<title>".concat(title || name, "</title>");
    const a11ydesc = desc ? "<desc>".concat(desc, "</desc>") : '';
    const sym = "<symbol id=\"".concat(this.id, "-").concat(name, "\" viewBox=\"").concat(viewBox, "\">").concat(a11ytitle).concat(a11ydesc).concat(shapes, "</symbol>");
    this.tracker[name] = _objectSpread(_objectSpread({}, data), {}, {
      viewBox,
      link: "#".concat(this.id, "-").concat(name)
    }); //
    // REE PeRfOrMaNcE sUx fOr innerHTML: We don't care, this operation only
    // happens once per used icon, and parsing a potential DOM tree costs more
    // in terms in CPU and bundle size than any PeRfOrMaNcE hit we'll take by
    // doing innerHTML's
    //

    this.svg.innerHTML += sym;
    return true;
  }

}
/**
 * The XML namespace.
 *
 * @type {String}
 * @private
 */


SVGOSM.xmlns = 'http://www.w3.org/2000/svg'; //
// Expose the interface.
//

module.exports = SVGOSM;

/***/ }),

/***/ "./node_modules/diagnostics/browser/production.js":
/*!********************************************************!*\
  !*** ./node_modules/diagnostics/browser/production.js ***!
  \********************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var create = __webpack_require__(/*! ../diagnostics */ "./node_modules/diagnostics/diagnostics.js");
/**
 * Create a new diagnostics logger.
 *
 * @param {String} namespace The namespace it should enable.
 * @param {Object} options Additional options.
 * @returns {Function} The logger.
 * @public
 */


var diagnostics = create(function prod(namespace, options) {
  options = options || {};
  options.namespace = namespace;
  options.prod = true;
  options.dev = false;
  if (!(options.force || prod.force)) return prod.nope(options);
  return prod.yep(options);
}); //
// Expose the diagnostics logger.
//

module.exports = diagnostics;

/***/ }),

/***/ "./node_modules/diagnostics/diagnostics.js":
/*!*************************************************!*\
  !*** ./node_modules/diagnostics/diagnostics.js ***!
  \*************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/**
 * Contains all configured adapters for the given environment.
 *
 * @type {Array}
 * @public
 */
var adapters = [];
/**
 * Contains all modifier functions.
 *
 * @typs {Array}
 * @public
 */

var modifiers = [];
/**
 * Our default logger.
 *
 * @public
 */

var logger = function devnull() {};
/**
 * Register a new adapter that will used to find environments.
 *
 * @param {Function} adapter A function that will return the possible env.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */


function use(adapter) {
  if (~adapters.indexOf(adapter)) return false;
  adapters.push(adapter);
  return true;
}
/**
 * Assign a new log method.
 *
 * @param {Function} custom The log method.
 * @public
 */


function set(custom) {
  logger = custom;
}
/**
 * Check if the namespace is allowed by any of our adapters.
 *
 * @param {String} namespace The namespace that needs to be enabled
 * @returns {Boolean|Promise} Indication if the namespace is enabled by our adapters.
 * @public
 */


function enabled(namespace) {
  var async = [];

  for (var i = 0; i < adapters.length; i++) {
    if (adapters[i].async) {
      async.push(adapters[i]);
      continue;
    }

    if (adapters[i](namespace)) return true;
  }

  if (!async.length) return false; //
  // Now that we know that we Async functions, we know we run in an ES6
  // environment and can use all the API's that they offer, in this case
  // we want to return a Promise so that we can `await` in React-Native
  // for an async adapter.
  //

  return new Promise(function pinky(resolve) {
    Promise.all(async.map(function prebind(fn) {
      return fn(namespace);
    })).then(function resolved(values) {
      resolve(values.some(Boolean));
    });
  });
}
/**
 * Add a new message modifier to the debugger.
 *
 * @param {Function} fn Modification function.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */


function modify(fn) {
  if (~modifiers.indexOf(fn)) return false;
  modifiers.push(fn);
  return true;
}
/**
 * Write data to the supplied logger.
 *
 * @param {Object} meta Meta information about the log.
 * @param {Array} args Arguments for console.log.
 * @public
 */


function write() {
  logger.apply(logger, arguments);
}
/**
 * Process the message with the modifiers.
 *
 * @param {Mixed} message The message to be transformed by modifers.
 * @returns {String} Transformed message.
 * @public
 */


function process(message) {
  for (var i = 0; i < modifiers.length; i++) {
    message = modifiers[i].apply(modifiers[i], arguments);
  }

  return message;
}
/**
 * Introduce options to the logger function.
 *
 * @param {Function} fn Calback function.
 * @param {Object} options Properties to introduce on fn.
 * @returns {Function} The passed function
 * @public
 */


function introduce(fn, options) {
  var has = Object.prototype.hasOwnProperty;

  for (var key in options) {
    if (has.call(options, key)) {
      fn[key] = options[key];
    }
  }

  return fn;
}
/**
 * Nope, we're not allowed to write messages.
 *
 * @returns {Boolean} false
 * @public
 */


function nope(options) {
  options.enabled = false;
  options.modify = modify;
  options.set = set;
  options.use = use;
  return introduce(function diagnopes() {
    return false;
  }, options);
}
/**
 * Yep, we're allowed to write debug messages.
 *
 * @param {Object} options The options for the process.
 * @returns {Function} The function that does the logging.
 * @public
 */


function yep(options) {
  /**
   * The function that receives the actual debug information.
   *
   * @returns {Boolean} indication that we're logging.
   * @public
   */
  function diagnostics() {
    var args = Array.prototype.slice.call(arguments, 0);
    write.call(write, options, process(args, options));
    return true;
  }

  options.enabled = true;
  options.modify = modify;
  options.set = set;
  options.use = use;
  return introduce(diagnostics, options);
}
/**
 * Simple helper function to introduce various of helper methods to our given
 * diagnostics function.
 *
 * @param {Function} diagnostics The diagnostics function.
 * @returns {Function} diagnostics
 * @public
 */


module.exports = function create(diagnostics) {
  diagnostics.introduce = introduce;
  diagnostics.enabled = enabled;
  diagnostics.process = process;
  diagnostics.modify = modify;
  diagnostics.write = write;
  diagnostics.nope = nope;
  diagnostics.yep = yep;
  diagnostics.set = set;
  diagnostics.use = use;
  return diagnostics;
};

/***/ }),

/***/ "./node_modules/eventemitter3/index.js":
/*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */

function Events() {} //
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//


if (Object.create) {
  Events.prototype = Object.create(null); //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //

  if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */


function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */


function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once),
      evt = prefix ? prefix + event : event;
  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
  return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */


function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */


function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */


EventEmitter.prototype.eventNames = function eventNames() {
  var names = [],
      events,
      name;
  if (this._eventsCount === 0) return names;

  for (name in events = this._events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */


EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event,
      handlers = this._events[evt];
  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */


EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event,
      listeners = this._events[evt];
  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */


EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;
  if (!this._events[evt]) return false;
  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;

      case 2:
        return listeners.fn.call(listeners.context, a1), true;

      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;

      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;

      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);
          break;

        case 2:
          listeners[i].fn.call(listeners[i].context, a1);
          break;

        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);
          break;

        case 4:
          listeners[i].fn.call(listeners[i].context, a1, a2, a3);
          break;

        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }
          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;
  if (!this._events[evt]) return this;

  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
        events.push(listeners[i]);
      }
    } //
    // Reset the array, or remove it completely if we have no more listeners.
    //


    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
  }

  return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
}; //
// Alias methods names because people roll like that.
//


EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
// Expose the prefix.
//

EventEmitter.prefixed = prefix; //
// Allow `EventEmitter` to be imported as module namespace.
//

EventEmitter.EventEmitter = EventEmitter; //
// Expose the module.
//

if (true) {
  module.exports = EventEmitter;
}

/***/ }),

/***/ "./node_modules/golf-to-eid/index.js":
/*!*******************************************!*\
  !*** ./node_modules/golf-to-eid/index.js ***!
  \*******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringcase = __webpack_require__(/*! stringcase */ "./node_modules/stringcase/lib/index.js"),
    deacro = __webpack_require__(/*! pascal-deacronym */ "./node_modules/pascal-deacronym/index.js"),
    diagnostics = __webpack_require__(/*! diagnostics */ "./node_modules/diagnostics/browser/production.js");

var debug = diagnostics('golf-to-eid');
var isValidKey = /^[A-Za-z0-9\_\:-]+$/;
/**
 * Transforms the specified set of keys from one of four
 * formats:
 *
 *    camelCaseWithNoDelimiters
 *    PascalCaseWithNoDelimiters
 *    camelCase:delimitedBy:Colon
 *    Pascal:Delimited:By:Colon
 *
 * and transforms it into:
 *
 *    snake_case_no_delimiter
 *
 * @param {string|Array} keys Key (or set of keys) to transform
 * @param {Object} opts *Optional* Additional options for returned keys
 * @returns {string|Array} Transformed key (or set ofkeys).
 *
 */

module.exports = function (keys, opts) {
  var isArray = Array.isArray(keys);
  opts = opts || {};
  keys = !isArray ? [keys] : keys;
  var mapped = keys.filter(function (key) {
    return isValidKey.test(key);
  }).map(function (key) {
    //
    // Transformation is three steps:
    // 1. Obtain substring of key after the last ":"
    // 2. "deacryonym" it using
    //   pascal-deacronym. For example:
    //   - SSL becomes Ssl
    //   - GDEmail becomes GdEmail
    //   - VAT becomes Vat
    //   - ECommerce stays ECommerce
    //   - etc. etc. etc.
    // 3. Convert that part from proper PascalCase
    //    to snake_case
    //
    var rekey = key.substring(key.lastIndexOf(':') + 1);
    rekey = deacro(rekey);
    rekey = stringcase.snakecase(rekey);
    rekey = rekey.replace('-', '_'); //
    // Add our prefix and postfix components of
    // the eid.
    //

    if (opts.prefix) {
      rekey = opts.prefix + '.' + rekey;
    }

    if (opts.postfix) {
      rekey = rekey + '.' + opts.postfix;
    }

    debug('%s', key);
    debug('%s', rekey);
    return rekey;
  });
  return isArray ? mapped : mapped[0];
};

/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/***/ }),

/***/ "./node_modules/pascal-deacronym/index.js":
/*!************************************************!*\
  !*** ./node_modules/pascal-deacronym/index.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = function deacronym(anyKey) {
  return anyKey.replace(/([A-Z]+)[A-Z]/g, function (match, cap, i, str) {
    var sub;

    if (i + match.length === str.length) {
      sub = match.slice(1);
    } else {
      sub = !i ? cap.slice(1) : match.slice(1, -1);
    }

    return match.replace(sub, sub.toLowerCase());
  });
};

/***/ }),

/***/ "./node_modules/querystringify/index.js":
/*!**********************************************!*\
  !*** ./node_modules/querystringify/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */

function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */


function encode(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */


function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g,
      result = {},
      part;

  while (part = parser.exec(query)) {
    var key = decode(part[1]),
        value = decode(part[2]); //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //

    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */


function querystringify(obj, prefix) {
  prefix = prefix || '';
  var pairs = [],
      value,
      key; //
  // Optionally prefix with a '?' if needed
  //

  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key]; //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //

      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encodeURIComponent(key);
      value = encodeURIComponent(value); //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //

      if (key === null || value === null) continue;
      pairs.push(key + '=' + value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
} //
// Expose the module.
//


exports.stringify = querystringify;
exports.parse = querystring;

/***/ }),

/***/ "./node_modules/stringcase/lib/camelcase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/camelcase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into camel case.
 * @memberof module:stringcase/lib
 * @function camelcase
 * @param {string} str - String to convert.
 * @returns {string} Camel case string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");

var replacing = {
  from: /[\-_\.\s]([a-zA-Z])/g,
  to: function (a, b) {
    return uppercase(b);
  }
};
/** @lends camelcase */

function camelcase(str) {
  if (camelcase.isCamelcase(str)) {
    return str;
  }

  str = String(str).replace(/^[\-_\.]/, '');

  if (!str) {
    return str;
  }

  if (uppercase.isUppercase(str)) {
    str = lowercase(str);
  }

  return lowercase(str[0]) + str.replace(replacing.from, replacing.to).slice(1);
}
/**
 * Checks whether the string are camelcase.
 * @memberof module:stringcase/lib
 * @function camelcase.isCamelcase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are camelcase.
 */


camelcase.isCamelcase = function (str) {
  return str && /^[a-zA-Z]+$/.test(str) && lowercase(str[0]) === str[0];
};

module.exports = camelcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/capitalcase.js":
/*!****************************************************!*\
  !*** ./node_modules/stringcase/lib/capitalcase.js ***!
  \****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into capital case.
 * First letters will be uppercase.
 * @memberof module:stringcase/lib
 * @function capitalcase
 * @param {string} str - String to convert.
 * @returns {string} Capital case string.
 */


var uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");
/** @lends capitalcase */


function capitalcase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return uppercase(str[0]) + str.slice(1);
}

module.exports = capitalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/constcase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/constcase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into upper snake case.
 * Join punctuation with underscore and convert letters into uppercase.
 * @memberof module:stringcase/lib
 * @function constcase
 * @param {string} str - String to convert.
 * @returns {string} Const cased string.
 */


var uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js"),
    snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends constcase */


function constcase(str) {
  if (constcase.isConstcase(str)) {
    return str;
  }

  return uppercase(snakecase(str));
}
/**
 * Checks whether the string are constcase.
 * @memberof module:stringcase/lib
 * @function constcase.isConstcase
 * @param {string} str - String to check.
 * @returns {boolean} - True if the string are constcase.
 */


constcase.isConstcase = function (str) {
  return str && /^[A-Z_]+$/.test(str);
};

module.exports = constcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/decapitalcase.js":
/*!******************************************************!*\
  !*** ./node_modules/stringcase/lib/decapitalcase.js ***!
  \******************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into de-capitalized case.
 * First letters will be lowercase.
 * @memberof module:stringcase/lib
 * @function decapitalcase
 * @param {string} str - String to convert.
 * @returns {string} Capital case string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js");
/** @lends capitalcase */


function capitalcase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return lowercase(str[0]) + str.slice(1);
}

module.exports = capitalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/index.js":
/*!**********************************************!*\
  !*** ./node_modules/stringcase/lib/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string cases between camel case, pascal case, snake case etc...
 * @module stringcase
 */


module.exports = {
  get camelcase() {
    return __webpack_require__(/*! ./camelcase */ "./node_modules/stringcase/lib/camelcase.js");
  },

  get capitalcase() {
    return __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");
  },

  get constcase() {
    return __webpack_require__(/*! ./constcase */ "./node_modules/stringcase/lib/constcase.js");
  },

  get decapitalcase() {
    return __webpack_require__(/*! ./decapitalcase */ "./node_modules/stringcase/lib/decapitalcase.js");
  },

  get lowercase() {
    return __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js");
  },

  get pascalcase() {
    return __webpack_require__(/*! ./pascalcase */ "./node_modules/stringcase/lib/pascalcase.js");
  },

  get pathcase() {
    return __webpack_require__(/*! ./pathcase */ "./node_modules/stringcase/lib/pathcase.js");
  },

  get sentencecase() {
    return __webpack_require__(/*! ./sentencecase */ "./node_modules/stringcase/lib/sentencecase.js");
  },

  get snakecase() {
    return __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
  },

  get spacecase() {
    return __webpack_require__(/*! ./spacecase */ "./node_modules/stringcase/lib/spacecase.js");
  },

  get spinalcase() {
    return __webpack_require__(/*! ./spinalcase */ "./node_modules/stringcase/lib/spinalcase.js");
  },

  get titlecase() {
    return __webpack_require__(/*! ./titlecase */ "./node_modules/stringcase/lib/titlecase.js");
  },

  get trimcase() {
    return __webpack_require__(/*! ./trimcase */ "./node_modules/stringcase/lib/trimcase.js");
  },

  get uppercase() {
    return __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");
  }

};

/***/ }),

/***/ "./node_modules/stringcase/lib/lowercase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/lowercase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into lower case.
 * @memberof module:stringcase/lib
 * @function lowercase
 * @param {string} str - String to convert.
 * @returns {string} Lowercase case string.
 */

/** @lends lowercase */

function lowercase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return str.toLowerCase();
}
/**
 * Checks whether the string are lowercase.
 * @memberof module:stringcase/lib
 * @function lowercase.isLowercase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are lowercase.
 */


lowercase.isLowercase = function (str) {
  return str && !/[A-Z]+/.test(str);
};

module.exports = lowercase;

/***/ }),

/***/ "./node_modules/stringcase/lib/pascalcase.js":
/*!***************************************************!*\
  !*** ./node_modules/stringcase/lib/pascalcase.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into pascal case.
 * @memberof module:stringcase/lib
 * @function pascalcase
 * @param {string} str - String to convert.
 * @returns {string} Pascal case string.
 */


var camelcase = __webpack_require__(/*! ./camelcase */ "./node_modules/stringcase/lib/camelcase.js"),
    capitalcase = __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");
/** @lends pascalcase */


function pascalcase(str) {
  return capitalcase(camelcase(str));
}

module.exports = pascalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/pathcase.js":
/*!*************************************************!*\
  !*** ./node_modules/stringcase/lib/pathcase.js ***!
  \*************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into path case.
 * Join punctuation with slash.
 * @memberof module:stringcase/lib
 * @function pathcase
 * @param {string} str - String to convert.
 * @returns {string} Path cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends pathcase */


function pathcase(str) {
  return snakecase(str).replace(/_/g, '/');
}

module.exports = pathcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/sentencecase.js":
/*!*****************************************************!*\
  !*** ./node_modules/stringcase/lib/sentencecase.js ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into sentence case.
 * First letter capped and each punctuations are joined with space.
 * @memberof module:stringcase/lib
 * @function sentencecase
 * @param {string} str - String to convert.
 * @returns {string} Sentence cased string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    trimcase = __webpack_require__(/*! ./trimcase */ "./node_modules/stringcase/lib/trimcase.js"),
    snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js"),
    capitalcase = __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");

var JOINER = ' ';
/** @lends sentencecase*/

function sentencecase(str) {
  str = String(str).replace(/^[\-_\.\s]/g, JOINER);

  if (!str) {
    return str;
  }

  return capitalcase(snakecase(trimcase(str)).replace(/_/g, JOINER));
}

module.exports = sentencecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/snakecase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/snakecase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into snake case.
 * Join punctuation with underscore.
 * @memberof module:stringcase/lib
 * @function snakecase
 * @param {string} str - String to convert.
 * @returns {string} Snake cased string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");

var JOINER = '_';
var replacing = {
  from: /([A-Z])/g,
  to: function ($1) {
    return JOINER + lowercase($1);
  }
};
/** @lends snakecase */

function snakecase(str) {
  if (snakecase.isSnakecase(str)) {
    return str;
  }

  str = String(str).replace(/[\-\.\s]/g, JOINER);

  if (!str) {
    return str;
  }

  if (uppercase.isUppercase(str)) {
    str = lowercase(str);
  }

  return lowercase(str[0]) + str.slice(1).replace(replacing.from, replacing.to).replace(/_+/g, '_');
}
/**
 * Checks whether the string are snakecase.
 * @memberof module:stringcase/lib
 * @function snakecase.isSnakecase
 * @param {string} str - String to check.
 * @returns {boolean} - True if the string are snakecase.
 */


snakecase.isSnakecase = function (str) {
  return str && /^[a-z_]+$/.test(str);
};

module.exports = snakecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/spacecase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/spacecase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into path case.
 * Join punctuation with space.
 * @memberof module:stringcase/lib
 * @function spacecase
 * @param {string} str - String to convert.
 * @returns {string} Path cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends spacecase */


function spacecase(str) {
  return snakecase(str).replace(/_/g, ' ');
}

module.exports = spacecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/spinalcase.js":
/*!***************************************************!*\
  !*** ./node_modules/stringcase/lib/spinalcase.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into spinal case.
 * Join punctuation with hyphen.
 * @memberof module:stringcase/lib
 * @function spinalcase
 * @param {string} str - String to convert.
 * @returns {string} Spinal cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends spinalcase */


function spinalcase(str) {
  return snakecase(str).replace(/_/g, '-');
}

module.exports = spinalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/titlecase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/titlecase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into sentence case.
 * First letter capped and each punctuations is capitalcase and joined with space.
 * @memberof module:stringcase/lib
 * @function titlecase
 * @param {string} str - String to convert.
 * @returns {string} Title cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js"),
    lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    trimcase = __webpack_require__(/*! ./trimcase */ "./node_modules/stringcase/lib/trimcase.js"),
    capitalcase = __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");

var LOWERCASE_WORDS = 'a,the,and,or,not,but,for,of'.split(',');
/** @lends titlecase*/

function titlecase(str) {
  return snakecase(str).split(/_/g).map(trimcase).map(function (word) {
    var lower = !!~LOWERCASE_WORDS.indexOf(word);

    if (lower) {
      return lowercase(word);
    } else {
      return capitalcase(word);
    }
  }).join(' ');
}

module.exports = titlecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/trimcase.js":
/*!*************************************************!*\
  !*** ./node_modules/stringcase/lib/trimcase.js ***!
  \*************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into trimmed string.
 * @memberof module:stringcase/lib
 * @function trimcase
 * @param {string} str - String to convert.
 * @returns {string} Trimmed case string.
 */

/** @lends trimcase */

function trimcase(str) {
  return String(str).trim();
}

module.exports = trimcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/uppercase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/uppercase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into upper case.
 * @memberof module:stringcase/lib
 * @function uppercase
 * @param {string} str - String to convert.
 * @returns {string} Upper case string.
 */

/** @lends uppercase */

function uppercase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return str.toUpperCase();
}
/**
 * Checks whether the string are uppercase.
 * @memberof module:stringcase/lib
 * @function uppercase.isUppercase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are uppercase.
 */


uppercase.isUppercase = function (str) {
  return str && !/[a-z]+/.test(str);
};

module.exports = uppercase;

/***/ }),

/***/ "./src/index.js":
/*!***********************************!*\
  !*** ./src/index.js + 39 modules ***!
  \***********************************/
/*! exports provided: Header, Footer */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@babel/runtime/helpers/defineProperty.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@babel/runtime/helpers/extends.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@px/header-cart/src/utils/constants.js because of ./node_modules/@px/header-cart/src/components/HeaderCart.js */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/cart/src/index.js because of ./node_modules/@px/header-cart/src/components/CartIcon.js */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/header-util/src/index.js because of ./node_modules/@px/header-cart/src/components/CartIcon.js */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/chevron-down-lt/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/drop-right/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/grid-horizontal/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/help/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/information/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/magnifying-glass/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/map-pin/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/phone/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/user/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/world/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/icon/x/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/link/src/index.js because of ./node_modules/@px/header-cart/src/components/CartIcon.js */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-down-lt/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-up-lt/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/golf-to-eid/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/object-assign/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./src/presets.json (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Button"],"commonjs":["@ux/button","default"],"commonjs2":["@ux/button","default"],"amd":"@ux/button"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Modal"],"commonjs":["@ux/modal","default"],"commonjs2":["@ux/modal","default"],"amd":"@ux/modal"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Spinner"],"commonjs":["@ux/spinner","default"],"commonjs2":["@ux/spinner","default"],"amd":"@ux/spinner"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"} (<- Module is not an ECMAScript module) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Header", function() { return /* binding */ src_Header; });
__webpack_require__.d(__webpack_exports__, "Footer", function() { return /* binding */ src_Footer; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js
var helpers_extends = __webpack_require__("./node_modules/@babel/runtime/helpers/extends.js");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("./node_modules/@babel/runtime/helpers/defineProperty.js");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"}
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_ = __webpack_require__("prop-types");
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_);

// EXTERNAL MODULE: external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"}
var namespace_component_ = __webpack_require__("@ux/namespace-component");

// EXTERNAL MODULE: external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
var external_root_React_commonjs_react_commonjs2_react_amd_react_ = __webpack_require__("react");
var external_root_React_commonjs_react_commonjs2_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs_react_commonjs2_react_amd_react_);

// EXTERNAL MODULE: external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"}
var external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_ = __webpack_require__("react-intl");

// EXTERNAL MODULE: ./node_modules/@px/header-cart/src/utils/constants.js
var constants = __webpack_require__("./node_modules/@px/header-cart/src/utils/constants.js");

// EXTERNAL MODULE: ./node_modules/@ux/cart/src/index.js
var src = __webpack_require__("./node_modules/@ux/cart/src/index.js");

// CONCATENATED MODULE: ./node_modules/@px/header-cart/src/components/HeaderCartLoader.js





const HeaderCart = /*#__PURE__*/Object(external_root_React_commonjs_react_commonjs2_react_amd_react_["lazy"])(() => __webpack_require__.e(/*! import() | header-cart */ "vendors~header-cart").then(__webpack_require__.bind(null, /*! ./HeaderCart */ "./node_modules/@px/header-cart/src/components/HeaderCart.js")));

class HeaderCartLoader_HeaderCartLoader extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(props);
    this.enable = this.enable.bind(this);
    this.setProps = this.setProps.bind(this);
    this.state = {
      enable: false,
      checkout: props.checkout,
      checkRestrictedDomains: props.checkRestrictedDomains
    };
  }

  isHeaderCartEligible() {
    const isIE = typeof window !== 'undefined' && (
    /* @cc_on!@*/
     false || !!document.documentMode);
    return this.state.enable && !this.isMobile && !isIE;
  }

  componentDidMount() {
    document.addEventListener(constants["Events"].PROPS, this.setProps);
    document.addEventListener(constants["Events"].ENABLE, this.enable);

    if (typeof window !== 'undefined' && window.Cypress) {
      window.appReady = true;
    }
  }

  componentWillUnmount() {
    document.removeEventListener(constants["Events"].PROPS, this.setProps);
    document.removeEventListener(constants["Events"].ENABLE, this.enable);
  }

  enable() {
    this.setState({
      enable: true
    });
  }

  setProps(event) {
    if (event && event.detail && event.detail.checkoutUrl) {
      this.setState({
        checkout: event.detail.checkoutUrl
      });
    }

    if (event && event.detail && event.detail.checkRestrictedDomains) {
      this.setState({
        checkRestrictedDomains: event.detail.checkRestrictedDomains
      });
    }
  }

  render() {
    return this.isHeaderCartEligible() ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_["Suspense"], {
      fallback: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src["default"], extends_default()({}, this.props, {
        checkout: this.state.checkout
      }))
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(HeaderCart, extends_default()({}, this.props, {
      checkout: this.state.checkout,
      checkRestrictedDomains: this.state.checkRestrictedDomains
    }))) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src["default"], extends_default()({}, this.props, {
      checkout: this.state.checkout
    }));
  }

}

/* harmony default export */ var components_HeaderCartLoader = (Object(namespace_component_["withNamespace"])(HeaderCartLoader_HeaderCartLoader));
// CONCATENATED MODULE: ./node_modules/@px/header-cart/src/index.js

/* harmony default export */ var header_cart_src = (components_HeaderCartLoader);
// EXTERNAL MODULE: ./node_modules/@ux/header-util/src/index.js + 13 modules
var header_util_src = __webpack_require__("./node_modules/@ux/header-util/src/index.js");

// EXTERNAL MODULE: ./node_modules/@ux/icon/x/index.js
var x = __webpack_require__("./node_modules/@ux/icon/x/index.js");
var x_default = /*#__PURE__*/__webpack_require__.n(x);

// EXTERNAL MODULE: external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"}
var external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_ = __webpack_require__("react-dom");
var external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/modal.js
/* eslint react/no-render-return-value: 0 */



/**
 * Render a modal in the page through a temporary placeholder.
 *
 * @param {React.ReactElement} modal UXCore2 Modal.
 * @param {String} market Locale.
 * @param {Object} messages Internationalization data.
 * @param {Function} done Optional completion callback.
 * @returns {ReactDOM} Instance of internationalized modal.
 * @api public
 */

function render(modal, market, messages, done = () => {}) {
  const placeholder = document.createElement('div');
  document.body.appendChild(placeholder);
  return external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_default.a.render( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
    locale: market,
    messages: messages
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.cloneElement(modal, {
    messages
  })), placeholder, done);
}
// EXTERNAL MODULE: external {"root":["ux","Button"],"commonjs":["@ux/button","default"],"commonjs2":["@ux/button","default"],"amd":"@ux/button"}
var button_ = __webpack_require__("@ux/button");
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external {"root":["ux","Modal"],"commonjs":["@ux/modal","default"],"commonjs2":["@ux/modal","default"],"amd":"@ux/modal"}
var modal_ = __webpack_require__("@ux/modal");
var modal_default = /*#__PURE__*/__webpack_require__.n(modal_);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/clickguard.js








/**
 * ClickGuard modal.
 *
 * @class Title
 * @api private
 */

class clickguard_ClickGuard extends external_root_React_commonjs_react_commonjs2_react_amd_react_["Component"] {
  /**
   * Event handler for cancel or continue button. This will always close the modal,
   * but the original guarded action could still be performed.
   *
   * @param {Boolean} allow Should callback be called
   * @returns {Function} event handler
   * @api private
   */
  close(allow) {
    const props = this.props;
    return () => {
      this.ref.close(); //
      // Continue button was clicked, call the supplied callback.
      //

      if (allow) {
        props.callback(props.event);
      }
    };
  }
  /**
   * Modal title, fallback to default.
   *
   * @returns {React.ReactElement} title
   * @api private
   */


  get title() {
    return this.props.title || /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:deny-all-title"
    });
  }
  /**
   * Modal footer buttons.
   *
   * @returns {React.ReactElement[]} both cancel and continue button
   * @api private
   */


  get footer() {
    return [/*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      key: "cancel",
      onClick: this.close()
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:cancel"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      key: "continue",
      design: "default",
      onClick: this.close(true)
    }, this.props.caption || /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:continue"
    }))];
  }

  render() {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(modal_default.a, {
      ref: c => {
        this.ref = c;
      },
      title: this.title,
      footer: this.footer
    }, this.props.message || /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:deny-all-msg"
    }));
  }

}
/**
 * Custom clickguard modal properties.
 *
 * @enum {Object}
 * @api public
 */


clickguard_ClickGuard.propTypes = {
  message: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  caption: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  title: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  callback: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  event: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.any
};
/**
 * Setup event listener to intercept events when account delegation is active.
 *
 * @param {String} market Locale.
 * @param {Object} messages Internationalized strings.
 * @param {Object} props Additional properties required for customized modal
 * @param {Function} done Completion callback
 * @returns {Function} Event listener
 * @api private
 */

function clickguard(market, messages, props = {}, done) {
  if (typeof props === 'function') {
    done = props;
    props = {};
  }

  return function handle(event) {
    if (!account_delegation_src.active) {
      return done(event);
    }

    render( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(clickguard_ClickGuard, extends_default()({}, props, {
      market: market,
      event: event,
      callback: done
    })), market, messages);
  };
}
// EXTERNAL MODULE: external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"}
var util_ = __webpack_require__("@ux/util");

// EXTERNAL MODULE: external {"root":["ux","Spinner"],"commonjs":["@ux/spinner","default"],"commonjs2":["@ux/spinner","default"],"amd":"@ux/spinner"}
var spinner_ = __webpack_require__("@ux/spinner");
var spinner_default = /*#__PURE__*/__webpack_require__.n(spinner_);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/verify.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Check if the stored credentials still match that of the cookie.
 *
 * @param {Object} customer details.
 * @returns {Boolean} validity.
 * @api private
 */

function validCredentials(customer) {
  return account_delegation_src.idp.getIdpProperty('jti') === customer.get('jti');
}
/**
 * Verify the consistency of the current authentication credentials
 * against the cookie. This should prevent actions against wrong accounts if
 * impersonating multiple accounts.
 *
 * @param {Object} config Required configuration.
 * @returns {Boolean} true if credentials are valid, false if they are not
 * @api private
 */


function verify(config) {
  const customer = config.customer; //
  // If delegation is inactive or credentials are valid don't render modal warning.
  //

  if (!account_delegation_src.active || validCredentials(customer)) {
    return true;
  }

  return false;
}
/**
 * Issue a request to refresh the authentication cookie.
 *
 * @param {Object} config Required configuration.
 * @param {Function} done Completion callback.
 */


function refreshCookie(config, done) {
  const {
    customer
  } = config; //
  // Try to refresh the cookie to check the known jti. Ignore errors from the
  // request so the modal will also be shown in that case.
  //

  util_["request"].get("".concat(config.restoreCookie, "?jti=").concat(customer.get('jti')), {
    jsonp: config.jsonp === false ? config.jsonp : true
  }, error => {
    //
    // Credentials are still valid, notify the delegate that delegation is active.
    //
    if (!error && validCredentials(customer)) {
      return done(true);
    }

    done(false);
  });
}
/**
 * Render UXCore2 Modal if validation failed.
 *
 * @class Verify
 * @api public
 */


class verify_VerificationModal extends namespace_component_["NamespaceConsumer"] {
  render() {
    const props = this.props;
    const footer = !props.refreshFailed && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      design: "primary",
      disabled: props.pending,
      onClick: !props.pending && props.onOk
    }, props.pending ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(spinner_default.a, {
      size: "sm",
      inline: true,
      shade: "dark"
    }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:Common:OK"
    }));
    let message;

    if (!props.refreshFailed) {
      message = 'Shared:AccountDelegation:pageAuthRefreshMessage';
    } else {
      message = 'Shared:AccountDelegation:validateAuthMessage';
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(modal_default.a, {
      footer: footer,
      title: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:AccountDelegation:validateAuthTitle"
      }),
      onClose: props.onDismiss
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('verification-modal')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:validateAuthShopper",
      values: props
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: message
    })));
  }

}
/**
 * Required properties for Modal message.
 *
 * @enum {Object}
 * @api public
 */


verify_VerificationModal.propTypes = _objectSpread(_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  displayName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  pending: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  refreshFailed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  onDismiss: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  onOk: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func
});
const modalWithNamespace = Object(namespace_component_["withNamespace"])(verify_VerificationModal);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/index.js



function src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








 //
// Delegation types.
//
// Impersonate: c3 representatives
// Delegate: shopper delegation
//

const impersonate = 'impersonate';
const delegate = 'delegate';
/**
 * Render exit links on the right side of each delegation bar.
 *
 * @class ExitLink
 * @api private
 */

class src_ActualExitLink extends namespace_component_["NamespaceConsumer"] {
  /**
   * Render form to ensure a POST request to action.
   *
   * @returns {React.ReactElement} form element.
   * @api private
   */
  delegate() {
    const props = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("form", {
      method: "post",
      action: props.action
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("input", {
      type: "hidden",
      name: "secret",
      value: props.secret
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      type: "submit",
      className: this.namespace('delegate-link')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(x_default.a, null), ' '
    /* deliberate space between icon and message */
    , /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "PC:AppHeader:Header:AcctDelegationExitLabel"
    })));
  }
  /**
   * Render a simple logout link.
   *
   * @returns {React.ReactElement} anchor element.
   * @api private
   */


  impersonate() {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: this.props.action,
      className: this.namespace('delegate-link')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(x_default.a, null), ' '
    /* deliberate space between icon and message */
    , /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "PC:AppHeader:Header:AcctImpersonationExitLabel"
    }));
  }

  render() {
    return this[this.props.type]();
  }

}
/**
 * Default type and action for exit link.
 *
 * @enum {Object}
 * @api public
 */


src_ActualExitLink.defaultProps = {
  type: delegate
};
/**
 * Required ExitLink properties.
 *
 * @enum {Object}
 * @api public
 */

src_ActualExitLink.propTypes = src_objectSpread(src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  secret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  type: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  action: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
const ExitLink = Object(namespace_component_["withNamespace"])(src_ActualExitLink);
/**
 * Render delegation bar.
 *
 * @class Bar
 * @api private
 */

class src_ActualBar extends namespace_component_["NamespaceConsumer"] {
  render() {
    const props = this.props;
    const type = props.type;
    const wrapper = this.namespace(this.classNames('delegate', {
      rep: type === impersonate
    }));
    const animated = this.namespace(this.classNames('container', {
      refreshed: props.refreshed
    }));

    if (!props.active) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapper
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: animated
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('pull-left')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], props.label)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('pull-right')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(ExitLink, {
      type: type,
      action: props.action,
      secret: props.secret
    }))));
  }

}
/**
 * Require Bar properties.
 *
 * @enum {Object}
 * @api public
 */


src_ActualBar.propTypes = src_objectSpread(src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  refreshed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  active: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  label: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  type: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  secret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  action: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
const Bar = Object(namespace_component_["withNamespace"])(src_ActualBar);
let AccountDelegation; // eslint-disable-line prefer-const

/**
 * Render internationalized delegation bars.
 *
 * @class AccountDelegation
 * @api public
 */

class src_ActualAccountDelegation extends namespace_component_["NamespaceConsumer"] {
  constructor(props = {}) {
    super(...arguments); //
    // Setup delegate instance
    //

    this.delegate = new header_util_src["Delegate"]({
      data: props.delegate || {}
    }); //
    // Keep track of the delegation type.
    //

    this._type = AccountDelegation.type || impersonate;
    this.state = {
      refreshed: false,
      credentialRefreshPending: false,
      showVerificationModal: false,
      impersonatedCustomerId: null
    }; //
    // Expose the clickguard method on the constructor. This is safe since there
    // should only be one AccountDelegation Component on the page. Required
    // to get the localization data in the modal. Also ClickGuard cannot
    // be used without account delegation being active.
    //

    AccountDelegation.clickguard = clickguard.bind(clickguard, props.market, props.messages);
  }
  /**
   * Determine type of delegating from cookie. This method is made static for
   * external consumption.
   *
   * @returns {String|Array} Account delegation type.
   * @api public
   */


  static get type() {
    const auth = AccountDelegation.idp.getIdpProperty('auth');

    switch (auth) {
      case 'e2s2s':
        return [delegate, impersonate];

      case 'e2s':
        return impersonate;

      case 's2s':
        return delegate;

      case 'e2s2snpr':
        return [delegate, impersonate];

      case 'e2snpr':
        return impersonate;

      case 's2snpr':
        return delegate;

      default:
        return 'none';
    }
  }
  /**
   * Return idp cookie reference. Also attempts to fetch latest data from cookie.
   *
   * @returns {Cookie} Header utils cookies instance.
   * @api public
   */


  static get idp() {
    if (!AccountDelegation._idp) {
      AccountDelegation._idp = new header_util_src["Cookies"]();
    }

    return AccountDelegation._idp.updateIdp();
  }
  /**
   * Is delegation active?
   *
   * @returns {Boolean} Active
   * @api public
   */


  static get active() {
    return !~AccountDelegation.type.indexOf('none');
  }
  /**
   * Is the delegation of type shopper delegate.
   *
   * @returns {Boolean} shopper delegation
   * @api private
   */


  get isDelegate() {
    return !!~this._type.indexOf(delegate);
  }
  /**
   * Is the delegation of type c3 impersonation.
   *
   * @returns {Boolean} impersonation
   * @api private
   */


  get isImpersonation() {
    return !!~this._type.indexOf(impersonate);
  }
  /**
   * Label properties of delegation bar.
   *
   * @param {Boolean} [forImpersonationBar] Whether this label is for the impersonation bar
   * @returns {Object} data used by formatted message.
   * @api private
   */


  label(forImpersonationBar = false) {
    let customer, impersonator;

    if (forImpersonationBar) {
      customer = this.delegate.impersonatedCustomer || this.props.customer;
      impersonator = this.delegate;
    } else {
      // delegation bar
      customer = this.props.customer;
      impersonator = this.delegate.impersonatedCustomer || this.delegate;
    } // If we have a displayName set, use that.
    // If we have the customer's first and last name, pass those in so the i18n string handles localizing name order.
    // Otherwise, use the displayName method to handle fallbacks to fullName, username, or shopperId.


    let customerFirstName = customer.get('displayName');
    let customerLastName = '';

    if (!customerFirstName) {
      customerFirstName = customer.get('firstName');
      customerLastName = customer.get('lastName');

      if (!(customerFirstName && customerLastName)) {
        customerFirstName = customer.displayName(true);
        customerLastName = '';
      }
    }

    return {
      id: 'PC:AppHeader:Header:AcctDelegationLabel',
      values: {
        delegate: impersonator.delegateName(),
        firstName: customerFirstName,
        lastName: customerLastName
      }
    };
  }
  /**
   * Update the window title to reflect the current shopperId of the customer.
   *
   * @api private
   */


  updateTitle() {
    const {
      customer
    } = this.props;

    if (!customer || !customer.shopperId) {
      return;
    }

    let title = window.document.title;
    const i = title.indexOf(']');
    title = ~i ? title.substr(i + 2) : title;
    window.document.title = "[".concat(customer.shopperId, "] ").concat(title);
  }
  /**
  * Verify consistency of credentials when a browser tab is focused.
  *
  * @api private
  */


  onTabFocus() {
    const self = this;
    const props = self.props; // Don't reset state if the dialog is already showing

    if (this.state.showVerificationModal) return;
    const credentialsValid = verify({
      customer: props.customer
    });
    this.setState({
      showVerificationModal: !credentialsValid,
      credentialRefreshPending: false,
      credentialRefreshFailed: false
    });
  }
  /**
   * Handle click on OK button in verification modal
   *
   * @api private
   */


  onVerificationModalOkClicked() {
    const props = this.props;
    this.setState({
      credentialRefreshPending: true
    });
    refreshCookie({
      customer: props.customer,
      restoreCookie: props.restoreCookie
    }, refreshed => {
      this.setState({
        showVerificationModal: !refreshed,
        credentialRefreshPending: false,
        credentialRefreshFailed: !refreshed
      });
    });
  }
  /**
   * Get data, listen to window focus and update the title if required.
   *
   * @api private
   */


  componentDidMount() {
    this.delegate.updateFromCookie(); // If there is an intermediate customer in the delegation chain, we need to set state so we re-render the
    // impersonation bar label

    this.delegate.impersonatedCustomer && this.setState({
      impersonatedCustomerId: this.delegate.impersonatedCustomer.shopperId
    });
    this.on('focus', this.onTabFocus);

    if (this.isImpersonation) {
      this.updateTitle();
    }

    if (AccountDelegation.active && this.isBrowser) {
      document.body.classList.add('uxp-delegation');
    }
  }
  /**
   * Update title if required
   *
   * @api private
   */


  componentDidUpdate() {
    if (this.isImpersonation) {
      this.updateTitle();
    }
  }
  /**
   * Remove window focus listener.
   *
   * @api private
   */


  componentWillUnmount() {
    this.off('focus', this.onTabFocus);

    if (this.isBrowser) {
      document.body.classList.remove('uxp-delegation');
    }
  }
  /**
   * Render the delegation bar.
   *
   * @returns {React.ReactElement} Translated delegation bar.
   * @api private
   */


  render() {
    const state = this.state;
    const props = this.props;
    const wrapper = this.namespace(this.classNames('delegation', {
      db: this.isImpersonation && this.isDelegate
    })); //
    // Do not render the bar if there is no active delegation.
    //

    if (!AccountDelegation.active) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapper
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(Bar, extends_default()({}, props, {
      type: impersonate,
      refreshed: state.refreshed,
      label: this.label(true),
      active: this.isImpersonation
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(Bar, extends_default()({}, props, {
      type: delegate,
      refreshed: state.refreshed,
      label: this.label(false),
      active: this.isDelegate
    })), this.state.showVerificationModal && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(modalWithNamespace, {
      displayName: props.customer.displayName(),
      shopperId: props.customer.shopperId,
      pending: this.state.credentialRefreshPending,
      refreshFailed: this.state.credentialRefreshFailed,
      onDismiss: () => {
        this.setState({
          showVerificationModal: false
        });
      },
      onOk: this.onVerificationModalOkClicked.bind(this)
    })));
  }

}
/**
 * Default type and action for exit link.
 *
 * @enum {Object}
 * @api public
 */

src_ActualAccountDelegation.defaultProps = {
  action: 'https://sso.godaddy.com/cookie/switchback/',
  restoreCookie: 'https://sso.godaddy.com/cookie/restore/'
};
/**
 * Allowed delegation values.
 *
 * @enum {Object}
 * @api public
 */

src_ActualAccountDelegation.propTypes = src_objectSpread(src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  customer: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  delegate: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  secret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  restoreCookie: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  action: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
AccountDelegation = Object(namespace_component_["withNamespace"])(src_ActualAccountDelegation); // Need to manually copy this over since `hoist-non-react-statics` ignores this static property.

Object.defineProperty(AccountDelegation, 'type', Object.getOwnPropertyDescriptor(src_ActualAccountDelegation, 'type'));
/* harmony default export */ var account_delegation_src = (AccountDelegation);
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray.js


function tray_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Tray component.
 *
 * This is the actual tray that the dropdown menu opens up. It is where the
 * content of the dropdown is rendered.
 *
 * @class Tray
 * @public
 */

class tray_Tray extends namespace_component_["NamespaceConsumer"] {
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  render() {
    const props = this.props;
    const renderChildren = props.open || props.renderClosed;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.classNames(props.className, this.namespace('tray-dropdown', this.isBrowser && 'loaded')),
      ref: r => {
        this.wrapper = r;
      }
    }, renderChildren && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('tray-content')
    }, props.children));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_Tray.propTypes = tray_objectSpread(tray_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  renderClosed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var tray = (Object(namespace_component_["withNamespace"])(tray_Tray));
// EXTERNAL MODULE: ./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-down-lt/index.js
var chevron_down_lt = __webpack_require__("./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-down-lt/index.js");
var chevron_down_lt_default = /*#__PURE__*/__webpack_require__.n(chevron_down_lt);

// EXTERNAL MODULE: ./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-up-lt/index.js
var chevron_up_lt = __webpack_require__("./node_modules/@ux/tray-menu/node_modules/@ux/icon/chevron-up-lt/index.js");
var chevron_up_lt_default = /*#__PURE__*/__webpack_require__.n(chevron_up_lt);

// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-button.js



function tray_button_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_button_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_button_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_button_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







/**
 * Get a width for a given node
 *
 * @param {Element} element the element to measure
 * @returns {Number} the width of {element}
 * @api private
 */

function getWidth(element) {
  if (!element) {
    return 0;
  }

  const style = window.getComputedStyle(element) || {
    width: void 0
  };
  return parseFloat(style.width) || 0;
}

const breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];
/**
 * Tray button component.
 *
 * Tray buttons are the anchor for the tray menu, or what element is used to
 * toggle the menu open or closed.
 *
 * @class TrayButton
 * @public
 */

class tray_button_TrayButton extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.state = {
      trayToggleWidth: 0,
      caretMarginLeft: 0
    };
  }
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} Button.
   * @api public
   */


  render() {
    const props = this.props;
    const {
      className,
      type,
      ariaLabel,
      onClick,
      children,
      traySpanClass,
      dataAttrs
    } = props;
    let caretNode = null;

    if (props.showOpenCaret) {
      caretNode = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: this.namespace('tray-toggle-caret'),
        style: {
          marginLeft: this.state.caretMarginLeft + 'px'
        }
      });
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('tray-toggle-wrapper'),
      ref: r => {
        this.trayToggleWrapper = r;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, extends_default()({
      ariaLabel: ariaLabel,
      onClick: onClick,
      design: type,
      className: this.classNames(className, this.namespace('tray-toggle'))
    }, dataAttrs, {
      "aria-expanded": props['aria-expanded'],
      "aria-haspopup": true
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: traySpanClass
    }, children), props.isOpen ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(chevron_up_lt_default.a, {
      width: 20,
      height: 20
    }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(chevron_down_lt_default.a, {
      width: 20,
      height: 20
    })), caretNode);
  }
  /**
   * Calculate the margin for placing the caret
   *
   * @api private
   */


  componentDidMount() {
    this.breakpoint(...breakpoints);

    if (this.props.showOpenCaret) {
      this.calcCaretMargin();
    }
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */


  componentWillUnmount() {
    this.breakup();
  }
  /**
   * Calculate the margin for placing the caret
   *
   * @param {Object} previousProps the props before the component updated
   * @param {Object} previousState the state before the component updated
   * @api private
   */


  componentDidUpdate(previousProps, previousState) {
    if ((previousState.breakpoint !== this.state.breakpoint || previousState.trayToggleWidth !== this.state.trayToggleWidth) && this.props.showOpenCaret) {
      this.calcCaretMargin();
    }
  }
  /**
   * Determine left margin for the caret based on the width of the tray-button
   *
   * This causes a potential style reflow, only do this when it is needed to
   * render the button.
   *
   * @api private
   */


  calcCaretMargin() {
    const trayToggleWidth = getWidth(this.trayToggleWrapper);
    const caretMarginLeft = trayToggleWidth / 2 - 10;
    this.setState({
      trayToggleWidth,
      caretMarginLeft
    });
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_button_TrayButton.propTypes = tray_button_objectSpread(tray_button_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  'ariaLabel': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'onClick': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func.isRequired,
  'type': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'children': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node,
  'traySpanClass': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'showOpenCaret': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'dataAttrs': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'aria-expanded': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var tray_button = (Object(namespace_component_["withNamespace"])(tray_button_TrayButton));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-close.js


function tray_close_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_close_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_close_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_close_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Tray close component.
 *
 *
 * @class TrayClose
 * @public
 */

class tray_close_TrayClose extends namespace_component_["NamespaceConsumer"] {
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} close button.
   * @api public
   */
  render() {
    const props = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      className: this.namespace('close'),
      onClick: props.onClick,
      "aria-label": "close"
    });
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_close_TrayClose.propTypes = tray_close_objectSpread(tray_close_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  onClick: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func.isRequired
});
/* harmony default export */ var tray_close = (Object(namespace_component_["withNamespace"])(tray_close_TrayClose));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/node_modules/toggler/src/index.js
/**
 * Provides a default implementation to toggle a property. Many UI actions revolve
 * around toggling state.
 *
 * @param {Object} scope Scope of the method to work on.
 * @param {String} property Property that keeps the dropdown state.
 * @param {Function} callback Optional callback to use for both toggle states.
 * @returns {Function} event handler that switched state.
 * @api private
 */
function toggle(scope, property = 'dropdown', callback) {
  if (arguments.length === 2 && typeof property === 'function') {
    callback = property;
    property = 'dropdown';
  }

  return function (event, done) {
    const state = scope.state || {};
    done = done || callback;

    if (typeof done !== 'function') {
      done = null;
    }

    scope.setState({
      [property]: !state[property]
    }, done);
  };
}
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-menu.js


function tray_menu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_menu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_menu_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_menu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








const isDataAttr = /^data-[a-zA-Z0-9-]+$/;
/**
 * Tray menu component.
 *
 * This is the primary component for using the tray menu. It defines and renders
 * the button and establishes click handlers for toggling open the menu.
 *
 * @class TrayMenu
 * @public
 */

class tray_menu_TrayMenu extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    const {
      open,
      onToggle,
      trayAlignment
    } = this.props;
    this.state = tray_menu_objectSpread(tray_menu_objectSpread({}, this.state), {}, {
      open: open || false,
      alignment: trayAlignment
    });
    this.close = this.close.bind(this);
    this.toggle = toggle(this, 'open', () => {
      if (typeof onToggle === 'function') {
        onToggle(this.state.open);
      }
    });
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  /**
   * Hide the dropdown if clicks are outside the Tray itself.
   *
   * @api private
   */


  componentDidMount() {
    this.outside('click', this.close, this.wrapperDiv);
    this.on('keydown', this.handleKeyDown);
    this.outside('focusin', this.close, this.wrapperDiv);

    if (!this.props.fullwidth && !this.state.alignment) {
      const alignment = this.getAlignment();
      this.setState(tray_menu_objectSpread(tray_menu_objectSpread({}, this.state), {}, {
        alignment
      }));
    }
  }
  /**
   * Remove the attached click event listener.
   *
   * @api private
   */


  componentWillUnmount() {
    this.off('click', this.close);
    this.off('keydown', this.handleKeyDown);
    this.off('focusin', this.close);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      open
    } = this.state;
    const {
      trayAlignment
    } = this.props;

    if (trayAlignment && trayAlignment !== prevProps.trayAlignment) {
      this.setState(tray_menu_objectSpread(tray_menu_objectSpread({}, this.state), {}, {
        alignment: trayAlignment
      }));
    } else if (open && open !== prevState.open) {
      const alignment = this.getAlignment();

      if (alignment !== prevState.alignment) {
        this.setState(tray_menu_objectSpread(tray_menu_objectSpread({}, this.state), {}, {
          alignment
        }));
      }
    }
  }
  /**
   * Listen for the ESC key event.
   * @param {object} e the event object sent from the browser
   * @api private
   */


  handleKeyDown(e) {
    if (e.key && (e.key === 'Escape' || e.key === 'Esc')) {
      e.preventDefault();
      this.close();
    }
  }
  /**
   * Open the tray.
   *
   * @api public
   */


  get show() {
    if (!this.state.open) {
      this.toggle();
    } // This is a getter because it has to override `this.show` in `@ux/component` which is also a getter for some
    // reason. We can have the debate later about whether we should ship a breaking change here to rename this and make
    // it a method as it should be. But for now, let's at least make this getter return `undefined` since getters have
    // to return _something_


    return void 0;
  }
  /**
   * Close the tray.
   *
   * @api public
   */


  close() {
    if (this.state.open) {
      this.toggle();
    }
  }
  /**
    * Fetches all element bounds to necessary calculations of display
    * @private
    * @returns {object} element bounds
    */


  getElementBounds() {
    // Viewport Bounds
    const viewportBounds = {
      x: window.pageXOffset,
      y: window.pageYOffset,
      width: window.innerWidth,
      height: window.innerHeight
    }; // Wrapper Div for Tray Menu

    const wrapperDivBounds = this.wrapperDiv && this.wrapperDiv.getBoundingClientRect(); // Tray Menu Element

    const menuBounds = this.trayMenuElement && this.trayMenuElement.wrapper && this.trayMenuElement.wrapper.getBoundingClientRect();
    return {
      viewportBounds,
      wrapperDivBounds,
      menuBounds
    };
  }
  /**
   * Compute horizontal spacing for menu and determine whether to show aligned left or right to the tray menu.
   *
   * @returns {String|Boolean} The direction of alignment. False if neither left nor right.
   * @private
   */


  getAlignment() {
    let alignment = null;

    if (!this.props.fullwidth) {
      const {
        wrapperDivBounds,
        menuBounds,
        viewportBounds
      } = this.getElementBounds();

      if (wrapperDivBounds && menuBounds) {
        const right = wrapperDivBounds.left + viewportBounds.x - window.document.documentElement.clientLeft + menuBounds.width; // The element needs to be right aligned if it's too close or outside the bounds of the viewport
        // and it it small enough to fit inside a viewport, if it's too big we'll default to left

        if (viewportBounds.width - right < 10 && menuBounds.width < viewportBounds.width) {
          alignment = 'right';
        } else {
          // otherwise align left
          alignment = 'left';
        }
      }
    }

    return alignment;
  }
  /**
   * Collects `data-*` attributes from the given object and returns them in a new object
   *
   * @param  {Object} obj The object from which data attributes are collected
   * @returns {Object} Thec colleciton of data attributes
   * @api private
   */


  collectDataAttrs(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      if (isDataAttr.test(key)) {
        accumulator[key] = obj[key];
      }

      return accumulator;
    }, {});
  }
  /**
   * Render the tray menu
   *
   * @returns {React.ReactElement} react element
   * @api public
   */


  render() {
    const props = this.props;
    const dataAttrs = this.collectDataAttrs(props);
    const {
      open,
      alignment
    } = this.state;
    let alignMenuClass;

    if (!props.fullwidth) {
      alignMenuClass = alignment === 'left' ? 'tray-align-left' : 'tray-align-right';
    } // Don't namespace the incoming `props.className` -- the parent component should do so


    const wrapperClassNames = this.classNames(this.namespace(this.classNames('tray-menu', {
      open
    })), props.className);
    const trayClassNames = this.classNames(this.namespace(this.classNames(alignMenuClass, {
      'tray-fullwidth': props.fullwidth
    })));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapperClassNames,
      ref: r => {
        this.wrapperDiv = r;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_button, {
      type: props.type,
      "aria-expanded": open,
      ariaLabel: props.ariaLabel,
      showOpenCaret: props.showOpenCaret,
      onClick: evt => {
        this.toggle(evt);
      },
      dataAttrs: dataAttrs,
      traySpanClass: props.traySpanClass,
      isOpen: open
    }, props.name), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray, {
      open: open,
      renderClosed: props.renderClosed,
      className: trayClassNames,
      ref: r => {
        this.trayMenuElement = r;
      }
    }, props.showClose && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_close, {
      onClick: evt => {
        this.toggle(evt);
      }
    }), props.children));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

tray_menu_TrayMenu.propTypes = tray_menu_objectSpread(tray_menu_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  // Arbitrary data-* tags can be passed along, e.g. data-mix, data-eid, ...
  // 'data-*': PropTypes.string,
  ariaLabel: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  type: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node.isRequired,
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node.isRequired,
  showOpenCaret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  onToggle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  fullwidth: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  showClose: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  renderClosed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  traySpanClass: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  trayAlignment: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['left', 'right'])
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

tray_menu_TrayMenu.defaultProps = {
  fullwidth: true,
  showClose: true,
  type: 'base',
  showOpenCaret: false,
  renderClosed: true
};
/* harmony default export */ var tray_menu = (Object(namespace_component_["withNamespace"])(tray_menu_TrayMenu));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-title.js


function tray_title_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_title_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_title_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_title_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Tray title component.
 *
 * Tray titles are for rendering a title inside of the open tray menu.
 *
 * @class TrayTitle
 * @public
 */

class tray_title_TrayTitle extends namespace_component_["NamespaceConsumer"] {
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  render() {
    const props = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-sm-12')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('font-primary-bold', 'h3')
    }, props.children)));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_title_TrayTitle.propTypes = tray_title_objectSpread(tray_title_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node
});
/* harmony default export */ var tray_title = (Object(namespace_component_["withNamespace"])(tray_title_TrayTitle));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/index.js






/* harmony default export */ var tray_menu_src = (tray_menu);
// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/enums.js
//
// Define the breakpoints the manifest need to listen to.
//
const enums_breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large']; //
// Golf translation ids
//

const golf = {
  login: 'Shared:UtilityBar:AccountTray:SignIn',
  logout: 'Shared:AccountTray:SignOut',
  createAccount: 'Shared:UtilityBar:AccountTray:CreateAccount',
  quickLink: 'Shared:UtilityBar:QuickLinks:Heading',
  controlPanelLinksHeading: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:Heading',
  manageDomains: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageDomains',
  manageWebsiteBuilder: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageWebsiteBuilder',
  manageHosting: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageHosting',
  manageSSLCert: 'Shared:UtilityBar:QuickLinks:ControlPanelLinks:ManageSslCertificates',
  inboxLinksHeading: 'Shared:UtilityBar:QuickLinks:InboxLinks:Heading',
  o365Login: 'Shared:UtilityBar:QuickLinks:InboxLinks:O365Login',
  webmailLogin: 'Shared:UtilityBar:QuickLinks:InboxLinks:WebmailLogin',
  proDashboard: 'Shared:UtilityBar:AccountTray:ProDashboard',
  myProducts: 'Shared:UtilityBar:AccountTray:MyProducts',
  products: 'Sales:ProductNav:Products',
  accountHome: 'PC:AppHeader:Header:MyAccountHome',
  accountSettings: 'Shared:UtilityBar:AccountTray:AccountSettings',
  renewals: 'Shared:UtilityBar:AccountTray:Renewals',
  visitMyAccount: 'Shared:UtilityBar:AccountTray:VisitMyAccount',
  manageAccount: 'Shared:UtilityBar:AccountTray:ManageYourAccount',
  shopperid: 'Shared:UtilityBar:AccountTray:CustomerNumberLabel',
  pinLabel: 'Shared:AccountTray:CustomerPinLabel',
  viewPin: 'Shared:UtilityBar:AccountTray:ViewPin',
  registeredUser: 'Shared:UtilityBar:AccountTray:RegisteredUser',
  signInAccountMessage: 'Shared:UtilityBar:AccountTray:SignInAccountMessage',
  newCustomerHeading: 'Shared:UtilityBar:AccountTray:NewCustomerHeading',
  newCustomerMessage: 'Shared:UtilityBar:AccountTray:NewCustomerMessage',
  createAccountMessage: 'Shared:UtilityBar:AccountTray:CreateAccountMessage',
  vipRepName: 'Shared:UtilityBar:Vip:VipRepName',
  vipExecPhone: 'Shared:UtilityBar:Vip:VipExecPhone',
  vipExecEmail: 'Shared:UtilityBar:Vip:VipExecEmail',
  allProducts: 'Shared:ProductNav:AllProducts',
  globalDirectory: 'Shared:UtilityBar:SupportPhone:GlobalDirectory',
  globalDirectoryList: 'Shared:UtilityBar:SupportPhone:GlobalDirectory:GlobalDirectoryList',
  contactUs: 'Shared:UtilityBar:SupportPhone:ContactUs',
  showSupportNumbersText: 'Shared:UtilityBar:SupportPhone:ShowSupportNumbersText',
  help: 'Shared:UtilityBar:SupportPhone:HelpCenter:HelpCenterLink',
  helpLink: 'Shared:Help:HeaderLink',
  helpCenter: 'Sales:HelpCenter',
  guideCenter: 'Sales:GuideCenter',
  byGoDaddyGuides: 'Sales:ByGoDaddyGuides',
  noNotificationsTitle: 'Shared:UtilityBar:Notifications:NoNotificationsTitle',
  noNotificationsText: 'Shared:UtilityBar:Notifications:NoNotificationsText',
  failedNotificationsTitle: 'Shared:UtilityBar:Notifications:FailedNotificationsTitle',
  failedNotificationsText: 'Shared:UtilityBar:Notifications:FailedNotificationsText',
  failedNotificationsLink: 'Shared:UtilityBar:Notifications:FailedNotificationsLink',
  notificationsHeaderText: 'Shared:UtilityBar:Notifications:HeaderText',
  blogLink: 'Shared:UtilityBar:BlogLink',
  productPanelControl: 'Sales:ProductPanel:MenuTitle'
};
const defaultComponents = {
  accountDelegation: true,
  backLink: false,
  marketSelector: true,
  contactTray: true,
  help: true,
  notifications: true,
  accountTray: true,
  cart: true,
  blog: true,
  logo: true,
  utilitySeparator: true,
  domainSearch: false,
  productPanel: false
};

// EXTERNAL MODULE: ./node_modules/golf-to-eid/index.js
var golf_to_eid = __webpack_require__("./node_modules/golf-to-eid/index.js");
var golf_to_eid_default = /*#__PURE__*/__webpack_require__.n(golf_to_eid);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("./node_modules/object-assign/index.js");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/eid.js


function eid_eid(opts = {}) {
  opts = object_assign_default()({}, opts, {
    prefix: 'uxp.hyd.utility_bar',
    postfix: 'link.click'
  });
  let key = opts.key;

  if (opts.manifest) {
    key = key.replace(/shared/i, opts.manifest);
  }

  return golf_to_eid_default()(key, opts);
}
// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/account-tray/vip.js


function vip_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function vip_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { vip_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { vip_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* jscs:disable requireSpacesInsideJsxExpressionContainers */





/**
 * Render VIP information after login if required.
 *
 * @Constructor
 * @class VIP
 * @api public
 */

class vip_VIP extends namespace_component_["NamespaceConsumer"] {
  render() {
    const props = this.props;
    const vip = props.details;

    if (typeof vip !== 'object') {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('list-unstyled', 'vip-status')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.vipRepName
    }), ":"), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, vip.repname)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.vipExecPhone
    }), ": ", /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: "tel:".concat(vip.phone)
    }, vip.phone)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.vipExecEmail
    }), ": ", /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: "mailto:".concat(vip.email)
    }, vip.email))));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @api private
 */


vip_VIP.propTypes = vip_objectSpread(vip_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  details: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired
});
/* harmony default export */ var account_tray_vip = (Object(namespace_component_["withNamespace"])(vip_VIP));
// EXTERNAL MODULE: ./node_modules/@ux/link/src/index.js
var link_src = __webpack_require__("./node_modules/@ux/link/src/index.js");

// EXTERNAL MODULE: ./node_modules/@ux/icon/drop-right/index.js
var drop_right = __webpack_require__("./node_modules/@ux/icon/drop-right/index.js");
var drop_right_default = /*#__PURE__*/__webpack_require__.n(drop_right);

// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/account-tray/user-details.js



function user_details_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function user_details_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { user_details_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { user_details_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* jscs:disable requireSpacesInsideJsxExpressionContainers */










/**
 * Render UserDetails in account tray after login.
 *
 * @Constructor
 * @class UserDetails
 * @api public
 */

class user_details_UserDetails extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(...arguments);
    this.eids = {
      proDashboard: eid_eid({
        key: golf.proDashboard,
        manifest: props.manifest
      }),
      visitMyAccount: eid_eid({
        key: golf.visitMyAccount,
        manifest: props.manifest
      }),
      manageAccount: eid_eid({
        key: golf.manageAccount,
        manifest: props.manifest
      }),
      accountSettings: eid_eid({
        key: golf.accountSettings,
        manifest: props.manifest
      }),
      viewPin: eid_eid({
        key: golf.viewPin,
        manifest: props.manifest
      }),
      products: eid_eid({
        key: golf.myProducts,
        manifest: props.manifest
      }),
      renewals: eid_eid({
        key: golf.renewals,
        manifest: props.manifest
      }),
      logout: eid_eid({
        key: golf.logout,
        manifest: props.manifest
      }),
      accountHome: eid_eid({
        key: golf.accountHome,
        manifest: props.manifest
      })
    };
  }
  /**
  * Show link for pro dashboard only added if a user is pro
  *
  * @returns {React.Component} Component
  * @api private
  */


  renderPro() {
    const props = this.props;
    const eids = this.eids;

    if (props.loggedIn && props.isPro) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
        urlArgs: props.urlArgs
      }, props.urls.pro, {
        "data-eid": eids.proDashboard
      }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: golf.proDashboard
      })));
    }

    return null;
  }
  /**
   * Render link to Account Home (i.e. Go overview) if the user is in the Go cohort
   *
   * @returns {React.Component} Component for the link
   * @private
   */


  renderMyAccountHome() {
    const {
      props,
      eids
    } = this;

    if (props.loggedIn && props.isInGoCohort && props.privateLabelId === 1) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
        urlArgs: props.urlArgs
      }, props.urls.accountHome, {
        "data-eid": eids.accountHome
      }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: golf.accountHome
      })));
    }

    return null;
  }

  render() {
    const props = this.props;
    const eids = this.eids;

    if (!props.loggedIn) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('account-info', 'collapse', 'in')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.products, {
      "data-eid": eids.manageAccount,
      className: "".concat(this.namespace('font-primary-bold', 'name'), " ctHidden")
    }), props.name)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('customer-number')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.shopperid
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: "".concat(this.namespace('shopper-id'), " ctHidden")
    }, props.shopperId, "\xA0|\xA0"), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.pinLabel
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.viewPin, {
      "data-eid": eids.viewPin,
      className: "".concat(this.namespace('customer-pin'), " ctHidden")
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.viewPin
    }))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(account_tray_vip, {
      details: props.vip,
      market: props.market,
      messages: props.messages
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('list-unstyled', 'quick-links')
    }, this.renderPro(), this.renderMyAccountHome(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.products, {
      "data-eid": eids.products
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('drop-right')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(drop_right_default.a, null)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.myProducts
    }))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.account, {
      "data-eid": eids.accountSettings
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('drop-right')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(drop_right_default.a, null)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.accountSettings
    }))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.renewals, {
      "data-eid": eids.renewals
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('drop-right')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(drop_right_default.a, null)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.renewals
    })))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.products, {
      "data-eid": eids.visitMyAccount,
      className: this.namespace('btn', 'btn-purchase')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.visitMyAccount
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.sso.logout, {
      "data-eid": eids.logout,
      className: this.namespace('logout-link')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.logout
    }))));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */


user_details_UserDetails.propTypes = user_details_objectSpread(user_details_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  isPro: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  isInGoCohort: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  vip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number
});
/* harmony default export */ var user_details = (Object(namespace_component_["withNamespace"])(user_details_UserDetails));
// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/account-tray/sign-in.js



function sign_in_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function sign_in_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { sign_in_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { sign_in_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* jscs:disable requireSpacesInsideJsxExpressionContainers */








/**
 * Render signIn section.
 *
 * @Constructor
 * @class SignIn
 * @api public
 */

class sign_in_SignIn extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(...arguments);
    this.eids = {
      login: eid_eid({
        key: golf.login,
        manifest: props.manifest
      })
    };
  }

  render() {
    const props = this.props;
    const eids = this.eids;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-xl-7', 'push-xl-5', 'col-lg-6', 'push-lg-6', 'col-md-6', 'sign-in', 'divider')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.registeredUser
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.signInAccountMessage
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.sso.login, {
      "data-eid": eids.login,
      className: this.namespace('btn', 'btn-sm', 'btn-filled', 'btn-purchase')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.login
    }))));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */


sign_in_SignIn.propTypes = sign_in_objectSpread(sign_in_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired
});
/* harmony default export */ var sign_in = (Object(namespace_component_["withNamespace"])(sign_in_SignIn));
// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/account-tray/create-account.js



function create_account_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function create_account_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { create_account_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { create_account_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* jscs:disable requireSpacesInsideJsxExpressionContainers */








/**
 * Render CreateMyAccount section.
 *
 * @Constructor
 * @class CreateMyAccount
 * @api public
 */

class create_account_CreateMyAccount extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(...arguments);
    this.eids = {
      createAccount: eid_eid({
        key: golf.createAccount,
        manifest: props.manifest
      })
    };
  }

  render() {
    const props = this.props;
    const eids = this.eids;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-xl-5', 'pull-xl-7', 'col-lg-6', 'pull-lg-6', 'col-md-6', 'sign-up', 'divider')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.newCustomerHeading
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.newCustomerMessage,
      values: {
        privateLabelName: props.privateLabelName
      }
    }), " ", /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.createAccountMessage
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      className: this.namespace('btn', 'btn-sm', 'btn-default-purchase'),
      urlArgs: props.urlArgs
    }, props.urls.sso.createAccount, {
      "data-eid": eids.createAccount
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.createAccount
    }))));
  }

}
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */


create_account_CreateMyAccount.propType = create_account_objectSpread(create_account_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired
});
/* harmony default export */ var create_account = (Object(namespace_component_["withNamespace"])(create_account_CreateMyAccount));
// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/account-tray/quick-links.js


function quick_links_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function quick_links_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { quick_links_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { quick_links_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* jscs:disable requireSpacesInsideJsxExpressionContainers */








/**
 * Render Quick Links section.
 *
 * @Constructor
 * @class QuickLinks
 * @api public
 */

class quick_links_QuickLinks extends namespace_component_["NamespaceConsumer"] {
  /**
    * Build the items in a list
    *
    * @param {LinkItem[]} items An array of objects containing the details of a list item
    * @returns {React.ReactElement[]} An array of list items containing a link
    * @api private
    */
  listItemBuilder(items) {
    return items.map(item => {
      const captionOrId = item.caption || item.id;
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: captionOrId
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
        urlArgs: this.props.urlArgs,
        href: item.href,
        "data-eid": eid_eid({
          key: captionOrId,
          manifest: this.props.manifest
        })
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: this.namespace('drop-right')
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(drop_right_default.a, null)), item.caption ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: item.caption
      }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, item.title)));
    });
  }
  /**
  * @typedef {Object} LinkItem
  * @prop {LinkItem[]} [children] Array of objects that hold individual list items (caption, href)
  * @prop {String} [caption] Golf string
  * @prop {String} [title] Pre-translated text -- either caption or title must be set
  * @prop {String} [id] Identifier for item -- either caption or ID must be set
  * @prop {String} [href] Optional URL to link to
  */

  /**
  * Build a list
  *
  * @param {LinkItem[]} items An object containing the details for lists to build
  * @returns {Array} An array of lists
  * @api private
  */


  listBuilder(items) {
    if (!items) {
      return;
    } // https://github.secureserver.net/UX/eldorado/blob/master/application/includes/all-products-menu.jade#L14-L19


    const colCount = items.length;
    let colClassNum = 2;

    if (colCount === 5) {
      colClassNum = 15;
    } else if (colCount === 6 || colCount <= 4) {
      colClassNum = Math.floor(12 / colCount);
    }

    return items.map(item => {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        key: item.caption || item.id,
        className: this.namespace("col-md-".concat(colClassNum))
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
        className: this.namespace('list-unstyled')
      }, (item.caption || item.title) && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, item.caption ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: item.caption
      }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, item.title))), this.listItemBuilder(item.children)));
    });
  }

  render() {
    const props = this.props;
    const utilityBarNavs = props.utilityBarNav || [];
    let quickLinks = {};

    for (let i = 0; i < utilityBarNavs.length; i++) {
      const nav = utilityBarNavs[i];
      const captionOrId = nav.caption || nav.id;

      if (captionOrId && ~captionOrId.indexOf('QuickLinks')) {
        quickLinks = nav;
        break;
      }
    }

    if (!quickLinks.caption && !quickLinks.title || !quickLinks.children) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-xl-5', 'pull-xl-7', 'col-lg-6', 'pull-lg-6', 'inbox-links')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, quickLinks.caption ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: quickLinks.caption
    }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, quickLinks.title)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row', 'quick-links')
    }, this.listBuilder(quickLinks.children))));
  }

}
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */


quick_links_QuickLinks.propType = quick_links_objectSpread(quick_links_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  utilityBarNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object)
});
/* harmony default export */ var quick_links = (Object(namespace_component_["withNamespace"])(quick_links_QuickLinks));
// EXTERNAL MODULE: ./node_modules/@ux/icon/user/index.js
var user = __webpack_require__("./node_modules/@ux/icon/user/index.js");
var user_default = /*#__PURE__*/__webpack_require__.n(user);

// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/account-tray/account-tray.js


function account_tray_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function account_tray_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { account_tray_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { account_tray_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* jscs:disable requireSpacesInsideJsxExpressionContainers */











/**
 * Render and expose the AccountTray as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced AccountTray.
 * @api public
 */

class account_tray_AccountTray extends namespace_component_["NamespaceConsumer"] {
  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */
  componentDidMount() {
    this.breakpoint(...enums_breakpoints);
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */


  componentWillUnmount() {
    this.breakup();
  }

  render() {
    const props = this.props;
    let name;

    if (!this.isMobile) {
      if (props.loggedIn) {
        // props.displayName is the short name (e.g. "Jane").
        name = props.displayName;
      } else {
        name = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
          id: golf.login
        });
      }
    }

    const trayName = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('account-tray-name')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('user-icon')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(user_default.a, {
      width: 28,
      height: 28
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('title-text')
    }, name));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_menu, {
      type: "base",
      className: this.namespace(this.classNames('account-tray', {
        'is-pro': props.loggedIn && props.isPro
      })),
      name: trayName,
      "data-eid": "uxp.hyd.shared.utility_bar.account_tray.click"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(props.oldBrand ? 'container' : 'container-fluid')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-xl-7', 'push-xl-5', 'col-lg-6', 'push-lg-6', 'mb-5')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(user_details, props), !props.loggedIn && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(sign_in, props), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(create_account, props))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(quick_links, props)))));
  }

}
/**
 * Default properties for account tray.
 *
 * @type {Object}
 * @api public
 */


account_tray_AccountTray.defaultProps = {
  urls: {
    products: 'https://mya.godaddy.com',
    renewals: 'https://account.godaddy.com/billing?filter=expires&subFilter=90',
    account: 'https://account.godaddy.com',
    pro: 'https://pro.godaddy.com',
    manageDomains: 'https://dcc.godaddy.com',
    manageHosting: 'https://gateway.godaddy.com',
    sso: {
      o365Login: 'https://sso.godaddy.com',
      webmailLogin: 'https://email.godaddy.com',
      login: 'https://sso.godaddy.com?realm=idp&app=mya&path=',
      logout: 'https://sso.godaddy.com/logout?realm=idp',
      createAccount: 'https://sso.godaddy.com/account/create?realm=idp&app=www&path='
    }
  },
  market: 'en-US',
  loggedIn: false,
  isPro: false,
  privateLabelId: 1
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

account_tray_AccountTray.propTypes = account_tray_objectSpread(account_tray_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  displayName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  isPro: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  vip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object
});
/* harmony default export */ var account_tray = (Object(namespace_component_["withNamespace"])(account_tray_AccountTray));
// CONCATENATED MODULE: ./node_modules/@ux/column-layout/src/columns.js


function columns_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function columns_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { columns_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { columns_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Columns component.
 *
 * This is the container for the columns, or in terms of HTML, it is the
 * wrapping `<ul>` element. You specify a list of `ColumnItem` components as
 * the children, and it will flow them into the correct columns based on the
 * props passed in.
 *
 * @class Columns
 * @public
 */

class columns_Columns extends namespace_component_["NamespaceConsumer"] {
  /**
   * Create the columns in a horizontal direction for the supplied items.
   *
   * @param {Array} items items to render into columns
   * @param {Number} num the number of columns to make
   * @returns {Array} columns
   * @api private
   */
  horizontal(items, num) {
    const columns = [];
    let i;

    for (i = 0; i < num; i++) {
      columns[i] = [];
    }

    for (i = 0; i < items.length; i++) {
      columns[i % num].push(items[i]);
    }

    return columns;
  }
  /**
   * Create the columns in a vertical direction for the supplied items.
   *
   * @param {Array} items items to render into columns
   * @param {Number} num the number of columns to make
   * @returns {Array} columns
   * @api private
   */


  vertical(items, num) {
    const itemsPerColumn = Math.ceil(items.length / num);
    const columns = [];
    let i;

    for (i = 0; i < num; i++) {
      const start = i * itemsPerColumn;
      const end = start + itemsPerColumn;
      columns[i] = items.slice(start, end);
    }

    return columns;
  }
  /**
   * Render the component.
   *
   * @returns {ReactElement} div
   * @api public
   */


  render() {
    const props = this.props;
    const {
      num,
      style
    } = props;
    const children = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Children.toArray(props.children);
    const className = this.classNames(props.className, this.namespace(this.classNames('col-lg-' + (num <= 6 ? Math.floor(12 / num) : 2), 'col-md-6', 'col-sm-12')));
    const columns = this[style](children, num);

    if (!columns || columns.length === 0) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, columns.map((items, idx) => {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
        className: className,
        key: idx
      }, items);
    }));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


columns_Columns.propTypes = columns_objectSpread(columns_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  num: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  style: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['horizontal', 'vertical']),
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node)
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

columns_Columns.defaultProps = {
  num: 4,
  style: 'vertical'
};
/* harmony default export */ var src_columns = (Object(namespace_component_["withNamespace"])(columns_Columns));
// CONCATENATED MODULE: ./node_modules/@ux/column-layout/src/column-item.js


function column_item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function column_item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { column_item_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { column_item_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Columns item component.
 *
 * This represents an individual list item that should be placed into a column.
 * In terms of HTML, this is the `<li>` element.
 *
 * @class Columns
 * @public
 */

class column_item_ColumnItem extends namespace_component_["NamespaceConsumer"] {
  /**
   * Render the component.
   *
   * @returns {ReactElement} li
   * @api public
   */
  render() {
    const props = this.props;
    const className = this.classNames(props.className, this.namespace(this.classNames({
      selected: props.isSelected
    })));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: className
    }, this.props.children);
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


column_item_ColumnItem.propTypes = column_item_objectSpread(column_item_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  isSelected: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node
});
/* harmony default export */ var column_item = (Object(namespace_component_["withNamespace"])(column_item_ColumnItem));
// CONCATENATED MODULE: ./node_modules/@ux/column-layout/src/index.js



/* harmony default export */ var column_layout_src = (src_columns);
// EXTERNAL MODULE: ./node_modules/@ux/icon/world/index.js
var world = __webpack_require__("./node_modules/@ux/icon/world/index.js");
var world_default = /*#__PURE__*/__webpack_require__.n(world);

// EXTERNAL MODULE: ./node_modules/@ux/icon/map-pin/index.js
var map_pin = __webpack_require__("./node_modules/@ux/icon/map-pin/index.js");
var map_pin_default = /*#__PURE__*/__webpack_require__.n(map_pin);

// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/node_modules/@ux/market-selector/src/index.js



function market_selector_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function market_selector_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { market_selector_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { market_selector_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * Market selector component.
 *
 * This renders an anchor with the label showing the current market. When it is
 * clicked it will open up a tray dropdown with all the available markets.
 * Clicking on them will then fire of a transfer to the market website.
 *
 * @class Columns
 * @public
 */

class src_MarketSelector extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.onTrayToggle = this.onTrayToggle.bind(this);
    this.lockScroll = this.lockScroll.bind(this);
    this.unlockScroll = this.unlockScroll.bind(this);
  }
  /**
   * Return the label for a market.
   * Ex: en-US becomes "United States - English"
   *
   * @param {String} name market
   * @returns {String} Label for the specified market
   * @private
   */


  getMarketLabel(name) {
    if (!this.props.marketData) {
      return name;
    }

    const marketInfo = this.props.marketData[name];

    if (!marketInfo) {
      return;
    }

    return "".concat(marketInfo.countryName, " - ").concat(marketInfo.languageName);
  }
  /**
   * Return the market for the aria-label.
   * Ex: en-US becomes "United States - English"
   *
   * @param {String} name market
   * @returns {String} Label for the specified market
   * @private
   */


  getMarketDescription(name) {
    if (!this.props.marketData) {
      return name;
    }

    const marketInfo = this.props.marketData[name];

    if (!marketInfo) {
      return 'Unknown market';
    }

    return marketInfo.description;
  }
  /**
   * Once we've mounted we need to listen for all breakpoints.
   */


  componentDidMount() {
    this.breakpoint('mobile', 'phablet', 'tablet', 'desktop', 'large');
  }
  /**
   * When we unmount stop listening for all breakpoint events.
   */


  componentWillUnmount() {
    this.breakup();
  }
  /**
   * If we are on a mobile breakpoint, then invoke the handlers to potentially
   * lock or unlock scrolling for the `document.body`.
   *
   * @param  {Boolean} open Value indicating if the TrayMenu in this Component is open.
   */


  onTrayToggle(open) {
    if (!this.isMobile) {
      return;
    }

    if (open) {
      this.lockScroll();
    }

    if (!open) {
      this.unlockScroll();
    }
  }
  /**
   * Add a class to set `overflow: hidden;`  on `document.body`.
   * This prevents scrolling of background content.
   *
   * TODO: Apply the Mobile Safari fix for GX-4564 when complete.
   */


  lockScroll() {
    //
    // Add className to the target to indicate that the TrayMenu is open.
    // This className ensures that the correct scroll bars are added when we
    // have content that is overflowing.
    //
    if (this.props.lockScrollOnOpen) {
      const target = document.body;
      target.classList.add(this.namespace('market-selector-open'));
    }
  }
  /**
   * Add a class to set `overflow: hidden;`  on `document.body`.
   * This prevents scrolling of background content.
   *
   * TODO: Apply the Mobile Safari fix for GX-4564 when complete.
   */


  unlockScroll() {
    //
    // Remove className to the target to indicate that the TrayMenu is closed.
    //
    const target = document.body;
    target.classList.remove(this.namespace('market-selector-open'));
  }
  /**
   * Render the markets into columns.
   *
   * @returns {Array} markets Array of ColumnItems
   * @private
   */


  renderMarkets() {
    const {
      manifest,
      eidPrefix,
      currentMarket,
      currentPage = '',
      urls = {},
      urlArgs,
      marketData,
      isReseller
    } = this.props;
    const marketNames = this.props.markets;
    let markets = [];

    if (marketData && marketNames) {
      markets = marketNames.reduce((acc, marketName) => {
        const marketDataForMarket = marketData[marketName];
        if (marketDataForMarket) acc.push(marketDataForMarket);
        return acc;
      }, []);
    }

    urls.markets = urls.markets || {};
    urls.pcgo = urls.pcgo || {}; //
    // All links to change market must go through GUI (the service urls.pcgo points to).
    // The GUI service sets the `market` cookie before redirecting to the `currentPage`.
    //

    const redirect = new util_["URL"](urls.pcgo.href, true);
    redirect.set('pathname', "".concat(redirect.pathname, "/").concat(currentPage));
    return markets.reduce((acc, market) => {
      const marketName = market.market || '';
      const eid = golf_to_eid_default()(":".concat(marketName.replace(/-/g, '_')), {
        prefix: "".concat(eidPrefix, ".").concat(golf_to_eid_default()(manifest), ".market_selector"),
        postfix: 'click'
      });
      let url = urls.markets[marketName] || '#';

      if (typeof url === 'string') {
        url = {
          href: url
        };
      } // During client re-render in reseller sales header, include explicit
      // target parameter specifying current location.


      if (this.isBrowser && isReseller) {
        url = new util_["URL"](url.href, true);
        url.set('query', market_selector_src_objectSpread(market_selector_src_objectSpread({}, url.query), {}, {
          target: window.location.href
        }));
        url = {
          href: url.href
        };
      }

      if (market) {
        redirect.set('query', market_selector_src_objectSpread(market_selector_src_objectSpread({}, redirect.query), {}, {
          regionsite: market.countrySite,
          marketid: market.market
        }));
        acc.push( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(column_item, {
          key: marketName,
          isSelected: marketName === currentMarket
        }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({}, url, {
          "data-tcc-ignore": true,
          urlArgs: urlArgs,
          redirect: isReseller ? null : redirect.href,
          "data-market": marketName,
          "data-eid": eid
        }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
          "data-tcc-ignore": true
        }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", {
          "data-tcc-ignore": true
        }, market.countryName), " - ", market.languageName, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
          className: this.namespace('location')
        }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(map_pin_default.a, {
          height: 14,
          width: 14
        }))))));
      }

      return acc;
    }, []);
  }
  /**
   * Get the two-letter short language code for the specified market
   * e.g. en-US: EN, el-GR: EL, fr-CA: FR
   *
   * If a displayCode is returned from the Markets API, use that instead.
   *
   * @param {String} market The market name to parse (e.g. en-US, el-GR, fr-CA)
   * @returns {String} The language code of the specified market, in upper case
   * @private
   */


  getShortLanguageCode(market) {
    if (!market || typeof market !== 'string') return '';
    const marketInfo = this.props.marketData && this.props.marketData[market];
    const displayCode = marketInfo && marketInfo.displayCode;

    if (displayCode) {
      return displayCode;
    }

    const marketParts = market.split('-');
    return marketParts[0].toUpperCase();
  }
  /**
   * Generate the tray title to show
   *
   * @returns {ReactElement} The title node to show for the tray
   * @private
   */


  getTrayName() {
    const {
      currentMarket,
      compact
    } = this.props;
    const currentMarketName = this.getMarketLabel(currentMarket) || 'Unknown market';
    let label = currentMarketName;

    if (compact) {
      label = this.getShortLanguageCode(currentMarket);
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('mrkt-selector-tray-name'),
      title: currentMarketName
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(world_default.a, null), label);
  }
  /**
   * Render the component.
   *
   * @returns {ReactElement} TrayMenu
   * @api public
   */


  render() {
    const {
      numColumns,
      messages,
      currentMarket,
      eidPrefix,
      manifest
    } = this.props;
    const eid = golf_to_eid_default()('market_selector', {
      prefix: "".concat(eidPrefix, ".").concat(golf_to_eid_default()(manifest)),
      postfix: 'click'
    });
    const marketDescription = this.getMarketDescription(currentMarket);

    if (this.trayMenu) {
      const isOpen = this.trayMenu.state.open;

      if (this.isMobile && isOpen) {
        this.lockScroll();
      } else if (this.isMobile && !isOpen || !this.isMobile && isOpen) {
        this.unlockScroll();
      }
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: currentMarket,
      messages: messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:MarketSelectorTray:AriaLabel",
      values: {
        selection: marketDescription
      }
    }, marketSelectorTray => /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_menu, {
      ariaLabel: marketSelectorTray,
      type: "base",
      ref: c => this.trayMenu = c // eslint-disable-line no-return-assign
      ,
      name: this.getTrayName(),
      className: this.namespace('market-selector'),
      onToggle: this.onTrayToggle,
      "data-eid": eid
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:MarketSelectorTray:Title"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_columns, {
      num: numColumns,
      style: "vertical",
      className: this.namespace('market-list')
    }, this.renderMarkets())))));
  }

}
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

src_MarketSelector.propTypes = market_selector_src_objectSpread(market_selector_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  manifest: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  currentMarket: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  numColumns: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  markets: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  compact: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  lockScrollOnOpen: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  marketData: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  isReseller: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

src_MarketSelector.defaultProps = {
  manifest: 'SalesHeader',
  eidPrefix: 'uxp.hyd',
  currentMarket: 'en-US',
  numColumns: 4,
  urlArgs: {},
  compact: false,
  open: false,
  lockScrollOnOpen: false,
  marketData: {}
};
/* harmony default export */ var market_selector_src = (Object(namespace_component_["withNamespace"])(src_MarketSelector));
// EXTERNAL MODULE: ./node_modules/@ux/icon/information/index.js
var information = __webpack_require__("./node_modules/@ux/icon/information/index.js");
var information_default = /*#__PURE__*/__webpack_require__.n(information);

// EXTERNAL MODULE: ./node_modules/@ux/icon/phone/index.js
var icon_phone = __webpack_require__("./node_modules/@ux/icon/phone/index.js");
var phone_default = /*#__PURE__*/__webpack_require__.n(icon_phone);

// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/contact-tray.js



function contact_tray_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function contact_tray_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { contact_tray_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { contact_tray_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











/**
 * Render and expose the LanguageSelector as a functional Component.
 *
 * @param {Object} props Properties
 * @api public
 */

class contact_tray_ContactTray extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(...arguments);
    this.eids = {
      contactUs: eid_eid({
        key: golf.contactUs,
        manifest: props.manifest
      }),
      globalDirectory: eid_eid({
        key: golf.globalDirectory,
        manifest: props.manifest
      }),
      help: eid_eid({
        key: golf.help,
        manifest: props.manifest
      })
    };
    this.showSupportContacts = this.showSupportContacts.bind(this);
    this.state.showPhoneNumbers = false;
  }
  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */


  componentDidMount() {
    this.breakpoint(...enums_breakpoints);
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */


  componentWillUnmount() {
    this.breakup();
  }

  render() {
    const props = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, this.renderInternal());
  }
  /**
   * Render contact tray menu or link
   * @returns {React.Element} tray menu or link
   */


  renderInternal() {
    const props = this.props;
    const supportDetails = props.supportContacts || {};
    const phoneNumber = supportDetails.technicalSupportPhone || '';
    const trayName = supportDetails.technicalSupportLabel;
    const telHref = "tel:".concat(phoneNumber.replace(/[^\d]/g, ''));

    if (!trayName || trayName === '') {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null);
    }

    const includesPhoneNumber = this.includesPhoneNumber(trayName, phoneNumber);

    if (props.privateLabelId === 1) {
      if (props.contactTrayEnabled) {
        return this.renderFullTray(supportDetails, trayName, includesPhoneNumber);
      }

      if (this.shouldShowCityContactsTray(supportDetails)) {
        return this.renderCityContactsTray(supportDetails, trayName, telHref, includesPhoneNumber);
      }
    } // If none of the trays are enabled, just show the tray name as a link
    // If {phone} make the number a telHref otherwise link to contact us


    const trayNameEid = includesPhoneNumber ? "uxp.hyd.utility_bar.support_phone.click" : this.eids.contactUs;
    let trayHref = props.urls.contactUs.href;

    if (includesPhoneNumber) {
      trayHref = telHref;
    } else if (props.privateLabelId !== 1) {
      trayHref = '#';
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('basic-phone-container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
      urlArgs: props.urlArgs,
      href: trayHref,
      className: this.namespace('btn', 'basic-phone-btn'),
      "data-eid": trayNameEid
    }, this.renderTrayName(trayName, includesPhoneNumber)));
  }
  /**
   * Renders name to display on contact tray
   * @param  {String} trayName The translated text to display as the tray name
   * @param {Boolean} includesPhoneNumber whether or not the tray label includes the support number
   * @returns {React.Element} div containing tray name
   * @private
   */


  renderTrayName(trayName, includesPhoneNumber) {
    const props = this.props;
    const isIconsContactHelpExp = props.split === 'iconsContactHelpExp';
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, (this.isMobile || this.state.breakpoint === 'tablet' || includesPhoneNumber || isIconsContactHelpExp) && this.renderPhoneIcon(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('basic-phone-text', 'hidden-sm-down', 'title-text')
    }, trayName));
  }
  /**
   * Check if tray name includes the phone number
   * @param {String} trayName contact tray label
   * @param {String} phoneNumber the technical support number
   * @returns {Boolean} true if tray name includes phone number
   * @private
   */


  includesPhoneNumber(trayName, phoneNumber) {
    return trayName.indexOf(phoneNumber) !== -1;
  }
  /**
   * Whether to show the city contacts tray
   *
   * Only shows the tray if there exists a city contact with a phone number that
   * does not match the market contact
   *
   * @param {Object} supportDetails Information from the support API
   * @returns {Boolean} true if we should show the city contacts tray, false otherwise
   * @private
   */


  shouldShowCityContactsTray(supportDetails) {
    if (!supportDetails || !supportDetails.cityContacts) return false;
    const cityContactKeys = Object.keys(supportDetails.cityContacts);

    for (let i = 0; i < cityContactKeys.length; i++) {
      const contact = supportDetails.cityContacts[cityContactKeys[i]];

      if (contact.technicalSupportPhone !== supportDetails.technicalSupportPhone) {
        return true;
      }
    }

    return false;
  }
  /**
   * Render the phone icon along with appropriate alternate text
   *
   * @returns {ReactElement} A `span` element with the phone icon and specified alt text
   * @private
   */


  renderPhoneIcon() {
    const props = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      title: props.messages[golf.contactUs],
      className: this.namespace('phone-header')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(phone_default.a, null));
  }

  renderCityContacts(supportDetails) {
    const altContactsData = []; // Push alternative contacts

    if (supportDetails.cityContacts && Object.keys(supportDetails.cityContacts).length) {
      Object.keys(supportDetails.cityContacts).forEach(key => {
        altContactsData.push(supportDetails.cityContacts[key]);
      });
    } // If no city contacts were found, use market contact
    // Make sure to use technicalSupportDescription for the market contact


    if (!altContactsData.length) {
      altContactsData.push({
        technicalSupportPhone: supportDetails.technicalSupportPhone,
        technicalSupportHours: supportDetails.technicalSupportDescription
      });
    }

    const altContacts = altContactsData.map((contact, idx) => {
      const altPhone = contact.technicalSupportPhone || '';
      const hrefPhoneNumber = "tel:".concat(altPhone.replace(/[^\d]/g, '')); // If {phone} make the number a telHref otherwise link to contact us

      const trayNameEid = this.includesPhoneNumber ? "uxp.hyd.utility_bar.support_phone.click" : this.eids.contactUs;
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: idx
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, contact.technicalSupportHours), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
        className: this.namespace('contact-link'),
        "data-eid": trayNameEid,
        href: hrefPhoneNumber
      }, altPhone));
    });
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('alt-contact-list', 'list-unstyled')
    }, altContacts);
  }

  renderFederatedPartner() {
    const props = this.props;

    if (!props.federatedPartner) {
      return null;
    }

    const {
      phone,
      phoneDescription
    } = props.federatedPartner;
    const hrefPhoneNumber = "tel:".concat(phone.replace(/[^\d]/g, ''));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('federated-partner')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('partner-description')
    }, phoneDescription), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: hrefPhoneNumber,
      className: this.namespace('contact-link'),
      "data-eid": "uxp.hyd.utility_bar.federated_phone.click"
    }, phone));
  }

  renderCityContactsTray(supportDetails, trayName, includesPhoneNumber) {
    const trayLabel = this.renderTrayName(trayName, includesPhoneNumber);
    const {
      messages = {}
    } = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_menu, {
      ariaLabel: messages[golf.contactUs],
      "data-eid": "uxp.hyd.utility_bar.city_contact_tray.tray.click",
      type: "base",
      className: this.namespace('city-contacts-tray'),
      name: trayLabel
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:Alternate:Numbers"
    })), this.renderCityContacts(supportDetails), this.renderFederatedPartner(), this.renderSupportAnnouncement(supportDetails.technicalSupportAnnouncement))));
  }

  renderFullTray(supportDetails, trayName, includesPhoneNumber) {
    const props = this.props;
    const eids = this.eids;
    const trayLabel = this.renderTrayName(trayName, includesPhoneNumber);
    const isIconsContactHelpExp = props.split === 'iconsContactHelpExp';
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_menu, {
      ariaLabel: props.messages[golf.contactUs],
      "data-eid": "uxp.hyd.utility_bar.contact_tray.tray.click",
      type: "base",
      className: this.namespace(this.classNames('contact-tray', {
        'contact-icon-exp': isIconsContactHelpExp
      })),
      name: trayLabel
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container')
    }, this.renderSupportAnnouncement(supportDetails.technicalSupportAnnouncementAllChannels, true, {
      label: supportDetails.technicalSupportAnnouncementBtnText,
      href: supportDetails.technicalSupportAnnouncementBtnHref
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-lg-4', 'col-md-6', 'content-wrap')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:CallUs"
    })), this.renderCityContacts(supportDetails), this.renderFederatedPartner(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('contact-link-info')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:GlobalDirectory:GlobalDirectory"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: props.urlArgs
    }, props.urls.contactUs, {
      "data-eid": eids.globalDirectory,
      className: this.namespace('contact-link')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.globalDirectory
    }))), this.renderRequestACall(), this.isMobile || this.state.breakpoint === 'tablet' ? this.renderMobileChatSection(supportDetails) : this.renderChatSection(supportDetails), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-md-4', 'help-mobile', 'hidden-md-up')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:HelpCenter"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:HelpCenter:Explore"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      className: this.namespace('btn', 'btn-default'),
      urlArgs: props.urlArgs
    }, props.urls.help, {
      "data-eid": eids.help
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.help
    }))))), this.renderSupportAnnouncement(supportDetails.technicalSupportAnnouncement)));
  }

  showSupportContacts() {
    this.setState({
      showPhoneNumbers: true
    });
  }

  renderChatSection(supportDetails) {
    // Make chat data available in a global so chat team code can render it
    if (this.isBrowser) {
      const uxel = window && window.ux && window.ux.eldorado;

      if (uxel) {
        const messages = this.props.messages;
        uxel.chat_data = {
          target: 'gdchat-container',
          utilityChatEnabled: this.props.utilityChatEnabled,
          messages: {
            ChatNow: messages['Shared:UtilityBar:SupportPhone:ChatNow'],
            Chat: messages['Shared:UtilityBar:SupportPhone:Chat'],
            ChatOffline: messages['Shared:UtilityBar:SupportPhone:ChatOffline'],
            ChatHours: supportDetails.liveChatHours
          }
        };
      }
    } // IMPORTANT: `#gdchat-container` is used by the Chat team to render their chat UI into.
    // Do not remove it or change it without talking to @clim & @mfloyd


    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-lg-4', 'col-md-6', 'content-wrap', 'divider')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      id: "gdchat-container"
    }));
  }

  renderMobileChatSection(supportDetails) {
    const showMobileChatSection = this.props.utilityChatEnabled && supportDetails.liveChatHours && supportDetails.contactTrayChatDescription && supportDetails.contactTrayButtonLink;
    if (!showMobileChatSection) return null;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-md-4', 'chat-mobile', 'hidden-md-up')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:ChatNow"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, supportDetails.contactTrayChatDescription, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("br", null), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, " ", supportDetails.liveChatHours)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, supportDetails.contactTrayButtonLink ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('mobile-chat-btn-wrap')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
      className: this.namespace('btn', 'btn-info', 'mobile-chat-btn'),
      urlArgs: this.props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.chat_support_btn.click",
      href: supportDetails.contactTrayButtonLink
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:UtilityBar:SupportPhone:ChatNow"
    }))) : null), supportDetails.WhatsAppButtonLink && supportDetails.WhatsAppPhoneNumber ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('whatsapp-container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('whatsapp-chat-btn')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
      className: this.namespace('btn', 'btn-default'),
      urlArgs: this.props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.whatsapp_chat_btn.click",
      href: supportDetails.WhatsAppButtonLink
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      "aria-hidden": "true",
      className: this.namespace('whatsapp-icon')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("svg", {
      role: "img",
      width: "16",
      height: "16",
      viewBox: "24 10 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("path", {
      d: "M44.504 13.488A11.877 11.877 0 0040.63 10.9 11.924 11.924 0 0036.05 10c-6.59 0-11.948 5.335-11.95 11.892a11.826 11.826 0 001.595 5.945L24 34l6.335-1.654a11.987 11.987 0 005.71 1.448h.005c6.586 0 11.948-5.336 11.95-11.893a11.772 11.772 0 00-.902-4.555 11.818 11.818 0 00-2.594-3.858zm-8.453 18.297h-.006a9.955 9.955 0 01-5.056-1.378l-.362-.214-3.76.981 1.004-3.65-.236-.373a9.83 9.83 0 01-1.517-5.257c0-5.45 4.458-9.884 9.937-9.884a9.958 9.958 0 017.022 2.9 9.862 9.862 0 012.906 6.99c-.002 5.45-4.458 9.885-9.932 9.885zm5.448-7.403c-.299-.149-1.767-.868-2.04-.97-.275-.1-.473-.147-.672.15-.2.297-.771.97-.946 1.165-.174.195-.348.223-.647.074-.298-.148-1.26-.462-2.401-1.475-.888-.787-1.487-1.76-1.662-2.059-.175-.297-.018-.456.132-.606.134-.133.298-.347.447-.52.149-.174.2-.298.298-.496.1-.198.05-.372-.024-.52-.075-.15-.672-1.612-.92-2.207-.243-.58-.49-.501-.672-.51-.172-.009-.374-.01-.574-.01a1.101 1.101 0 00-.796.371c-.273.298-1.044 1.017-1.044 2.48 0 1.462 1.07 2.875 1.218 3.074.15.198 2.106 3.2 5.1 4.486.556.239 1.124.448 1.702.627.716.229 1.367.194 1.88.118.574-.085 1.768-.719 2.017-1.413.248-.694.248-1.289.172-1.413-.077-.125-.27-.197-.568-.346z"
    }))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Sales:ContactTray:WhatsApp:ChatButton"
    }))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, supportDetails.WhatsAppPhoneNumber))) : null);
  }

  renderRequestACall() {
    const props = this.props;

    if (!props.requestACallEnabled) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-lg-4', 'col-md-6', 'content-wrap', 'divider')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('request-a-call')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_title, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Sales:ContactTray:RequestACall:CTA"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Sales:ContactTray:RequestACall:avoidTheWait"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      className: this.namespace('btn btn-default'),
      urlArgs: props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.request_a_call.click"
    }, props.urls.requestACall), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Sales:ContactTray:RequestACall:CTA"
    }))));
  }
  /**
   * Render the support announcement section if needed
   *
   * @param {Object} announcement value from supportDetails.technicalSupport{AllChannels}
   * @param {boolean} [allChannels] flag denoting whether we're rendering the `AllChannels` support announcement
   * @param {Object} [buttonInfo] settings for the button to show next to the AllChannels announcement if applicable
   * @returns {React.ReactElement} The support announcement as a React element, or null if none needed
   */


  renderSupportAnnouncement(announcement, allChannels = false, buttonInfo = {}) {
    const className = allChannels ? 'support-announcement-all' : 'support-announcement';
    const announcementsTemplate = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(className)
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('support-announcement-text')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(information_default.a, null), announcement), buttonInfo.href ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('support-announcement-btn')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
      className: this.namespace('btn', 'btn-sm', 'btn-default'),
      urlArgs: this.props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.support_announcement_btn.click",
      href: buttonInfo.href
    }, buttonInfo.label)) : null);

    if (announcement) {
      if (!allChannels) {
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
          className: this.namespace('row')
        }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
          className: this.namespace('col-xs-12')
        }, announcementsTemplate));
      }

      return announcementsTemplate;
    }

    return null;
  }

}

contact_tray_ContactTray.propTypes = contact_tray_objectSpread(contact_tray_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  supportContacts: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  contactTrayEnabled: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  requestACallEnabled: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  utilityChatEnabled: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
contact_tray_ContactTray.defaultProps = {
  contactTrayEnabled: false,
  requestACallEnabled: false,
  utilityChatEnabled: false
};
/* harmony default export */ var contact_tray = (Object(namespace_component_["withNamespace"])(contact_tray_ContactTray));
// CONCATENATED MODULE: ./node_modules/@ux/product-panel/src/enums.js
//
// Define the breakpoints the manifest need to listen to.
//
const src_enums_breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large']; //
// Golf translation ids
//

const enums_golf = {
  close: 'Shared:UtilityBar:Close',
  discover: 'Sales:DiscoverNav:Heading',
  helpCenter: 'Shared:UtilityBar:SupportPhone:HelpCenter',
  home: 'PC:AppHeader:Header:Home',
  mainMenu: 'Shared:MobileNav:MainMenu',
  product: 'Sales:ProductNav:Heading',
  productPanel: 'Sales:ProductPanel:MenuTitle',
  signin: 'Shared:UtilityBar:AccountTray:SignIn'
};

// EXTERNAL MODULE: ./node_modules/@ux/icon/grid-horizontal/index.js
var grid_horizontal = __webpack_require__("./node_modules/@ux/icon/grid-horizontal/index.js");
var grid_horizontal_default = /*#__PURE__*/__webpack_require__.n(grid_horizontal);

// EXTERNAL MODULE: ./node_modules/@ux/icon/chevron-down-lt/index.js
var icon_chevron_down_lt = __webpack_require__("./node_modules/@ux/icon/chevron-down-lt/index.js");
var icon_chevron_down_lt_default = /*#__PURE__*/__webpack_require__.n(icon_chevron_down_lt);

// CONCATENATED MODULE: ./node_modules/@ux/product-panel/src/utils.js


/**
 * Determines whether to render text as FormattedMessage or as literal string
 * @param  {String}  caption   The string to render
 * @param  {Boolean} isLiteral Whether or not to render as literal string
 * @returns {String|React.ReactElement} null if there is nothing to render, otherwise
 * returns what should be rendered for the caption
 */

function renderCaption(caption, isLiteral = false) {
  if (!caption) {
    return null;
  } else if (isLiteral) {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, caption);
  }

  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
    id: caption
  });
}


// CONCATENATED MODULE: ./node_modules/@ux/product-panel/src/parent-panel.js


function parent_panel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function parent_panel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { parent_panel_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { parent_panel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









class parent_panel_ParentPanel extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.renderParents = this.renderParents.bind(this);
    this.focusables = {};
    this.state = parent_panel_objectSpread(parent_panel_objectSpread({}, this.state), {}, {
      hovered: false
    });
    this.createFocusRefs = this.createFocusRefs.bind(this);
  }
  /**
   * Focus on the first link in the shown panel
   * @private
   */


  focusFirst() {
    this.focusables.first && this.focusables.first.focus();
  }
  /**
   * Focus on the last link in the shown panel
   * @private
   */


  focusLast() {
    this.focusables.last && this.focusables.last.focus();
  }
  /**
   * Store refs to the first and last focusable nav items
   * @private
   * @param {HTMLElement} btn DOM node to be stored in ref
   */


  createFocusRefs(btn) {
    if (!this.focusables.first) this.focusables.first = btn;
    this.focusables.last = btn;
  }
  /**
   * Render top level headings for nav. If the nav has children,
   * the heading will trigger expansion of child panel
   *
   * @private
   * @param {Object[]} nav Array of objects for generating parent items
   * @returns {React.ReactElement[]} List items for parent nav items
   */


  renderParents(nav) {
    const props = this.props;
    return nav.map((item, i) => {
      if (item.onlyallproducts) {
        return;
      }

      const {
        caption,
        children,
        title,
        href,
        id
      } = item;
      const text = caption || title;

      if (text) {
        const eid = golf_to_eid_default()(caption || id, {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        });

        if (children && children.length > 0) {
          // list item that will trigger a menu
          return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
            className: this.namespace('parent-with-child'),
            key: id || caption + i,
            "data-eid": eid
          }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
            tabIndex: props.tabIndex,
            onClick: () => props.onParentClick(item),
            onMouseEnter: () => this.setState({
              hovered: true
            }),
            onMouseLeave: () => this.setState({
              hovered: false
            }),
            ref: this.createFocusRefs
          }, renderCaption(text, !caption)));
        } else if (href) {
          // Plain link
          return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
            key: id || caption + i
          }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
            href: href,
            "data-eid": eid,
            urlArgs: this.props.urlArgs,
            onClicked: props.onClose,
            className: this.namespace('single-parent-link'),
            tabIndex: props.tabIndex,
            onMouseEnter: () => this.setState({
              hovered: true
            }),
            onMouseLeave: () => this.setState({
              hovered: false
            })
          }, renderCaption(text, !caption)));
        }
      }
    });
  }

  render() {
    const {
      props,
      state
    } = this;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('parent-menu-panel', {
        open: props.open
      }, {
        'product-flyout-hovered-menu': props.open && state.hovered
      }))
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container-fluid', 'menu-scroller'),
      onScroll: this.props.onScroll,
      ref: r => {
        this.outerDiv = r;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('parent-navigation'),
      ref: r => {
        this.innerDiv = r;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('product-flyout-heading')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.product
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('list-unstyled', 'parent-link-items', 'parent-product-nav')
    }, this.renderParents(props.productNav))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('product-flyout-heading')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.discover
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('list-unstyled', 'parent-link-items', 'parent-discover-nav')
    }, this.renderParents(props.discoverNav))))));
  }

}
parent_panel_ParentPanel.propTypes = parent_panel_objectSpread(parent_panel_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  productNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object).isRequired,
  discoverNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object).isRequired,
  onClose: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  onParentClick: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  tabIndex: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  onScroll: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func
});
parent_panel_ParentPanel.defaultProps = {
  onParentClick: () => {},
  open: false
};
/* harmony default export */ var parent_panel = (Object(namespace_component_["withNamespace"])(parent_panel_ParentPanel));
// CONCATENATED MODULE: ./node_modules/@ux/product-panel/src/child-panel.js


function child_panel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function child_panel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { child_panel_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { child_panel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










class child_panel_ChildPanel extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.focusables = {};
    this.state = child_panel_objectSpread(child_panel_objectSpread({}, this.state), {}, {
      hovered: false
    });
  }
  /**
   * Focus on the first link in the shown panel
   * @private
   */


  focusFirst() {
    this.focusables.first && this.focusables.first.focus();
  }
  /**
   * Focus on the last link in the shown panel
   * @private
   */


  focusLast() {
    this.focusables.last && this.focusables.last.focus();
  }
  /**
   * render a back button
   *
   * @private
   * @returns {React.ReactElement} a div with a back btn
   */


  renderBackBtn() {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('child-flyout-back')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      tabIndex: this.props.tabIndex,
      ref: btn => {
        this.focusables.first = btn;
      },
      onClick: this.props.onBack,
      className: this.namespace('btn')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.mainMenu
    })));
  }
  /**
   * Renders the heading at the top of the child panel
   * @param  {String} caption The text to render
   * @param  {Boolean} useLiteralCaptions Whether or not to render as literal string
   * @param  {String} href The destination for the link
   * @param  {Object} urlArgs Args to append to the href
   * @returns {React.ReactElement|string} `Link` component or span with literal string
   */


  renderTitle(caption, useLiteralCaptions, href, urlArgs) {
    const title = renderCaption(caption, useLiteralCaptions);

    if (typeof href === 'string' && href.length) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
        href: href,
        urlArgs: urlArgs,
        tabIndex: this.props.tabIndex,
        className: this.namespace('no-link-styling')
      }, title);
    }

    return title;
  }

  renderLearnMoreButton() {
    const props = this.props;
    const {
      leftnav = {}
    } = props.parent;
    const {
      href,
      btn,
      btnText,
      id
    } = leftnav;

    if (href && (btn || btnText)) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
        className: this.namespace('learn-more'),
        href: href,
        rel: "nofollow",
        onClicked: props.onClose,
        urlArgs: props.urlArgs,
        tabIndex: props.tabIndex,
        "data-eid": golf_to_eid_default()(btn || id, {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        })
      }, renderCaption(btn || btnText, !btn));
    }
  }
  /**
   * Renders panel title, description, and learn more btn if present
   * @returns {React.ReactElement} Div for title/description/learnmore
   */


  renderTitleAndDescription() {
    const props = this.props;
    const {
      leftnav = {},
      caption,
      title
    } = props.parent;
    const text = caption || title;
    const description = leftnav.description || leftnav.descriptionText;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('child-panel-top-info')
    }, text && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('product-flyout-heading')
    }, this.renderTitle(text, !caption, leftnav.href, props.urlArgs)), description && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", {
      className: this.namespace('description')
    }, renderCaption(description, !leftnav.description), " ", this.renderLearnMoreButton()));
  }
  /**
   * Generate links
   *
   * @private
   * @param {Object[]} items Array of objects to display as links
   * @returns {React.ReactElement[]} a set of Links
   */


  renderLinks(items) {
    const props = this.props;
    const links = [];
    items.forEach((child, i) => {
      if (child.onlyallproducts) {
        return;
      }

      const {
        caption,
        title,
        id,
        href
      } = child;
      const text = caption || title;

      if (href && href.length && text) {
        const eid = golf_to_eid_default()(caption || id, {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        });
        links.push( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
          key: id || caption + i,
          className: this.namespace('child-menu-link')
        }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
          "data-eid": eid,
          href: href,
          urlArgs: props.urlArgs,
          onClicked: props.onClose,
          tabIndex: props.tabIndex,
          ref: link => {
            this.focusables.last = link;
          },
          onMouseEnter: () => this.setState({
            hovered: true
          }),
          onMouseLeave: () => this.setState({
            hovered: false
          })
        }, renderCaption(text, !caption))));
      }
    });
    return links;
  }
  /**
   * Render rows of children with given number of columns
   * @param  {React.ReactElement[]} children Array of content to put in each column
   * @param  {Number} numCols How many columns in each row
   * @returns {React.ReactElement[]} Array of rows
   */


  renderRows(children, numCols) {
    const rows = [];
    const numKids = children.length; // split children array into array of new arrays length `numCols`

    const endLoop = Math.floor(numKids / numCols);

    for (let i = 0; i <= endLoop; i++) {
      const start = numCols * i;

      if (start === numKids) {
        // prevent an extra row from being added if numKids is evenly
        // divisible by numCols
        break;
      }

      const end = start + numCols;
      rows.push(children.slice(start, end));
    }

    return rows.map((colArr, i) => {
      // for each array of columns, start a row
      // for each fragment in the array, start a column
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        key: 'row' + i,
        className: this.namespace('child-menu-items-row')
      }, colArr.map((frag, j) => {
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
          key: j,
          className: this.namespace('child-menu-items-col')
        }, frag);
      }));
    });
  }
  /**
   * Renders a group of links that may or may not have a heading
   * @private
   * @param {Object[]} sections Array of objects for generating the sections of links
   * @returns {React.ReactElement[]} a set of list items
   */


  renderSections(sections) {
    const props = this.props;
    const subNavSections = [];
    sections.forEach((section, i) => {
      const {
        caption,
        title,
        children
      } = section;

      if (Array.isArray(children) && children.length > 0 && !section.onlyallproducts) {
        let showSectionHeader = caption && props.messages[caption] !== props.messages[props.parent.caption];
        showSectionHeader = showSectionHeader || title !== props.parent.title;
        subNavSections.push( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, {
          key: section.id || caption + i
        }, showSectionHeader && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
          className: this.namespace('child-menu-header', 'title', 'small')
        }, renderCaption(caption || title, !caption)), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
          className: this.namespace('child-menu-links', 'list-unstyled')
        }, this.renderLinks(children))));
      }
    });

    if (subNavSections.length === 0) {
      // no subNavSections, just a list of links
      return this.renderLinks(sections);
    }

    return subNavSections;
  }
  /**
   * Render panel displaying subnav if navigation menu is open
   *
   * @private
   *
   * @returns {React.ReactElement} div for the subnav panel
   */


  render() {
    const {
      props,
      state
    } = this;
    const columnContent = this.renderSections(props.navigation);
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      onTransitionEnd: e => props.open && e.propertyName === 'transform' && this.focusFirst(),
      className: this.classNames(props.className, this.namespace('child-menu-panel', props.open && 'open', props.open && state.hovered && 'product-flyout-hovered-menu'))
    }, this.renderBackBtn(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('child-menu-container', 'menu-scroller'),
      onScroll: this.props.onScroll,
      ref: r => {
        this.outerDiv = r;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      ref: r => {
        this.innerDiv = r;
      }
    }, this.renderTitleAndDescription(), this.renderRows(columnContent, 2))));
  }

}
/**
 * PropType validation for SubNavPanel
 *
 * @type {Object}
 * @api public
 */


child_panel_ChildPanel.propTypes = child_panel_objectSpread(child_panel_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  navigation: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array.isRequired,
  onBack: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  onClose: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  tabIndex: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  parent: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

child_panel_ChildPanel.defaultProps = {
  onBack: () => {},
  onClose: () => {},
  open: false
};
/* harmony default export */ var child_panel = (Object(namespace_component_["withNamespace"])(child_panel_ChildPanel));
// CONCATENATED MODULE: ./node_modules/@ux/product-panel/src/index.js



function product_panel_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function product_panel_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { product_panel_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { product_panel_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













class src_ProductPanel extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.state = product_panel_src_objectSpread(product_panel_src_objectSpread({}, this.state), {}, {
      selectedParent: null,
      showChildPanel: false,
      open: false,
      runway: false,
      hideOnScroll: false
    });
    this.control = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createRef();
    this.close = this.close.bind(this);
    this.goToParentMenu = this.goToParentMenu.bind(this);
    this.setSelected = this.setSelected.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleForwardTab = this.handleForwardTab.bind(this);
    this.handleBackwardTab = this.handleBackwardTab.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.killRunway = this.killRunway.bind(this);
    this.compareDivs = this.compareDivs.bind(this);
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */


  componentWillUnmount() {
    this.breakup;
    this.off('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      state
    } = this;
    const {
      open
    } = state;

    if (prevState.open !== open) {
      if (this.isBrowser) {
        const html = this.html = this.target || document.documentElement;
        html.className = this.classNames(html.className, this.mobileSafariClass, {
          [this.namespace('product-flyout-open')]: open
        });
      }
    }

    if (this.isMobile) {
      let parentNeedsRunway = false;
      let childNeedsRunway = false;

      if (this.parentPanel) {
        parentNeedsRunway = this.compareDivs(this.parentPanel.outerDiv, this.parentPanel.innerDiv);
      } else if (this.childPanel) {
        childNeedsRunway = this.compareDivs(this.childPanel.outerDiv, this.childPanel.innerDiv);
      }

      if ((childNeedsRunway || parentNeedsRunway) && !state.runway && !state.hideOnScroll) {
        this.setState({
          runway: true
        });
      } else if (!state.open && state.runway) {
        this.setState({
          runway: false
        });
      }
    }
  }

  componentDidMount() {
    this.breakpoint(...src_enums_breakpoints);

    if (this.isBrowser) {
      const userAgent = window.navigator.userAgent;
      const iOS = userAgent.match(/iPhone|iPad/i); // iPad and iPhone user agent for Safari

      const mobileRegExp = /(iPad|iPhone|CriOS).*WebKit(?:(?!(FxiOS|OPiOS)).)*$/;
      this.mobileSafariClass = mobileRegExp.test(userAgent) ? this.namespace("mobile-safari-".concat(iOS[0].toLowerCase())) : '';
      this.on('keydown', this.handleKeyDown);
    }
  }
  /**
   * Compare the heights of two div references.
   * @param  {Element} outer Ref to a div
   * @param  {Element} inner Ref to a div
   * @returns {Boolean} True if inner height > outer height
   */


  compareDivs(outer, inner) {
    if (outer && inner) {
      const outerDivHeight = outer.clientHeight;
      const innerDivHeight = inner.clientHeight;
      return innerDivHeight > outerDivHeight;
    }

    return false;
  }
  /**
   * get rid of the runway
   *
   * @private
   */


  killRunway() {
    if (!this.state.runway) {
      return;
    }

    this.setState({
      runway: false,
      hideOnScroll: true
    });
  }
  /**
   * close the menu by setting state.open to be false
   *
   * @private
   */


  close() {
    this.setState({
      open: false,
      showChildPanel: false,
      selectedParent: null
    }, () => this.control.current && this.control.current.focus());
  }
  /**
   * click function to set open/close state of menu
   *
   * @private
   */


  toggleOpen() {
    const {
      open
    } = this.state;
    this.setState({
      open: !open
    });
  }
  /**
   * Handle the Tab keydown. Do not allow tabbing in background and set focus.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   *
   * @private
   */


  handleForwardTab(e) {
    let activePanel, lastFocusable;

    if (this.childPanel) {
      activePanel = this.childPanel;
      lastFocusable = this.childPanel.focusables.last.anchor.current;
    } else {
      activePanel = this.parentPanel;
      lastFocusable = this.parentPanel.focusables.last;
    }

    if (document.activeElement === lastFocusable) {
      e.preventDefault();
      activePanel.focusFirst();
    }
  }
  /**
   * Handle the shift + Tab keydown. Do not allow tabbing in background and set focus.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   *
   * @private
   */


  handleBackwardTab(e) {
    const activePanel = this.childPanel ? this.childPanel : this.parentPanel;

    if (document.activeElement === activePanel.focusables.first) {
      e.preventDefault();
      activePanel.focusLast();
    }
  }
  /**
   * Listen for the ESC and Tab key events.
   * @param {React.KeyboardEvent} e the event object sent from the browser
   * @private
   */


  handleKeyDown(e) {
    if (e.key && (e.key === 'Escape' || e.key === 'Esc') && this.state.open) {
      e.preventDefault();
      this.close();
    }

    if (e.key === 'Tab' && this.state.open) {
      e.shiftKey ? this.handleBackwardTab(e) : this.handleForwardTab(e);
    }
  }
  /**
   * Set which parent is currently selected
   * @param {Object} item The parent nav item and its properties
   */


  setSelected(item) {
    this.setState({
      selectedParent: item,
      showChildPanel: true,
      hideOnScroll: false
    });
  }
  /**
   * click function to go back to the parent menu
   *
   * @private
   */


  goToParentMenu() {
    this.setState({
      showChildPanel: false,
      hideOnScroll: false
    });
  }
  /**
   * Render translucent background behind the navigation menu
   *
   * @private
   *
   * @returns {React.ReactElement} div for the background
   */


  renderBackground() {
    if (!this.state.open) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      onClick: this.close,
      className: this.namespace('product-panel-bkg'),
      role: "presentation"
    });
  }
  /**
   * Render all panels containing children
   * @param  {Object[]} nav Array of child nav items
   * @param  {String} className Class to add to the child panel div
   * @returns {React.ReactElement[]} Array of child panels
   */


  renderChildPanels(nav, className) {
    const {
      state,
      props
    } = this;
    const panels = [];
    const {
      selectedParent
    } = state;
    const {
      caption = null,
      id
    } = selectedParent || {};
    nav.forEach(navItem => {
      if (navItem.children && !navItem.onlyallproducts) {
        const matchingCaption = caption && caption === navItem.caption;
        const matchingId = id && id === navItem.id;
        const open = state.showChildPanel && (matchingCaption || matchingId);
        panels.push( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(child_panel, {
          className: className,
          parent: navItem,
          onClose: this.close,
          onBack: this.goToParentMenu,
          open: open,
          tabIndex: open ? void 0 : -1,
          navigation: navItem.children,
          eidPrefix: props.eidPrefix,
          key: navItem.caption || navItem.id,
          urlArgs: props.urlArgs,
          messages: props.messages,
          ref: r => {
            if (open) {
              this.childPanel = r;
            }
          },
          onScroll: this.killRunway
        }));
      }
    });
    return panels;
  }
  /**
   * Renders the footer that exists on all panels
   * @returns {React.ReactElement} div for the flyout footer
   */


  renderPanelFooter() {
    const {
      props
    } = this;
    const {
      bottomNav
    } = props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('product-flyout-footer')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container-fluid')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-md-7', 'product-flyout-legal')
    }, bottomNav && Array.isArray(bottomNav) && bottomNav.map((item, i) => {
      const {
        caption,
        title,
        href,
        id
      } = item;
      const text = caption || title;
      return text && href && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
        key: id || caption + i,
        href: href,
        urlArgs: props.urlArgs,
        onClicked: props.onClose,
        target: item.target,
        "data-eid": golf_to_eid_default()(caption || id, {
          prefix: 'uxp.hyd.product_panel',
          postfix: 'link.click'
        })
      }, renderCaption(text, !caption));
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-md-5', 'product-flyout-selectors-wrap')
    }, props.cornerContent))));
  }

  renderRunway() {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('product-flyout-runway-container', {
        show: this.state.runway
      }))
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_chevron_down_lt_default.a, {
      width: 15,
      height: 15
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_chevron_down_lt_default.a, {
      width: 15,
      height: 15
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_chevron_down_lt_default.a, {
      width: 15,
      height: 15
    }));
  }

  render() {
    const {
      props,
      state
    } = this;
    const parentPanelOpen = state.open && !state.showChildPanel;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.classNames(props.controlWrapperClass, this.namespace('product-flyout-btn-wrap'), {
        [this.namespace('is-open')]: state.open
      })
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.productPanel
    }, productPanelTxt => /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      "data-eid": "uxp.hyd.product_panel_control.button.click",
      onClick: this.toggleOpen,
      title: productPanelTxt,
      "aria-haspopup": true,
      "aria-expanded": state.open,
      className: this.namespace('product-flyout-btn'),
      ref: this.control
    }, props.control))), this.renderBackground(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('product-flyout-menu', {
        open: state.open
      }))
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.close
    }, closeTxt => /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      onClick: this.close,
      className: this.namespace('close'),
      "aria-label": closeTxt,
      tabIndex: state.open ? void 0 : -1
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(parent_panel, extends_default()({
      onClose: this.close,
      open: parentPanelOpen,
      tabIndex: parentPanelOpen ? void 0 : -1,
      onParentClick: this.setSelected,
      ref: r => {
        if (parentPanelOpen) {
          this.parentPanel = r;
          r && r.focusFirst();
        }
      },
      onScroll: this.killRunway
    }, props)), this.renderChildPanels(props.discoverNav, this.namespace('discover-child-panel')), this.renderChildPanels(props.productNav, this.namespace('product-child-panel')), this.renderPanelFooter(), this.renderRunway())));
  }

}
src_ProductPanel.propTypes = product_panel_src_objectSpread(product_panel_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  productNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object).isRequired,
  discoverNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object).isRequired,
  bottomNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object),
  cartProps: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  control: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element,
  controlWrapperClass: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  cornerContent: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element,
  globalElements: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    notifications: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element, external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool]),
    accountTray: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    cart: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    help: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
  }), external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool]),
  isInGoCohort: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  onClick: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

src_ProductPanel.defaultProps = {
  isInGoCohort: false,
  loggedIn: false,
  eidPrefix: 'uxp.hyd.product_panel_nav',
  market: 'en-US',
  control: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(grid_horizontal_default.a, {
    width: 18,
    height: 18
  })
};
/* harmony default export */ var product_panel_src = (Object(namespace_component_["withNamespace"])(src_ProductPanel));
// CONCATENATED MODULE: ./node_modules/@ux/popover/src/index.js


function popover_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function popover_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { popover_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { popover_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
* Display popover content when click on the control component
*
* @displayName PopOver (Web)
* @class PopOver
* @public
*/

class src_PopOver extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      alignment: props.popoverAlignment,
      controllerWidth: 0,
      caretStyleLeft: 0
    };
    this.mounted = false;
    this.toggle = this.toggle.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onHover = this.onHover.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
  }
  /**
   * Open the popover by setting open to true
   *
   * @public
   */


  open() {
    if (!this.mounted) return;
    this.setState({
      open: true
    }, () => this.props.onToggle(true));
  }
  /**
   * Close the popover by setting open to false
   *
   * @public
   */


  close() {
    if (!this.mounted) return;
    this.setState({
      open: false
    }, () => this.props.onToggle(false));
  }
  /**
   * Toggle the popover based on current state of open
   *
   * @private
   */


  toggle() {
    const next = this.state.open;
    next ? this.close() : this.open();
  }
  /**
   * Hide the dropdown if clicks are outside the popover itself.
   */


  componentDidMount() {
    this.mounted = true;
    this.clickHandler = this.outside('click', this.close, this.contentWrapper);
    this.focusInHandler = this.outside('focusin', this.close, this.contentWrapper);
    const alignment = this.getAlignment();
    this.setState({
      alignment
    }, () => this.calculateCaretPosition());
  }
  /**
   * Remove the attached click event listener.
   */


  componentWillUnmount() {
    this.mounted = false;
    this.off('click', this.clickHandler);
    this.off('focusin', this.focusInHandler);
  }
  /**
   * Check if the open prop has changed.
   * If so, update state of open.
   *
   * @param {Object} prevProps - previous instance of props
   * @param {Object} prevState - previous instance of state
   */


  componentDidUpdate(prevProps, prevState) {
    const {
      open
    } = this.state;
    const {
      popoverAlignment
    } = this.props;

    if (popoverAlignment && popoverAlignment !== prevProps.popoverAlignment) {
      this.setState({
        alignment: popoverAlignment
      });
    } else if (open && open !== prevState.open) {
      const alignment = this.getAlignment();

      if (alignment !== prevState.alignment) {
        this.setState({
          alignment
        }, () => this.calculateCaretPosition());
      }
    }

    if (prevProps.open !== this.props.open && this.state.open !== this.props.open) {
      this.setState({
        open: this.props.open
      });
    }

    if (prevState.controllerWidth !== this.state.controllerWidth) {
      this.calculateCaretPosition();
    }
  }
  /**
   * Listen for the ESC key event.
   * @param {object} e the event object sent from the browser
   * @api private
   */


  handleEscape(e) {
    if (e.key && (e.key === 'Escape' || e.key === 'Esc')) {
      e.preventDefault();
      this.close();
    }
  }

  onHover(hovered) {
    if (!this.props.openOnHover) {
      return;
    }

    this.stopAutoHideTimer();

    if (hovered) {
      this.open();
    } else {
      this.autoHideTimerHandle = window.setTimeout(this.close, this.props.autoHideTimeout);
    }
  }
  /**
   * Stops (clears) auto hide timer
   *
   * @private
   */


  stopAutoHideTimer() {
    if (this.autoHideTimerHandle) {
      window.clearTimeout(this.autoHideTimerHandle);
      this.autoHideTimerHandle = null;
    }
  }
  /**
   * Fetches all element bounds to necessary calculations of display
   *
   * @private
   * @returns {object} element bounds
   */


  getElementBounds() {
    // Viewport Bounds
    const viewportBounds = {
      x: window.pageXOffset,
      y: window.pageYOffset,
      width: window.innerWidth,
      height: window.innerHeight
    }; // Wrapper Div for Popover

    const wrapperDivBounds = this.contentWrapper && this.contentWrapper.getBoundingClientRect(); // Popover Element

    const menuBounds = this.popoverElement && this.popoverElement.getBoundingClientRect();
    return {
      viewportBounds,
      wrapperDivBounds,
      menuBounds
    };
  }
  /**
   * Compute horizontal spacing for menu and determine whether to show aligned left or right to the popover.
   *
   * @returns {String|Boolean} The direction of alignment. False if neither left nor right.
   * @private
   */


  getAlignment() {
    let alignment = '';
    const {
      wrapperDivBounds,
      menuBounds,
      viewportBounds
    } = this.getElementBounds();

    if (wrapperDivBounds && menuBounds) {
      const right = wrapperDivBounds.left + viewportBounds.x - window.document.documentElement.clientLeft + menuBounds.width; // The element needs to be right aligned if it's too close or outside the bounds of the viewport
      // and if it is small enough to fit inside a viewport, if it's too big we'll default to left

      if (viewportBounds.width - right < 10 && menuBounds.width < viewportBounds.width) {
        alignment = 'right';
      } else {
        // otherwise align left
        alignment = 'left';
      }
    }

    return alignment;
  }
  /**
   * Calculate caret position based on controller element and alignment
   *
   * @private
   */


  calculateCaretPosition() {
    const controllerWidth = this.contentWrapper ? this.contentWrapper.getBoundingClientRect().width : void 0;
    const result = {
      controllerWidth
    }; // Remark: (right|left)Style = (controllerWidth/2) - (caretWidth/2)

    result.caretPosition = controllerWidth / 2 - 8;
    this.setState(result);
  }
  /**
   * Render a properly positioned caret
   *
   * @returns {ReactElement} PopOver element.
   * @private
   */


  renderCaret() {
    const {
      caretPosition,
      alignment
    } = this.state;
    const styles = {};

    if (caretPosition) {
      styles[alignment] = caretPosition;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('content-caret'),
      style: styles
    });
  }
  /**
   * Render the control component within a button and the popover content children.
   *
   * @returns {ReactElement} PopOver element.
   * @private
   */


  render() {
    const {
      children,
      className,
      control,
      eid
    } = this.props;
    const {
      open,
      alignment
    } = this.state; // check that we are in viewport bounds && bidi?

    const alignClass = alignment === 'left' ? 'popover-align-left' : 'popover-align-right'; // Don't namespace the incoming `props.className` -- the parent component should do so

    const wrapperClassNames = this.classNames(this.namespace(this.classNames('popover', {
      open
    })), alignClass, className);
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapperClassNames,
      "data-eid": eid,
      ref: r => {
        this.contentWrapper = r;
      },
      onMouseEnter: () => this.onHover(true),
      onMouseLeave: () => this.onHover(false),
      onKeyUp: this.handleEscape,
      role: "presentation"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      type: "button",
      onClick: this.toggle,
      tabIndex: "0",
      className: this.namespace('popover-button')
    }, control), this.renderCaret(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('content'),
      ref: r => {
        this.popoverElement = r;
      }
    }, children));
  }

}
src_PopOver.propTypes = popover_src_objectSpread(popover_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  /** The number of milliseconds before popover auto-hides (use in tandem w/ openOnHover) */
  autoHideTimeout: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,

  /** Customized class name */
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,

  /** Control component for button render  */
  control: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element,

  /** Toggle handler for when popover is opened or closed */
  onToggle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,

  /** eid to be used for the traffic tracking */
  eid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,

  /** Allows consumer to open or close the popover */
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,

  /** Flag dictating if popover should open on hover */
  openOnHover: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,

  /** Aligns popover on left or right */
  popoverAlignment: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['left', 'right'])
});
src_PopOver.defaultProps = {
  autoHideTimeout: 75,
  onToggle: () => {},
  open: false,
  openOnHover: false,
  popoverAlignment: 'left'
};
/* harmony default export */ var popover_src = (Object(namespace_component_["withNamespace"])(src_PopOver));
// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    var newArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);
// CONCATENATED MODULE: ./node_modules/@ux/header-navigation/src/index.js



function header_navigation_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function header_navigation_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { header_navigation_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { header_navigation_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











const src_isDataAttr = /^data-[a-zA-Z0-9-]+$/;
/**
 * Mapping of the margins used on nav items in various breakpoints
 */

const navItemMargins = {
  tablet: 16,
  desktop: 24,
  large: 32
};
/**
 * @typedef {object} Item
 * @prop {string|React.ReactElement} [title] The label of the item (may also be specified as caption)
 * @prop {string} [caption] The label of the item (may also be specified as title)
 * @prop {string} [href] The URL to link the item to
 * @prop {React.MouseEventHandler} [onClick] A click event handler to run when the item is clicked
 * @prop {string} [className] A CSS class name to apply to the item
 * @prop {string} [target] The HTML target value to apply to the item
 * @prop {string} [id] A unique identifier for the item
 * @prop {string} [eid] The analytics EID to apply to the item
 * @prop {string} [icon] An icon name to use alongside the item label
 * @prop {boolean} [active] Whether the item is currently active
 * @prop {object} [dataAttrs] A set of data-* attributes to apply to the item
 * @prop {boolean} [mobileOnly] Whether the item should only show in a mobile view (and thus excluded from this nav)
 * @prop {Item[]} [children] An array of children Items
 */

/**
 * @typedef {object} ItemWithDesign
 * @prop {string} [design] The button design to use on the right-side button item
 */

/**
 * @typedef {Item & ItemWithDesign} RightItem
 */

/**
 * Generic header navigation component
 *
 * @public
 */

class src_HeaderNavigation extends namespace_component_["NamespaceConsumer"] {
  /**
   * Constructor for HeaderNavigation component
   *
   * @param {object} props Props for the component
   * @constructor
   * @public
   */
  constructor(props) {
    super(...arguments);
    this.setDataAttrs = this.setDataAttrs.bind(this);
    this.closeNavTrays = this.closeNavTrays.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.trayMenus = Object.create(null); // For scaling logic

    this.itemRefs = Object.create(null);
    this.containerRef = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createRef();
    this.lastMoreIndexBuilt = null;
    this.moreMenuChildren = null;
    this.measurements = Object.create(null);
    this.resizeTimeoutId = null;
    this.state = {
      visible: !props.scale,
      firstMoreItemIndex: null
    };
    this.getItems = memoize_one_esm(items => items.map(this.setDataAttrs));
  }
  /**
   * React lifecycle method called after initial mount of the component
   *
   * @private
   */


  componentDidMount() {
    const {
      scale,
      items
    } = this.props;

    if (scale) {
      if (items.length) {
        this.measure();
        this.scale(true);
      }

      this.attachResizeHandler();
      this.breakpoint('tablet', 'desktop', 'large');
    }
  }
  /**
   * React lifecycle method called after any updates to component props or state
   *
   * @param {object} prevProps Previous props prior to the update
   * @param {object} prevState Previous state prior to the update
   * @private
   */


  componentDidUpdate(prevProps, prevState) {
    const {
      scale,
      items
    } = this.props;
    if (scale && !prevProps.scale) this.attachResizeHandler();
    if (!scale && prevProps.scale) this.detachResizeHandler();

    if (scale && items.length && this.didScaleRelevantDataChange(prevProps, prevState)) {
      this.lastMoreIndexBuilt = null;
      this.moreMenuChildren = null;
      this.scale();
    }
  }
  /**
   * React lifecycle method called before unmount of the component
   *
   * @private
   */


  componentWillUnmount() {
    this.detachResizeHandler();
    this.breakup();
  }
  /**
   * Attach the window resize handler if we're in a browser
   *
   * @private
   */


  attachResizeHandler() {
    if (!this.isBrowser) return;
    this.on('resize', this.handleResize);
  }
  /**
   * Detach the window resize handler if we're in a browser
   *
   * @private
   */


  detachResizeHandler() {
    if (!this.isBrowser) return;
    this.off('resize', this.handleResize);
  }
  /**
   * Handle a resize event
   *
   * This method includes debouncing logic to ensure that we only react to resize events after a user has paused
   * dragging for at least 100ms
   * @private
   */


  handleResize() {
    // Resize events will be continually sent as a user drags their browser edge, so we need to debounce this a bit.
    if (this.resizeTimeoutId) {
      clearTimeout(this.resizeTimeoutId);
    } else {
      // Initial resize event -- we should close menus & set resizing class
      this.closeNavTrays();
      this.setState({
        resizing: true
      });
    }

    const self = this;
    this.resizeTimeoutId = setTimeout(() => {
      self.resizeTimeoutId = null;
      self.setState({
        resizing: false
      });

      if (self.containerRef.current && self.containerRef.current.offsetWidth !== self.measurements.container) {
        // Container width changed -- must scale
        self.measureContainer();
        self.scale();
      }
    }, 100);
  }
  /**
   * Determine whether a component update changed any props or state that are relevant to scaling logic. That is,
   * changes that would necessitate re-measuring and scaling items
   *
   * @param {object} prevProps Previous props prior to the update
   * @param {object} prevState Previous state prior to the update
   * @returns {boolean} true if a change occurred that necessitates re-measuring/scaling, false otherwise
   * @private
   */


  didScaleRelevantDataChange(prevProps, prevState) {
    const newProps = this.props;
    const newState = this.state;
    const {
      items: prevItems
    } = prevProps;
    const {
      items: newItems
    } = newProps;
    const {
      breakpoint: prevBreakpoint
    } = prevState;
    const {
      breakpoint: newBreakpoint
    } = newState;
    return prevItems.length !== newItems.length || prevBreakpoint !== newBreakpoint || newItems.some((newItem, i) => {
      const prevItem = prevItems[i];
      return prevItem.title !== newItem.title || // title changed
      prevItem.caption !== newItem.caption || // caption changed
      prevItem.icon !== newItem.icon || // icon changed
      // whether the item has children or not changed
      (prevItem.children && !!prevItem.children.length) !== (newItem.children && !!newItem.children.length);
    });
  }
  /**
   * Measure the main container element (UL) and all item elements (LIs) and store their sizes
   *
   * @private
   */


  measure() {
    this.measureContainer();

    for (const itemRefKey in this.itemRefs) {
      // eslint-disable-line guard-for-in
      if (this.itemRefs[itemRefKey]) {
        this.measurements[itemRefKey] = this.itemRefs[itemRefKey].offsetWidth;
      }
    }
  }
  /**
   * Measure the main container element (UL)
   *
   * @public
   */


  measureContainer() {
    if (!this.containerRef || !this.containerRef.current) return;
    this.measurements.container = this.containerRef.current.offsetWidth;
  }
  /**
   * Calculate whether all items will fit in the available container width and scale any overflowing items into a More
   * menu as needed.
   *
   * @param {boolean} [shouldMakeVisible=false] Whether to set the `visible` state flag after scaling, defaults to
   *  false
   * @private
   */
  // eslint-disable-next-line max-statements


  scale(shouldMakeVisible) {
    // Get the nav item margin being used
    const navItemMargin = navItemMargins[this.state.breakpoint] || navItemMargins.large;
    const allItemsWidth = Object.keys(this.measurements).reduce((acc, key) => {
      if (key !== 'more' && key !== 'container') acc += this.measurements[key] + navItemMargin;
      return acc;
    }, 0); // Default to showing all items

    let firstMoreItemIndex = null;
    const {
      container: containerWidth,
      more: moreMenuWidth
    } = this.measurements; // If not all items will fit, find how many will

    if (allItemsWidth > containerWidth) {
      // Start with full width available
      let spaceRemaining = containerWidth; // Since we know we'll scale at least 1 item to More menu, we must subtract the more menu width

      spaceRemaining -= moreMenuWidth + navItemMargin;
      firstMoreItemIndex = 0;

      while (firstMoreItemIndex < this.props.items.length) {
        if (spaceRemaining - (this.measurements[firstMoreItemIndex] + navItemMargin) > 0) {
          // Item fits
          spaceRemaining -= this.measurements[firstMoreItemIndex] + navItemMargin;
          firstMoreItemIndex++;
        } else {
          break;
        }
      }
    }

    const newState = {
      firstMoreItemIndex
    };
    if (shouldMakeVisible) newState.visible = true;
    this.setState(newState);
  }
  /**
   * Close all navigation menus
   *
   * @private
   */


  closeNavTrays() {
    for (const menu in this.trayMenus) {
      // eslint-disable-line guard-for-in
      if (this.trayMenus[menu]) {
        this.trayMenus[menu].close();
      }
    }
  }
  /**
   * Function to call when clicking an item.
   *
   * @param {Item} item The item containing a custom onClick function
   * @param {React.MouseEvent} event The click event
   * @private
   */


  onItemClick(item, event) {
    if (item.onClick) {
      item.onClick(event);
    }

    this.closeNavTrays();
  }
  /**
   * Sets a dataAttrs field containing all the `data-` attributes on a given item.
   *
   * @param {Item} item A navigation item
   * @returns {Item} The updated navigation item with a `dataAttrs` field
   * @private
   */


  setDataAttrs(item) {
    if (!item) return;
    item.dataAttrs = Object.keys(item).reduce(function (acc, k) {
      if (src_isDataAttr.test(k)) {
        acc[k] = item[k];
      }

      return acc;
    }, {});

    if (item.children) {
      item.children.forEach(this.setDataAttrs);
    }

    return item;
  }
  /**
   * Determine whether an item has an existing eid, or if one should be generated.
   *
   * @param {object} item object from the passed via the  props.items array
   * @param {string} postfix postfix to be applied if an eid must be generated
   * @returns {string} the found or generated eid
   * @private
   */


  generateEid(item = {}, postfix = '') {
    if (item.eid) {
      return item.eid;
    }

    if (!item.id) {
      return;
    }

    const prefix = this.props.eidPrefix;
    return golf_to_eid_default()(item.id, {
      prefix,
      postfix
    });
  }
  /**
   * Render a uxicon.
   *
   * @param {string} classname The classname corresponding to the uxicon
   * @returns {React.ReactElement} Span containing a uxicon
   * @private
   */


  renderNavIcon(classname) {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace(classname, 'icon', 'uxicon')
    });
  }
  /**
   * Render a column of nav items. Used inside of a multi-column tray.
   * @param  {Item} item Navigation item whose children to render in a column
   * @param  {string} key The key for the heading list elements
   * @returns {React.ReactElement[]} Array of list elements containing a heading and links
   */


  renderColumn(item, key) {
    if (item.mobileOnly) {
      return null;
    }

    const columnItems = []; // push the heading for the column if there is one

    if (item.caption || item.title) {
      columnItems.push( /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", extends_default()({
        key: key,
        className: this.namespace('heading', 'title', 'small')
      }, item.dataAttrs), item.caption || item.title, item.icon && this.renderNavIcon(item.icon)));
    } // then push the links


    for (let i = 0; i < item.children.length; i++) {
      const childItem = item.children[i];

      if (childItem.mobileOnly) {
        // eslint-disable-next-line no-continue
        continue;
      }

      columnItems.push(this.renderSingleLink(childItem, (childItem.caption || childItem.id || key) + '_' + i));
    }

    return columnItems;
  }
  /**
   * Render a single nav item. Used inside of a single column tray.
   * @param  {Item} item Navigation item to render
   * @param  {string} key The key for each list element
   * @returns {React.ReactElement} List element containing a @ux/link
   */


  renderSingleLink(item, key) {
    const classNames = this.classNames(item.className, this.namespace(this.classNames({
      active: item.active
    })));

    const props = header_navigation_src_objectSpread({
      'className': classNames,
      'target': item.target,
      'id': item.id,
      'href': item.href || '#',
      'data-eid': this.generateEid(item, 'link.click'),
      'onClicked': e => {
        this.onItemClick(item, e);
      }
    }, item.dataAttrs);

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      key: key,
      className: props.className
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({}, props, {
      urlArgs: this.props.urlArgs
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, item.caption || item.title, item.icon && this.renderNavIcon(item.icon))));
  }
  /**
   * Create a list with all nested data structures
   * rendered appropriately.
   *
   * @param {object} navItem the parent nav item of a collection of columns
   * @param {boolean} [multi] True if the nav structure is multi-column
   * @returns {React.ReactElement} Columns
   * @private
   */


  renderColumns(navItem, multi) {
    if (multi) {
      return navItem.children.map((child, k) => {
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", extends_default()({
          key: k,
          className: this.namespace('list-unstyled', 'nav-column')
        }, child.dataAttrs), this.renderColumn(child, k));
      });
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", extends_default()({
      className: this.namespace('list-unstyled', 'nav-column')
    }, navItem.dataAttrs), navItem.children.map((child, k) => {
      if (child.mobileOnly) {
        return null;
      }

      return this.renderSingleLink(child, k);
    }));
  }
  /**
   * Determines if the root navigation's structure is multi- or single columned
   *
   * @param {Item} navItem the root node of the nav structure
   * @returns {boolean} true if multi column
   * @private
   */


  isMultiColumn(navItem) {
    return navItem.children && navItem.children.every(child => Array.isArray(child.children));
  }
  /**
   * Render items that appear on the right side of the navigation
   * @param  {RightItem} item Object containing details of the navigation item
   * @param  {React.ReactElement} icon Span containing a uxicon
   * @param  {number|string} i Index value
   * @returns {React.ReactElement} Either a button-link or a string of text
   * @private
   */


  renderNavRightItem(item, icon, i) {
    if (item.href) {
      const design = item.design || 'default';
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: i,
        className: this.namespace('nav-item', 'right-button')
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, extends_default()({
        design: design,
        size: "small",
        id: item.id,
        href: item.href,
        target: item.target,
        onClick: item.onClick,
        "data-eid": item.eid
      }, item.dataAttrs), icon, item.caption));
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      key: i,
      className: this.namespace('nav-item', 'right-text')
    }, item.caption);
  }
  /**
   * Render some of the navigation items
   *
   * @param {Item[]} items Navigation items
   * @param {number} [howMany] How many items to render
   * @returns {React.ReactElement[]} Rendered items
   */


  renderSomeItems(items, howMany) {
    const result = [];
    if (!howMany && howMany !== 0) howMany = items.length;

    for (let i = 0; i < howMany; i++) {
      result.push(this.renderItem(items[i], i));
    }

    return result;
  }
  /**
   * Render a navigation item
   *
   * @param {Item} item nav item
   * @param {number|string} i index value
   * @returns {React.ReactElement} ReactElement
   * @private
   */


  renderItem(item, i) {
    const props = this.props;

    if (item.mobileOnly) {
      return null;
    }

    const classNames = this.classNames(this.namespace(this.classNames('nav-item', {
      active: item.active
    })), item.className);
    let icon;

    if (item.icon) {
      icon = this.renderNavIcon(item.icon);
    } //
    // Render a tray-menu if the current item has children regardless of side
    //


    if (item.children && item.children.length) {
      const multiColumn = this.isMultiColumn(item);
      const columns = this.renderColumns(item, multiColumn);
      const trayTitle = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, item.caption || item.title, icon, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_chevron_down_lt_default.a, null));
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        className: classNames,
        key: i,
        ref: r => {
          this.itemRefs[i] = r;
        }
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(popover_src, extends_default()({
        ref: r => {
          this.trayMenus[i] = r;
        },
        className: this.namespace(this.classNames({
          'multi-col': multiColumn
        })),
        control: trayTitle,
        eid: this.generateEid(item, 'popover.click'),
        openOnHover: true
      }, item.dataAttrs), props.showTitleInsideTray && trayTitle, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('flex-columns')
      }, columns)));
    } // if no children, handle rendering for right side


    if (props.side === 'right') {
      return this.renderNavRightItem(item, icon, i);
    } // handle render for left side


    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      key: i,
      className: classNames,
      ref: r => {
        this.itemRefs[i] = r;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      className: this.namespace('nav-link', 'font-base', 'single-parent-link'),
      id: item.id,
      href: item.href || '#',
      target: item.target,
      onClicked: item.onClick,
      "data-eid": this.generateEid(item, 'link.click'),
      urlArgs: props.urlArgs
    }, item.dataAttrs), item.caption || item.title, icon));
  }
  /**
   * Render the More menu in a scaling nav
   *
   * @param {Item[]} allItems The full collection of items to be displayed (not just in the More menu)
   * @returns {React.ReactElement} The More menu React element
   * @private
   */


  renderMoreMenu(allItems) {
    const {
      firstMoreItemIndex,
      visible
    } = this.state;
    if (visible && (firstMoreItemIndex === null || firstMoreItemIndex >= allItems.length)) return null;
    const moreItem = this.getMoreMenuItem(allItems);
    return this.renderItem(moreItem, 'more');
  }
  /**
   * Get the Item object to describe the More menu
   *
   * @param {Item[]} allItems The full collection of items to be displayed (not just in the More menu)
   * @returns {Item} An Item object representing the More menu
   * @private
   */


  getMoreMenuItem(allItems) {
    const {
      moreMenuEid
    } = this.props;
    return {
      children: this.getMoreItemChildren(allItems),
      title: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:HeaderNavigation:More"
      }),
      eid: moreMenuEid,
      className: 'more-menu'
    };
  }
  /**
   * Get the children that should appear in the More menu - from pre-cached copy if available
   *
   * @param {Item[]} allItems All of the menu items
   * @returns {Item[]} An array of nav items for the items that should appear in the More menu
   * @private
   */


  getMoreItemChildren(allItems) {
    const {
      firstMoreItemIndex,
      visible
    } = this.state;

    if (!visible) {
      // The menu is not visible -- this is just for scaling before initial render. So we can just toss in a dummy link
      return [{
        title: 'Dummy link for scaling',
        href: '#'
      }];
    }

    if (this.lastMoreIndexBuilt === firstMoreItemIndex && this.moreMenuChildren) {
      return this.moreMenuChildren;
    }

    this.lastMoreIndexBuilt = firstMoreItemIndex;

    if (firstMoreItemIndex === null || firstMoreItemIndex >= allItems.length) {
      this.moreMenuChildren = [];
    } else {
      this.moreMenuChildren = this.buildMoreItemChildren(allItems, firstMoreItemIndex);
    }

    return this.moreMenuChildren;
  }
  /**
   * Build the More menu children array
   *
   * @param {Item[]} allItems All of the menu items
   * @param {number} firstMoreItemIndex The index of the first item to show in the More menu
   * @returns {Item[]} An array of nav items for the items that should appear in the More menu
   * @private
   */


  buildMoreItemChildren(allItems, firstMoreItemIndex) {
    const allMoreChildren = allItems.slice(firstMoreItemIndex);
    const moreChildrenLinks = [];
    const moreChildrenMenus = [];

    for (const moreChild of allMoreChildren) {
      if (moreChild.children && moreChild.children.length) {
        moreChildrenMenus.push(moreChild);
      } else {
        moreChildrenLinks.push(moreChild);
      }
    }

    if (moreChildrenMenus.length) {
      if (moreChildrenLinks.length) {
        return [{
          title: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
            id: "Shared:HeaderNavigation:More"
          }),
          children: moreChildrenLinks
        }, ...moreChildrenMenus];
      }

      return moreChildrenMenus;
    }

    return moreChildrenLinks;
  }
  /**
   * Render the navigation component
   *
   * @returns {React.ReactElement} ReactElement
   */


  render() {
    const props = this.props;
    const allItems = this.getItems(props.items);

    if (!allItems.length) {
      return null;
    }

    const {
      firstMoreItemIndex,
      visible,
      resizing
    } = this.state;
    const visibleItems = this.renderSomeItems(allItems, firstMoreItemIndex); // Note: we need to ensure that the nav is not display:none during the initial hidden scaling measurements. So we
    // only set the d-none class if we're rendering visible.

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('flex-row', 'd-lg-flex', visible && 'd-none', 'header-nav-wrap')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("nav", {
      className: this.namespace('header-nav')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('nav', "nav-".concat(props.side), !visible && 'invisible-header-nav', resizing && 'resizing'),
      ref: this.containerRef
    }, visibleItems, props.scale && this.renderMoreMenu(allItems)))));
  }

}

src_HeaderNavigation.defaultProps = {
  side: 'left',
  eidPrefix: 'uxp.hyd',
  items: [],
  showTitleInsideTray: false,
  scale: false
};
src_HeaderNavigation.propTypes = header_navigation_src_objectSpread(header_navigation_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  showTitleInsideTray: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  side: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['left', 'right']),
  scale: validateScalePropType,
  moreMenuEid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  items: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array.isRequired,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});

function validateScalePropType(props, propName, componentName) {
  if (typeof props[propName] !== 'boolean') {
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Expected boolean value. Validation failed.');
  }

  if (props[propName] && props.side === 'right') {
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Scaling is not supported on right-side menus. Validation failed.');
  }
}

/* harmony default export */ var header_navigation_src = (Object(namespace_component_["withNamespace"])(src_HeaderNavigation));
// CONCATENATED MODULE: ./node_modules/@ux/logo/src/index.js



function logo_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function logo_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { logo_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { logo_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





 // Regex for whitespace and non-typographical unicode characters
// eslint-disable-next-line no-control-regex

const WHITESPACE_REGEX = /[\s\u0000-\u001F\u007F-\u009F]/g;
/**
 * Add query parameters from props to the url.
 *
 * @param {String} url link.
 * @param {Object} props Properties to merge with the query parameters object.
 * @returns {String} Configured url.
 * @private
 */

function updateQuery(url, props) {
  url = new util_["URL"](url, true);
  return url.set('query', logo_src_objectSpread(logo_src_objectSpread({}, url.query), props)).href;
}
/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} shared logo
 * @public
 */


class src_LogoComponent extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(props); // Some Logo consumers setup breakpoints themselves and will trigger
    // corresponding re-renders of the Logo. But for those that don't, Logo
    // needs to setup breakpoints on its own. This prevents spurious re-renders
    // when consumed by an already-breakpoint-sensitive component.

    this.shouldConfigureBreakpoints = typeof props.isMobile !== 'boolean';
  }
  /**
   * Check if breakpoint is mobile. (Respects `shouldConfigureBreakpoints`.)
   *
   * @returns {Boolean} Mobile or not.
   * @private
   */


  get _isMobile() {
    return this.shouldConfigureBreakpoints ? this.isMobile : this.props.isMobile;
  }
  /**
   * Get the logo URL for the current breakpoint.
   *
   * @returns {String} Logo URL.
   * @private
   */


  get _logo() {
    const {
      logos
    } = this.props;
    const url = logos && (this._isMobile ? logos.mobile : logos.desktop) || '';
    return url.replace(WHITESPACE_REGEX, '');
  }

  componentDidMount() {
    if (this.shouldConfigureBreakpoints) {
      this.breakpoint('mobile', 'phablet', 'tablet', 'desktop', 'large');
    }
  }

  componentWillUnmount() {
    if (this.shouldConfigureBreakpoints) {
      this.breakup();
    }
  }
  /**
   * Return elements for rendering a reseller logo
   * @param {String} imgSrc Logo source url
   * @returns {ReactElement} Part of the shared logo
   * @api private
   */


  resellerLogo() {
    const {
      spanClass,
      privateLabelName
    } = this.props;
    const imgSrc = this._logo; //
    // If no URL for a custom logo has been provided then display
    // the name of the private label.
    //

    if (!imgSrc) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        id: "registrar",
        className: this.namespace('logo-text')
      }, privateLabelName);
    } // To prevent SVGs from rendering 0x0, set an arbitrarily large enough width
    // to cover the max-width of the span. Only appropriate for SVGs because
    // other image types would stretch if their aspect ratio is narrower than
    // the span's.


    const svgHack = /\.svg$/.test(imgSrc) && {
      width: 200
    };
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.classNames(this.namespace('logo-img'), spanClass)
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", extends_default()({
      id: "registrar",
      src: encodeURI(imgSrc),
      alt: privateLabelName
    }, svgHack)));
  }
  /**
   * Work around for `sinon@7`/lolex having issues faking timers.
   * Context
   *
   * @returns {number} number of milliseconds since epoch (same as `Date.now()`)
   */


  getDateNow() {
    return Date.now();
  }
  /**
   * Return elements for rendering the temporary GoDaddy logo for culture campaigns
   *
   * @param {Object} tempLogo from props
   * @param {String} tempLogo.filename the name of the file to be retrieved from CDN
   * @param {Object} tempLogo.start the starting date of the campaign
   * @param {Object} tempLogo.end the ending date of the campaign
   * @param {Object} tempLogo.styles the styles to be applied
   * @returns {ReactElement} The temp logo
   */


  renderTempLogo({
    filename,
    start,
    end,
    styles = {},
    altText = ''
  }) {
    const props = this.props;

    const convertToDateObject = ({
      year,
      month,
      day,
      hour = null
    }) => {
      // subtract 1 from the month since Date months are indexed from 0
      return new Date(year, month - 1, day, hour);
    };

    const startDate = convertToDateObject(start);
    const endDate = convertToDateObject(end);
    const now = this.getDateNow();

    if (startDate < now && now < endDate) {
      const cdn = "".concat(props.urls.cdn.href, "ux/sales-header/");
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: props.spanClass,
        "aria-label": "GoDaddy"
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", {
        alt: altText,
        src: "".concat(cdn).concat(filename),
        onError: e => {
          e.target.onError = null; // default logo fallback
          // TODO: update default logo fallback

          e.target.src = "".concat(cdn, "gd-logo.svg");
          e.target.style = null;
        },
        style: styles
      }));
    }

    return this.renderGoLogo();
  }

  renderGoLogo() {
    const props = this.props; // NOTE: `sr-only` is a bootstrap classname and cannot be namespaced

    const srClasses = this.classNames('sr-only', this.namespace('sr-logo'));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.classNames(this.namespace('mobile-logo'), this.namespace('go-logo'), props.spanClass),
      "aria-label": "GoDaddy"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: srClasses
    }, "GoDaddy"), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("svg", {
      className: this.namespace('svg-fill-black'),
      viewBox: "0 0 36 32",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("path", {
      d: "M30.824 1.453c-3.713-2.316-8.603-1.77-12.963.972-4.347-2.74-9.239-3.288-12.948-.972C-.955 5.12-1.667 14.564 3.32 22.546c3.677 5.887 9.428 9.335 14.548 9.271 5.119.064 10.87-3.384 14.547-9.27C37.4 14.563 36.692 5.12 30.824 1.452zM6.02 20.863a19.112 19.112 0 01-2.303-5.273 15.067 15.067 0 01-.5-4.97C3.44 7.673 4.64 5.375 6.598 4.15c1.957-1.224 4.544-1.295 7.299-.203.419.169.829.358 1.228.568a22.496 22.496 0 00-3.956 4.754C8.14 14.116 7.215 19.511 8.272 23.81a19.723 19.723 0 01-2.253-2.947zm26.003-5.273a19.158 19.158 0 01-2.302 5.272 19.733 19.733 0 01-2.254 2.954c.946-3.855.303-8.576-2.014-13.005a.583.583 0 00-.837-.228l-7.225 4.515a.59.59 0 00-.188.813l1.06 1.695a.59.59 0 00.814.188l4.683-2.925c.151.454.303.901.416 1.363.442 1.617.611 3.297.5 4.97-.223 2.95-1.424 5.247-3.38 6.471a6.607 6.607 0 01-3.35.97h-.15a6.599 6.599 0 01-3.35-.97c-1.958-1.224-3.159-3.521-3.381-6.472-.11-1.672.058-3.352.5-4.969a19.671 19.671 0 016.03-9.65 15.108 15.108 0 014.241-2.629c2.748-1.092 5.34-1.02 7.298.203 1.958 1.224 3.157 3.522 3.38 6.47a15.105 15.105 0 01-.49 4.964zM27.89 30.386v-.21c0-.015.005-.03.015-.04a.048.048 0 01.038-.015h1.342c.014-.001.028.004.038.015.01.01.016.025.015.04v.21a.051.051 0 01-.015.04.048.048 0 01-.038.014h-.49v1.322a.05.05 0 01-.017.04.051.051 0 01-.038.017h-.253a.055.055 0 01-.038-.017.06.06 0 01-.015-.04V30.44h-.49a.048.048 0 01-.039-.015.051.051 0 01-.015-.04zm2.345-.217l.374.848.375-.848a.073.073 0 01.03-.036.08.08 0 01.05-.012h.4a.051.051 0 01.053.053v1.592a.056.056 0 01-.013.037.05.05 0 01-.037.016h-.24a.055.055 0 01-.038-.016.056.056 0 01-.015-.037v-1.203l-.393.874a.09.09 0 01-.03.04.086.086 0 01-.05.013h-.194a.085.085 0 01-.048-.012.09.09 0 01-.03-.041l-.393-.874v1.203a.05.05 0 01-.015.037.053.053 0 01-.036.016h-.243a.05.05 0 01-.036-.016.056.056 0 01-.015-.037v-1.592a.05.05 0 01.017-.038.047.047 0 01.036-.015h.413a.083.083 0 01.049.012.071.071 0 01.029.036z"
    }))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.classNames(this.namespace('desktop-logo'), this.namespace('go-logo'), props.spanClass),
      "aria-label": "GoDaddy"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: srClasses
    }, "GoDaddy"), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("svg", {
      className: this.namespace('svg-fill-black'),
      viewBox: "0 0 166 34",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("path", {
      d: "M32.937 1.554c-3.968-2.48-9.193-1.889-13.852 1.039C14.44-.335 9.213-.925 5.25 1.553c-6.27 3.919-7.032 14.01-1.701 22.54 3.93 6.289 10.074 9.974 15.544 9.906 5.47.068 11.615-3.617 15.545-9.906 5.324-8.53 4.568-18.621-1.701-22.54zM6.43 22.292a20.434 20.434 0 01-2.46-5.632 16.104 16.104 0 01-.534-5.31c.238-3.153 1.521-5.608 3.612-6.914s4.855-1.385 7.8-.217c.441.177.878.38 1.312.606a24.09 24.09 0 00-4.228 5.081C8.697 15.086 7.71 20.848 8.84 25.443a20.911 20.911 0 01-2.408-3.151zm27.786-5.634a20.482 20.482 0 01-2.46 5.632 21.1 21.1 0 01-2.408 3.158c1.01-4.12.324-9.165-2.153-13.897a.625.625 0 00-.895-.243l-7.72 4.823a.631.631 0 00-.2.87l1.133 1.811a.63.63 0 00.869.2l5.004-3.126c.162.486.324.971.445 1.457a16.1 16.1 0 01.536 5.303c-.238 3.151-1.521 5.606-3.612 6.914a7.06 7.06 0 01-3.579 1.036h-.16a7.051 7.051 0 01-3.578-1.036c-2.093-1.308-3.376-3.763-3.614-6.914a16.143 16.143 0 01.534-5.31 21.015 21.015 0 016.444-10.314 16.137 16.137 0 014.532-2.806c2.936-1.168 5.705-1.09 7.797.217 2.093 1.308 3.375 3.761 3.613 6.914a16.145 16.145 0 01-.528 5.311zm39.848-3.766c-4.06 0-7.34 3.169-7.34 7.2 0 4.004 3.28 7.121 7.34 7.121 4.086 0 7.366-3.112 7.366-7.12 0-4.03-3.275-7.2-7.366-7.2zm0 10.557c-1.871 0-3.295-1.513-3.295-3.384s1.424-3.407 3.295-3.407c1.898 0 3.322 1.54 3.322 3.412 0 1.87-1.424 3.385-3.322 3.385zM90.583 7.362h-7.468a.6.6 0 00-.61.612v18.208a.605.605 0 00.61.648h7.468c5.977 0 10.13-3.975 10.13-9.758 0-5.818-4.153-9.71-10.13-9.71zm.177 15.622h-4.087V11.198h4.087c3.308 0 5.588 2.474 5.588 5.866 0 3.336-2.28 5.92-5.588 5.92zm24.82-9.7h-2.809a.633.633 0 00-.582.612v.833c-.64-1.057-2.085-1.835-3.884-1.835-3.503 0-6.783 2.751-6.783 7.145 0 4.37 3.251 7.171 6.755 7.171 1.806 0 3.28-.777 3.92-1.834v.861a.587.587 0 00.582.585h2.808a.571.571 0 00.584-.585V13.896a.594.594 0 00-.592-.612zm-6.533 10.196c-1.86 0-3.256-1.43-3.256-3.412s1.397-3.41 3.256-3.41c1.86 0 3.257 1.426 3.257 3.408s-1.395 3.412-3.257 3.412zm22.294-16.118h-2.808a.592.592 0 00-.61.584v6.728c-.648-1.002-2.114-1.78-3.948-1.78-3.476 0-6.7 2.751-6.7 7.145 0 4.37 3.252 7.171 6.755 7.171 1.806 0 3.17-.777 3.92-1.834v.861c0 .322.261.583.583.585h2.808a.57.57 0 00.584-.585V7.95a.57.57 0 00-.584-.588zm-6.532 16.152c-1.852 0-3.237-1.444-3.237-3.448s1.39-3.447 3.237-3.447c1.846 0 3.237 1.444 3.237 3.447s-1.384 3.448-3.237 3.448zm22.29-16.152h-2.803a.594.594 0 00-.612.584v6.728c-.64-1.002-2.114-1.78-3.947-1.78-3.477 0-6.7 2.751-6.7 7.145 0 4.37 3.253 7.171 6.755 7.171 1.807 0 3.168-.777 3.92-1.834v.861a.587.587 0 00.584.585h2.803a.568.568 0 00.582-.585V7.95a.568.568 0 00-.582-.588zm-6.532 16.152c-1.853 0-3.237-1.444-3.237-3.448s1.39-3.447 3.237-3.447c1.846 0 3.237 1.444 3.237 3.447s-1.38 3.448-3.232 3.448zm21.906-9.283l-4.19 14.37c-.809 2.556-2.613 4.086-5.421 4.086-1.277 0-2.44-.261-3.35-.782-.531-.303-.971-.58-.971-1.023 0-.275.089-.417.25-.675l.832-1.246c.235-.348.408-.461.66-.461a.96.96 0 01.554.192c.523.339 1.008.63 1.748.63.864 0 1.524-.277 1.88-1.306l.36-1.193h-1.696c-.418 0-.648-.249-.751-.584l-3.75-12.008c-.14-.473-.011-.946.683-.946h2.954c.36 0 .613.123.771.64l2.77 9.67 2.589-9.67c.082-.334.306-.64.75-.64h2.802c.552-.001.719.387.526.946zm-96.806 4.274v7.676a.625.625 0 01-.635.634h-2.317a.623.623 0 01-.634-.634v-2.015c-1.472 1.858-4.03 3.028-6.924 3.028-5.434 0-9.681-4.088-9.681-9.908 0-6.048 4.585-10.217 10.377-10.217 4.276 0 7.694 1.839 9.212 5.537a.843.843 0 01.07.309c0 .175-.116.307-.486.435l-2.706 1.042a.694.694 0 01-.511.009.783.783 0 01-.324-.371c-.971-1.847-2.7-3.1-5.36-3.1-3.45 0-5.922 2.694-5.922 6.188 0 3.387 2.104 6.172 6.02 6.172 2.06 0 3.703-.97 4.469-2.037H57.87a.625.625 0 01-.634-.635v-2.086a.625.625 0 01.634-.634h7.161a.604.604 0 01.635.607zm96.882-8.063v-.186c0-.013.005-.026.013-.036a.052.052 0 01.034-.013h1.183c.013 0 .025.005.034.013.009.01.013.023.013.036v.186a.052.052 0 01-.013.034.047.047 0 01-.034.013h-.432v1.167a.05.05 0 01-.048.048h-.224a.044.044 0 01-.032-.014.047.047 0 01-.015-.034v-1.167h-.432a.044.044 0 01-.047-.047zm2.069-.193l.323.75.324-.75a.066.066 0 01.026-.032.087.087 0 01.044-.01h.375a.044.044 0 01.047.046v1.404a.044.044 0 01-.045.047h-.21a.047.047 0 01-.035-.013.042.042 0 01-.013-.034v-1.06l-.348.77a.084.084 0 01-.026.038.08.08 0 01-.043.01h-.172a.078.078 0 01-.042-.01.073.073 0 01-.026-.037l-.346-.77v1.06a.052.052 0 01-.013.033.052.052 0 01-.032.013h-.216a.042.042 0 01-.03-.013.042.042 0 01-.013-.034v-1.404a.044.044 0 01.047-.046h.364c.014 0 .029.003.042.01.009.009.015.02.018.032z"
    }))));
  }

  render() {
    const props = this.props;
    const linkProps = {
      'className': this.classNames(props.className, {
        [this.namespace('white-logo-bg')]: props.privateLabelId !== 1 && this._logo
      }),
      'urlArgs': props.urlArgs,
      'href': updateQuery(props.href, props.urlArgs),
      'data-eid': props['data-eid'],
      onClick: props.onClick
    };
    let logoContent;

    if (props.privateLabelId !== 1) {
      linkProps.rel = 'nofollow';
      logoContent = this.resellerLogo();
    } else if (props.tempLogo) {
      logoContent = this.renderTempLogo(props.tempLogo);
    } else {
      logoContent = this.renderGoLogo();
    }

    const logo = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, props.market !== 'en-US' && props.showCountryNameOnLogo && props.privateLabelId === 1 && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('topnav-country')
    }, props.country), logoContent);
    if (!props.href) return logo;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], linkProps, logo);
  }

}
src_LogoComponent.defaultProps = {
  country: '',
  market: 'en-US',
  privateLabelId: 1,
  showCountryNameOnLogo: false,
  urlArgs: {}
};
src_LogoComponent.propTypes = logo_src_objectSpread(logo_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  'className': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'country': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'data-eid': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'href': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'logos': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'market': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  'messages': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  'privateLabelId': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number.isRequired,
  'privateLabelName': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'showCountryNameOnLogo': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'spanClass': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'tempLogo': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'urlArgs': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'urls': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'isMobile': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'id': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/* harmony default export */ var logo_src = (Object(namespace_component_["withNamespace"])(src_LogoComponent));
// EXTERNAL MODULE: ./node_modules/@ux/icon/magnifying-glass/index.js
var magnifying_glass = __webpack_require__("./node_modules/@ux/icon/magnifying-glass/index.js");
var magnifying_glass_default = /*#__PURE__*/__webpack_require__.n(magnifying_glass);

// EXTERNAL MODULE: ./node_modules/@ux/icon/help/index.js
var help = __webpack_require__("./node_modules/@ux/icon/help/index.js");
var help_default = /*#__PURE__*/__webpack_require__.n(help);

// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/link-builder.js




const LinkBuilder = props => {
  const {
    title,
    eid,
    href,
    classNames,
    urlArgs
  } = props;

  if (!title || !href) {
    return null;
  }

  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
    className: classNames
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], {
    urlArgs: urlArgs,
    href: href,
    "data-eid": eid
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, title)));
};

LinkBuilder.propTypes = {
  classNames: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  eid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  id: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  title: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object
};
/* harmony default export */ var link_builder = (LinkBuilder);
// CONCATENATED MODULE: ./node_modules/@ux/utility-bar/src/index.js



function utility_bar_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function utility_bar_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { utility_bar_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { utility_bar_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















const Notifications = /*#__PURE__*/Object(external_root_React_commonjs_react_commonjs2_react_amd_react_["lazy"])(() => __webpack_require__.e(/*! import() | notifications */ "vendors~notifications").then(__webpack_require__.bind(null, /*! @ux/notifications */ "./node_modules/@ux/notifications/src/index.js")));
/**
 * Render and expose the Utility as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced UtilityBar.
 * @api public
 */

class src_UtilityBar extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(...arguments); //
    // Merge `components` from props with the default components so that incoming
    // props only have to set things that should be different than the default.
    //

    this.components = utility_bar_src_objectSpread(utility_bar_src_objectSpread({}, defaultComponents), props.components);
    this.oldBrand = props.isReseller && props.preset !== 'brand-header' && props.preset !== 'language-header';
    this.eids = {
      blogLink: eid_eid({
        key: golf.blogLink,
        manifest: props.manifest
      })
    };
  }
  /**
   * Update this.components when props.components changes
   *
   * @param {Object} nextProps the new properties that are received
   * @api private
   */


  componentWillReceiveProps(nextProps) {
    // Merge `components` from props with the default components so that incoming props only have to set things that should be
    // different than the default.
    this.components = utility_bar_src_objectSpread(utility_bar_src_objectSpread({}, defaultComponents), nextProps.components);
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */


  componentWillUnmount() {
    this.breakup();
  }
  /**
   * Add eventListeners for breakpoints. Notify listeners the utilityBar
   * is mounted and expose the instance.
   *
   * @api private
   */


  componentDidMount() {
    this.breakpoint('mobile', 'phablet', 'tablet', 'desktop', 'large');
  }
  /**
   * Re-scale the headerNav after username and cart data are available
   *
   * @param {Object} prevProps The previous props for utility-bar
   * @api private
   */


  componentDidUpdate(prevProps) {
    const {
      items,
      cart = {},
      customer
    } = this.props;

    if (this.headerNav && (items !== prevProps.items || cart.items !== (prevProps.cart && prevProps.cart.items) || customer.shopperId !== prevProps.shopperId)) {
      this.headerNav.measureContainer();
      this.headerNav.scale(true);
    }
  }
  /**
   * Prefer state over props when assigning to children
   *
   * @returns {Object} Child props
   * @api private
   */


  getChildProps() {
    return object_assign_default()({}, this.props, this.state);
  }
  /**
   * Render notifications module
   *
   * @returns {React.ReactElement} Notifications component
   */


  renderNotifications() {
    const props = this.props;
    const {
      urls,
      messages,
      privateLabelId
    } = props;
    const headerText = messages[golf.notificationsHeaderText];

    const notificationProps = utility_bar_src_objectSpread({
      showCount: false,
      showOpenCaret: true,
      manifest: props.manifest,
      sso: {
        href: urls.sso.href,
        login: urls.sso.login
      },
      market: props.market,
      shopperId: props.shopperId,
      privateLabelId,
      messages: {
        noNotificationsTitle: messages[golf.noNotificationsTitle],
        noNotificationsText: messages[golf.noNotificationsText],
        failedNotificationsTitle: messages[golf.failedNotificationsTitle],
        failedNotificationsText: messages[golf.failedNotificationsText],
        failedNotificationsLink: messages[golf.failedNotificationsLink],
        headerText
      },
      tooltip: headerText
    }, urls.notifications);

    return typeof window !== 'undefined' && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_["Suspense"], {
      fallback: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('notifications-fallback')
      })
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(Notifications, notificationProps));
  }
  /**
   * Renders help, notifications, account tray, cart in that order
   * @param  {Object} cartProps  Props specific to cart
   * @param  {Object} childProps Values assembled from combining props and state
   * @returns {React.ReactElement} A right-aligned div containing global elements
   */


  renderGlobalElements(cartProps, childProps) {
    const props = this.props;
    const components = this.components;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, components.help && this.renderHelpCenter(), components.notifications && props.loggedIn && this.renderNotifications(), components.accountTray && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(account_tray, childProps), components.cart && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(header_cart_src, cartProps));
  }

  renderDomainSearch() {
    const mobileSearch = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      urlArgs: this.props.urlArgs
    }, this.props.urls.domainSearch, {
      className: this.namespace('mobile-header-domain-search')
    }));
    const action = "".concat(this.props.urls.home.href, "/domainsearch/find");
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, mobileSearch, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Sales:DomainSearch:Input:Placeholder"
    }, placeholder => /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("form", {
      method: "GET",
      action: action,
      className: this.namespace('input-group', 'header-domain-search')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("input", {
      placeholder: placeholder,
      type: "text",
      name: "domainToCheck",
      className: this.namespace('form-control')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('input-group-btn')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      design: "addon",
      type: "submit",
      value: "Submit"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(magnifying_glass_default.a, null))))));
  }

  renderHelpCenter() {
    const {
      fullHelpLinkId,
      urlArgs,
      urls,
      split,
      supportContacts: {
        technicalSupportDescription,
        technicalSupportPhone
      } = {}
    } = this.props;
    const isIconsContactHelpExp = split === 'iconsContactHelpExp';
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: fullHelpLinkId
    }, title => /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      "data-eid": "uxp.hyd.utility_bar.help.link.click",
      className: this.namespace(this.classNames('help-link', {
        'help-icon-exp': isIconsContactHelpExp
      })),
      urlArgs: urlArgs
    }, urls.help, {
      target: "_blank",
      title: title,
      ariaLabel: technicalSupportDescription + ' ' + technicalSupportPhone
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('help-icon')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(help_default.a, {
      width: 28,
      height: 28
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('help-link-text')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: fullHelpLinkId
    }))));
  }

  renderFeaturedNav() {
    const {
      urlArgs,
      domainsExp,
      featuredNav,
      messages,
      market,
      scaleFeaturedNav,
      eidPrefix
    } = this.props;

    if (scaleFeaturedNav) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(header_navigation_src, {
        ref: r => {
          this.headerNav = r;
        },
        messages: messages,
        market: market,
        eidPrefix: eidPrefix,
        moreMenuEid: "".concat(eidPrefix, "_more.menu.click"),
        items: featuredNav,
        urlArgs: urlArgs,
        scale: true
      });
    }

    const navs = featuredNav.map(item => {
      if (!item.onlyMobile) {
        const {
          id
        } = item;
        const eid = eid_eid({
          key: id
        });
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_builder, extends_default()({}, item, {
          key: id,
          eid: eid,
          urlArgs: urlArgs,
          classNames: this.namespace('d-none', 'd-lg-flex')
        }));
      }
    });
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace(this.classNames('featured-nav', {
        'domains-experiment': domainsExp
      }))
    }, navs);
  }
  /**
   * Render function for jsx specific to DeepSee
   * @param  {Object} logoProps  Props specific to logo
   * @param  {Object} cartProps  Props specific to cart
   * @param  {Object} childProps Values assembled from combining props and state
   * @returns {React.ReactElement} div for seechange elements
   */


  renderDeepSee(logoProps, cartProps, childProps) {
    const props = this.props;
    const components = this.components;
    const {
      split,
      messages,
      urls,
      urlArgs
    } = props;
    const {
      features
    } = childProps;
    const control = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('product-flyout-btn-lines', 'no-treatment')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('product-flyout-btn-outline')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('product-flyout-btn-lines')
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.productPanelControl
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('product-flyout-title')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.productPanelControl
    })));
    const productPanelProps = {
      control,
      messages,
      urls,
      discoverNav: props.discoverNav,
      productNav: props.navigation,
      urlArgs,
      globalElements: false,
      controlWrapperClass: this.namespace(this.classNames({
        'product-panel-left': split === 'productpanela',
        'product-panel-c': split === 'productpanelc',
        'product-panel-e': split === 'productpanele'
      }))
    };
    const marketSelectorProps = object_assign_default()({
      currentPage: props.currentPage,
      manifest: props.manifest,
      eidPrefix: 'uxp.hyd',
      urls,
      urlArgs,
      messages,
      currentMarket: props.market,
      numColumns: this.state.breakpoint === 'tablet' ? 2 : 4,
      marketData: props.marketData,
      isReseller: props.isReseller
    }, props.marketSelector);
    const eids = this.eids;
    const contactTrayProps = object_assign_default()({
      contactTrayEnabled: features.contactTray,
      utilityChatEnabled: features.utilityChat,
      requestACallEnabled: features.requestACall,
      shopperId: props.customer.shopperId
    }, props);
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('flex-row', 'd-flex')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('see-change-bar-left', 'd-flex')
    }, components.logo && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('topnav-logo-wrap', {
        'product-panel-left': split === 'productpanela'
      }))
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(logo_src, logoProps)), components.marketSelector && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('market-selector-container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(market_selector_src, marketSelectorProps)), components.productPanel && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(product_panel_src, productPanelProps), props.featuredNav && this.renderFeaturedNav(), components.domainSearch && this.renderDomainSearch()), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('see-change-bar-right', 'justify-content-end')
    }, components.contactTray && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(contact_tray, contactTrayProps), components.blog && props.urls.blog && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      className: this.namespace('blog-link'),
      urlArgs: props.urlArgs
    }, props.urls.blog, {
      "data-eid": eids.blogLink
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.blogLink
    })), this.renderGlobalElements(cartProps, childProps)));
  }
  /**
   * Render function for jsx in all non-deepsee instances of utility-bar
   * @param  {Object} logoProps  Props specific to logo
   * @param  {Object} cartProps  Props specific to cart
   * @param  {Object} childProps Values assembled from combining props and state
   * @returns {React.ReactElement} div for normal rendering of elements
   */


  renderOldBrand(logoProps, cartProps, childProps) {
    const props = this.props;
    const components = this.components;
    const eids = this.eids;
    const {
      features
    } = childProps;
    const marketSelectorProps = object_assign_default()({
      currentPage: props.currentPage,
      manifest: props.manifest,
      eidPrefix: 'uxp.hyd',
      urls: props.urls,
      urlArgs: props.urlArgs,
      messages: props.messages,
      currentMarket: props.market,
      numColumns: this.state.breakpoint === 'tablet' ? 2 : 4,
      marketData: props.marketData,
      isReseller: props.isReseller
    }, props.marketSelector);
    const contactTrayProps = object_assign_default()({
      contactTrayEnabled: features.contactTray,
      utilityChatEnabled: features.utilityChat,
      shopperId: props.customer.shopperId
    }, props);
    const utilSeparator = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('util-separator')
    });
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('flex-row')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('utility-left-nav')
    }, components.logo && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('topnav-logo-wrap')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(logo_src, logoProps)), components.marketSelector && !props.isReseller && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('market-selector-container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(market_selector_src, marketSelectorProps))), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('utility-right-nav')
    }, components.utilitySeparator && props.isPaymentHeader && utilSeparator, components.contactTray && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(contact_tray, contactTrayProps), components.marketSelector && props.isReseller && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(market_selector_src, marketSelectorProps), // if there is no props.urls.blog, then blog is blacklisted
    components.blog && props.urls.blog && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_src["default"], extends_default()({
      className: this.namespace('blog-link'),
      urlArgs: props.urlArgs
    }, props.urls.blog, {
      "data-eid": eids.blogLink
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: golf.blogLink
    })), components.help && this.renderHelpCenter(), components.utilitySeparator && props.loggedIn && utilSeparator, components.notifications && this.props.loggedIn && this.renderNotifications(), components.utilitySeparator && !props.isPaymentHeader && utilSeparator, components.utilitySeparator && props.isPaymentHeader && !props.loggedIn && utilSeparator, components.accountTray && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(account_tray, extends_default()({}, childProps, {
      oldBrand: true
    })), components.cart && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(header_cart_src, cartProps))));
  }
  /**
  * Renders utility-bar
  * @returns {React.ReactElement} the whole utility-bar
  */


  render() {
    const props = this.props;
    const {
      logos,
      isReseller,
      resellerStorefrontLogoSize
    } = props;
    const components = this.components;
    const childProps = this.getChildProps();
    const marketInfo = props.marketData[props.market];
    const isPrivateLabel = props.privateLabelId !== 1;
    this.countryName = marketInfo ? marketInfo.countryName : 'United States'; // Only apply logo size class name on reseller storefront for private
    // labels with a desktop logo and a size setting other than 'small'.

    const plLogoSize = isReseller && isPrivateLabel && logos && logos.desktop && resellerStorefrontLogoSize && resellerStorefrontLogoSize !== 'small' && "pl-".concat(resellerStorefrontLogoSize, "-logo");
    const logoProps = object_assign_default()({
      'className': this.namespace('topnav-logo', props.tempLogo && 'temp-logo-anchor', plLogoSize),
      'showCountryNameOnLogo': !this.isMobile && this.state.breakpoint !== 'tablet',
      'country': this.countryName,
      'href': props.urls.home.href,
      'logos': props.logos,
      'market': props.market,
      'messages': props.messages,
      'privateLabelId': props.privateLabelId,
      'privateLabelName': props.privateLabelName,
      'urlArgs': props.urlArgs,
      'tempLogo': props.tempLogo,
      'urls': props.urls,
      'data-eid': 'uxp.hyd.utility_bar.logo.link.click'
    }, props.logo);
    const cartProps = object_assign_default()({}, props.cart);

    if (typeof this.props.items === 'number') {
      cartProps.items = this.props.items;
    } // isReseller comes from sales-header
    // isPrivateLabel must be calculated for utility-header


    const utilityBarClasses = this.namespace(this.classNames({
      'utility-bar': this.oldBrand,
      'single-use-header': components.logo && !props.isPaymentHeader && this.oldBrand,
      'payment-header': props.isPaymentHeader,
      'pl': isPrivateLabel,
      'pl-no-logo': isPrivateLabel && (!logos || !(this.isMobile ? logos.mobile : logos.desktop)),
      'reseller': isReseller,
      'language-header': props.preset === 'language-header',
      'brand-header': props.preset === 'brand-header',
      'logged-in': props.loggedIn,
      'see-change-bar': !this.oldBrand
    }));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, components.accountDelegation && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(account_delegation_src, {
      market: props.market,
      messages: props.messages,
      action: props.urls.sso.exitDelegation.href,
      restoreCookie: props.urls.sso.restoreCookie.href,
      customer: props.customer
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: utilityBarClasses
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.oldBrand ? 'container' : 'container-fluid')
    }, this.oldBrand ? this.renderOldBrand(logoProps, cartProps, childProps) : this.renderDeepSee(logoProps, cartProps, childProps)))));
  }

}

src_UtilityBar.propTypes = utility_bar_src_objectSpread(utility_bar_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  components: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    marketSelector: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    contactTray: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    help: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    notifications: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    accountTray: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    cart: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    blog: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
    logo: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
  }),
  bottomNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  contactTray: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  currentHref: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  customer: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  discoverNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  features: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  manifest: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  marketSelector: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  marketData: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  navigation: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  privateLabelName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  supportContacts: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  tempLogo: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  utilityBarNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object),
  isPaymentHeader: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  isReseller: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  fullHelpLinkId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  resellerStorefrontLogoSize: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  domainsExp: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  scaleFeaturedNav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
src_UtilityBar.defaultProps = {
  utilityBarNav: [],
  components: defaultComponents,
  contactTray: {
    compact: true
  },
  features: {},
  privateLabelId: 1,
  privateLabelName: '',
  isPaymentHeader: false,
  isReseller: false,
  marketData: {},
  fullHelpLinkId: golf.helpLink,
  scaleFeaturedNav: false,
  eidPrefix: 'uxp.hyd.featured_nav'
};
/* harmony default export */ var utility_bar_src = (Object(namespace_component_["withNamespace"])(src_UtilityBar));
// CONCATENATED MODULE: ./node_modules/@ux/application-footer/src/index.js



function application_footer_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function application_footer_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { application_footer_src_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { application_footer_src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





/**
 * Configuration for the GoLF i18n string (and associated EID)
 * of the privacy policy links in this footer component. These
 * are included here (again) so that component can stand alone
 * when reused across multiple header services.
 */

const privacyLinks = {
  policy: {
    golf: 'PC:AppHeader:Footer:PrivacyPolicy',
    eid: 'uxp.hyd.int.pc.app_header.footer.privacy_policy.link.click'
  },
  doNotSell: {
    golf: 'Shared:Footer:Privacy:DoNotSell',
    eid: 'uxp.hyd.int.pc.app_header.footer.do_not_sell.link.click'
  }
};
/**
 * Render Application Header Footer.
 *
 * @class Footer
 * @api public
 */

class src_ApplicationFooter extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.htmlClassName = this.namespace('footer-html');
    this.setHeight = this.setHeight.bind(this);
  }
  /**
   * Calculate height and add as margin to the bottom.
   *
   * @returns {Footer} fluent interface.
   * @api private
   */


  setHeight() {
    const height = parseInt(window.getComputedStyle(this.element).height, 10) || 0;
    this.body.style.marginBottom = "".concat(height, "px");
    return this;
  }
  /**
   * Add className to the html element to display the footer.
   *
   * @returns {Footer} fluent interface.
   * @api private
   */


  addClassName() {
    const html = this.body.parentNode;
    html.className = html.className.split(' ').concat(this.htmlClassName).filter(Boolean).join(' ');
    return this;
  }
  /**
   * Renders the footer links
   *
   * @param {Object}   props Full set of props for this component
   * @param {String}   url url for link
   * @param {Object}   name Set of golf string and eid
   * @returns {React.Component} a for privacy link
   */


  buildPrivacyLink(props, url, name) {
    // plid=3153 is used when "we do not know" the plid in which case we remove the privacy policy link.
    if (props.privateLabelId === 3153) {
      return;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", extends_default()({
      className: this.namespace('privacy-link')
    }, url, {
      "data-eid": privacyLinks[name].eid
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: privacyLinks[name].golf
    }));
  }
  /**
   * Add margin to the bottom of the body on mount and resizes to create space
   * for the absolutely positioned footer.
   *
   * @api private
   */


  componentDidMount() {
    this.body = document.body;
    this.on('resize', this.setHeight);
    this.addClassName().setHeight();
  }
  /**
   * Remove the resize eventlistener when the component is unmounted.
   *
   * @api private
   */


  componentWillUnmount() {
    const html = this.body.parentNode;
    html.className = html.className.replace(this.htmlClassName, '');
    this.off('resize', this.setHeight);
  }

  render() {
    const props = this.props;
    const features = props.features || {};
    const id = this.namespace('appheader-footer');
    const className = this.namespace('manifest', 'footer');
    let copyright = 'PC:AppHeader:Footer:Copyright';

    if (props.privateLabelId !== 1) {
      copyright += 'PL';
    } // This is a placeholder div that is used for tealium's privacy policy content injection.


    const tealiumPrivacyPlaceholder = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      id: "gtm_privacy"
    });
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("footer", {
      id: id,
      className: className,
      ref: c => {
        this.element = c;
      }
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      role: "contentinfo",
      className: this.namespace('container')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: copyright,
      values: {
        year: props.year
      }
    }), ' '
    /* intentional whitespace, JSX parser limitation */
    , this.buildPrivacyLink(props, props.urls.privacy, 'policy'), features.doNotSellLink && props.urls.cookies && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('do-not-sell')
    }, this.buildPrivacyLink(props, props.urls.cookies, 'doNotSell'))), tealiumPrivacyPlaceholder));
  }

}
/**
 * Default properties for the Footer. Year is only provided as fallback value
 * and should always be replaced with server time.
 *
 * @type {Object}
 * @api public
 */


src_ApplicationFooter.defaultProps = {
  urls: {
    privacy: {
      href: 'https://www.godaddy.com/agreements/showdoc.aspx?pageid=PRIVACY'
    }
  },
  year: new Date().getFullYear(),
  privateLabelId: 1
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

src_ApplicationFooter.propTypes = application_footer_src_objectSpread(application_footer_src_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  features: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  year: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number
});
/* harmony default export */ var application_footer_src = (Object(namespace_component_["withNamespace"])(src_ApplicationFooter));
// CONCATENATED MODULE: ./node_modules/@ux/abstract-header/src/index.js






const BrowserDeprecationBanner = /*#__PURE__*/Object(external_root_React_commonjs_react_commonjs2_react_amd_react_["lazy"])(() => __webpack_require__.e(/*! import() | browser-deprecation-banner */ "vendors~browser-deprecation-banner").then(__webpack_require__.bind(null, /*! @ux/browser-deprecation-banner */ "./node_modules/@ux/browser-deprecation-banner/src/index.js")));
/**
 * Super class for @ux/{sales,application,utility, pass}-headers. This module
 * should not be used directly, but rather extended in order to centralize a
 * lot of the shared business logic among the header.
 */

class src_AbstractHeader extends namespace_component_["NamespaceConsumer"] {
  constructor(props) {
    super(...arguments);
    this.events = header_util_src["events"];
    this.state = {
      cartItems: 0
    }; // Expose a method on ux.eldorado.header to updateCart for passing down
    // to UtilityBar's Cart class as props.items

    this.updateCart = src["default"].update.bind(this);
    header_util_src["traffic2"].init({
      type: props.traffic,
      beacon: true
    });
    this.customer = this.createCustomer();
  }
  /**
   * @typedef {typeof Customer} Customer
   */

  /**
   * Returns a valid Customer instance using the props associated
   * with this instance. Derived Headers (e.g. ApplicationHeader, SalesHeader, etc.)
   * should override this method to define custom cookie behavior.
   *
   * @returns {Customer} Customer instance from @ux/header-util.
   */


  createCustomer() {
    return new header_util_src["Customer"](this.props);
  }
  /**
   * Returns a value indicating if this instance will display no components
   * which themselves would require authentication (and thus a GUI call).
   * @param  {Object} components This has two distinct upstream locations:
   *   - `@ux/sales-header`:  props.components.utilityBar`.
   *   - `@ux/utility-header`: props.components (read from preset.components).
   * @returns {Boolean} Returns true if no auth data is required.
   */


  isUnauthenticated(components) {
    components = components || {};
    return !(components.accountDelegation || components.notifications || components.accountTray || components.cart || components.contactTray); // Federated partner info requires GUI call
  }

  getWindowLocation() {
    return window.location.href;
  }
  /**
   * Read in cookie Data for OrderConfirmation
   */


  getOrderDetails() {
    const orderId = new util_["URL"](this.getWindowLocation(), true).query.orderId;

    if (orderId) {
      this.setState({
        orderId
      });
    }
  }
  /**
   * Returns a shallow copy of any state set by the GUI call in
   * this.getCustomerDetails() for ease-of-access.
   * @returns {Object} All state we set from our GUI call for the customer.
   */


  getCustomerState() {
    const {
      state = {}
    } = this;
    return {
      displayName: state.displayName,
      federatedPartner: state.federatedPartner,
      items: state.items,
      isInGoCohort: state.isInGoCohort,
      isPro: state.isPro,
      loggedIn: state.loggedIn,
      name: state.name,
      proshopper: state.proshopper,
      rewardPoints: state.rewardPoints,
      shopperId: state.shopperId,
      username: state.username,
      vip: state.vip
    };
  }
  /**
   * Get customer details.
   *
   * @param {Function} [done] Completion callback.
   * @api private
   */


  getCustomerDetails(done) {
    // Start with data from the existing cookie
    this.customer.updateFromCookie();

    if (typeof done !== 'function') {
      done = () => {};
    }

    if (this.state.unauthenticated && !account_delegation_src.active) {
      // No components visible that use customer data, so we can skip the GUI call
      header_util_src["shopperDataLoader"].configureOnly({
        url: this.props.urls.gui.href,
        privateLabelId: this.props.privateLabelId,
        shopperId: this.customer.shopperId
      });
      done();
      return;
    } // Next, try to fetch fresh data from the server


    this.customer.fetch({
      gui: this.props.urls.gui.href
    }, error => {
      if (error) {
        const doneWithError = () => {
          header_util_src["events"].emit('error', error);
          done(error);
        }; // We still have some data from the cookie, so just fall back to that.
        // We use the presence of a shopper ID as a weak proxy to login state.
        // This won't actually unlock any real actions -- just tells the header to act
        // like the user is logged in. If they are not really logged in, they'll get
        // sent to SSO when they try to do anything that requires login.


        if (this.customer.shopperId) {
          this.setState({
            displayName: this.customer.displayName(true),
            federatedPartner: this.customer.get('federatedPartner'),
            name: this.customer.displayName(),
            shopperId: this.customer.shopperId,
            loggedIn: true
          }, doneWithError);
        } else {
          doneWithError();
        }

        return;
      }

      const proUser = this.customer.get('proshopper');
      const proshopper = proUser && proUser.status === 1;
      const rewardPoints = proshopper ? proUser.rewardPoints : null;
      const tmsData = this.customer.get('tms');
      const isInGoCohort = tmsData && tmsData.some(split => {
        return split.Name === 'wsb_vnext';
      });
      this.setState({
        displayName: this.customer.displayName(true),
        federatedPartner: this.customer.get('federatedPartner'),
        items: this.customer.cart,
        isInGoCohort,
        isPro: proshopper,
        loggedIn: this.customer.loggedIn,
        name: this.customer.displayName(),
        proshopper,
        rewardPoints,
        shopperId: this.customer.shopperId,
        username: this.customer.get('loginName'),
        vip: this.customer.vip
      }, done);
    }, false);
  }
  /**
   * Query Traffic for the variant result of a given experiment and pipe the result to React state
   *
   * @param {Object} opt Options
   * @param {String} opt.expId The experiment ID
   * @param {Object} [opt.attributes] An optional object to to pass along attributes
   * for Traffic/Split.io to calculate the variant ID. If none pass {}
   * @param {String} opt.stateFieldName The name of the React state field to store the result in
   * @param {StateValueTransformerFn} [opt.stateValueTransformer] An optional function to transform a variant ID into a state
   *   value. If omitted, the state field will contain the variant ID itself
   * @example <caption>Sets the state value to a boolean based on if the variant ID is 'B'</caption>
   * pipeExpVariantToState({'my_experiment', { 'market-id': 'en-US' }, 'myExperiment', variantId => variantId === 'B'}, done)
   * @param {Function} [done] Callback function
   *
   * @callback StateValueTransformerFn
   * @param {String} variantId The variant identifier to transform
   */


  pipeExpVariantToState({
    expId,
    attributes = {},
    stateFieldName,
    stateValueTransformer = variantId => variantId
  }, done) {
    // During server-rendering, we don't want to access `window`
    if (typeof window === 'undefined') return;
    const expDataLayer = window._expDataLayer = window._expDataLayer || [];

    const pipeVariantToState = variantId => {
      this.setState({
        [stateFieldName]: stateValueTransformer(variantId)
      }, done);
    };

    expDataLayer.push({
      schema: 'get_variant_for_experiment',
      version: 'v2',
      data: {
        experiment_id: expId,
        callback: pipeVariantToState,
        attributes: attributes,
        traffic_type: 'shopper'
      }
    });
  }
  /**
   * Query Hivemind for the variant result of a given experiment and set the result to React state
   *
   * @param {Object} opt Options
   * @param {String} opt.experimentId The experiment ID
   * @param {Object} [opt.attributes] An optional object to to pass along attributes
   * for split.io to calculate the variant ID. If none pass {}
   * @param {String} opt.stateFieldName The name of the React state field to store the result in
   * @param {Function} [done] Callback function used in unit tests
   */


  setExpVariantOnState({
    experimentId,
    attributes = {},
    stateFieldName
  }, done) {
    if (typeof window === 'undefined' || !window.hivemind) return;
    window.hivemind.getClient().then(client => {
      const {
        cohorts
      } = client.getCohorts({
        experiments: [experimentId],
        attributes
      });
      if (!cohorts || !cohorts[experimentId]) return;
      this.setState({
        [stateFieldName]: cohorts[experimentId].cohortId
      }, done);
    });
  }
  /**
   * Notify listeners the header is mounted and expose the instance.
   */


  componentDidMount() {
    this.events.emit('mount', 'header', this);
    this.events.emit('mount:header', this);
    this.getCustomerDetails();
    this.getOrderDetails();
  }
  /**
   * Notify header was updated.
   */


  componentDidUpdate() {
    header_util_src["events"].emit('update:header', this);
  }
  /**
   * Needed to prevent enzyme from complaining about
   * missing inst.render method
   * @returns {undefined}
   */


  render() {
    return null;
  }
  /**
   * Renders the chosen banner for all headers.
   * @param {Object} childProps The props to be used for the banner(s) that are rendered.
   * @returns {React.ReactElement} Returns the browser deprecation banner model
   */


  renderBanner(childProps) {
    return typeof window !== 'undefined' && /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_["Suspense"], {
      fallback: /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null)
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(BrowserDeprecationBanner, childProps));
  }

}
// EXTERNAL MODULE: ./src/presets.json
var presets = __webpack_require__("./src/presets.json");

// CONCATENATED MODULE: ./src/index.js



function src_ownKeys_0(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_objectSpread_0(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_ownKeys_0(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_ownKeys_0(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









/**
 * Return a namespace if the environment variable is set, 'polyfilled' by WebPack.
 *
 * @returns {Object} Configured namespace.
 * @api private
 */

function namespace() {
  return {
    namespace: "" // eslint-disable-line no-process-env

  };
}
/**
 * Render and expose the Header as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Header.
 * @api public
 */


class src_Header extends src_AbstractHeader {
  constructor(props) {
    super(...arguments);
    const preset = presets[props.preset];
    this.state = src_objectSpread_0(src_objectSpread_0({}, this.state), {}, {
      unauthenticated: preset && this.isUnauthenticated(preset.components)
    });
  }

  render() {
    const props = this.props;
    const cartProps = {
      items: this.state.cartItems,
      market: 'en-US',
      messages: props.messages,
      checkout: props.urls.checkout.href,
      eid: "uxp.hyd.".concat(props.manifest, ".header.cart.cart_link.link.click"),
      className: 'cart-link'
    };
    let preset = presets[props.preset];

    if (!preset) {
      throw new Error('Header preset not defined. This service serves the following headers: ' + Object.keys(presets).join(', '));
    }

    const plPreset = "".concat(props.preset, "-pl");

    if (props.privateLabelId !== 1 && presets[plPreset]) {
      preset = presets[plPreset];
    }

    const components = preset.components || {};
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceProvider"], namespace(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, this.renderBanner(props), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(utility_bar_src, extends_default()({}, props, this.getCustomerState(), {
      customer: this.customer,
      components: components,
      cart: cartProps
    }))));
  }

}

src_Header.propTypes = {
  preset: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(Object.keys(presets)).isRequired,
  supportContacts: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  traffic: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
};
/**
 * Render and expose the Footer as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Header.
 * @api public
 */

class src_Footer extends external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Component {
  componentDidMount() {
    header_util_src["events"].emit('mount', 'footer', this);
    header_util_src["events"].emit('mount:footer', this);
  }

  render() {
    const props = this.props;
    const preset = presets[this.props.preset];

    if (!preset.footer) {
      return null;
    }

    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceProvider"], namespace(), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(application_footer_src, props));
  }

}

src_Footer.propTypes = {
  preset: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(Object.keys(presets)).isRequired
};


/***/ }),

/***/ "./src/presets.json":
/*!**************************!*\
  !*** ./src/presets.json ***!
  \**************************/
/*! exports provided: brand-header, language-header, language-header-pl, default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module) {

module.exports = JSON.parse("{\"brand-header\":{\"components\":{\"marketSelector\":false,\"contactTray\":false,\"help\":false,\"notifications\":false,\"accountTray\":false,\"cart\":false,\"blog\":false,\"logo\":true,\"utilitySeparator\":false},\"footer\":true},\"language-header\":{\"components\":{\"logo\":true,\"marketSelector\":false,\"help\":false,\"notifications\":false,\"accountTray\":false,\"contactTray\":true,\"cart\":false,\"accountDelegation\":false,\"blog\":false,\"utilitySeparator\":false},\"footer\":true},\"language-header-pl\":{\"components\":{\"logo\":true,\"accountDelegation\":false,\"marketSelector\":true,\"contactTray\":true,\"help\":false,\"notifications\":false,\"accountTray\":false,\"cart\":false,\"blog\":false,\"utilitySeparator\":false},\"footer\":true}}");

/***/ }),

/***/ "@ux/button":
/*!*************************************************************************************************************************************!*\
  !*** external {"root":["ux","Button"],"commonjs":["@ux/button","default"],"commonjs2":["@ux/button","default"],"amd":"@ux/button"} ***!
  \*************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_button__;

/***/ }),

/***/ "@ux/checkbox":
/*!*********************************************************************************************************************************************!*\
  !*** external {"root":["ux","Checkbox"],"commonjs":["@ux/checkbox","default"],"commonjs2":["@ux/checkbox","default"],"amd":"@ux/checkbox"} ***!
  \*********************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_checkbox__;

/***/ }),

/***/ "@ux/collapsible":
/*!*********************************************************************************************************************************************************!*\
  !*** external {"root":["ux","Collapsible"],"commonjs":["@ux/collapsible","default"],"commonjs2":["@ux/collapsible","default"],"amd":"@ux/collapsible"} ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_collapsible__;

/***/ }),

/***/ "@ux/component":
/*!*************************************************************************************************************************************************!*\
  !*** external {"root":["ux","Component"],"commonjs":["@ux/component","default"],"commonjs2":["@ux/component","default"],"amd":"@ux/component"} ***!
  \*************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_component__;

/***/ }),

/***/ "@ux/dropdown":
/*!*********************************************************************************************************************************************!*\
  !*** external {"root":["ux","Dropdown"],"commonjs":["@ux/dropdown","default"],"commonjs2":["@ux/dropdown","default"],"amd":"@ux/dropdown"} ***!
  \*********************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_dropdown__;

/***/ }),

/***/ "@ux/form-element":
/*!************************************************************************************************************************************************************!*\
  !*** external {"root":["ux","FormElement"],"commonjs":["@ux/form-element","default"],"commonjs2":["@ux/form-element","default"],"amd":"@ux/form-element"} ***!
  \************************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_form_element__;

/***/ }),

/***/ "@ux/icon":
/*!*****************************************************************************************************************************!*\
  !*** external {"root":["ux","Icon"],"commonjs":["@ux/icon","default"],"commonjs2":["@ux/icon","default"],"amd":"@ux/icon"} ***!
  \*****************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_icon__;

/***/ }),

/***/ "@ux/modal":
/*!*********************************************************************************************************************************!*\
  !*** external {"root":["ux","Modal"],"commonjs":["@ux/modal","default"],"commonjs2":["@ux/modal","default"],"amd":"@ux/modal"} ***!
  \*********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_modal__;

/***/ }),

/***/ "@ux/namespace-component":
/*!****************************************************************************************************************************************************************************************!*\
  !*** external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"} ***!
  \****************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_namespace_component__;

/***/ }),

/***/ "@ux/quantity-selector":
/*!********************************************************************************************************************************************************************************!*\
  !*** external {"root":["ux","QuantitySelector"],"commonjs":["@ux/quantity-selector","default"],"commonjs2":["@ux/quantity-selector","default"],"amd":"@ux/quantity-selector"} ***!
  \********************************************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_quantity_selector__;

/***/ }),

/***/ "@ux/radio":
/*!*********************************************************************************************************************************!*\
  !*** external {"root":["ux","Radio"],"commonjs":["@ux/radio","default"],"commonjs2":["@ux/radio","default"],"amd":"@ux/radio"} ***!
  \*********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_radio__;

/***/ }),

/***/ "@ux/radio-group":
/*!********************************************************************************************************************************************************!*\
  !*** external {"root":["ux","RadioGroup"],"commonjs":["@ux/radio-group","default"],"commonjs2":["@ux/radio-group","default"],"amd":"@ux/radio-group"} ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_radio_group__;

/***/ }),

/***/ "@ux/spinner":
/*!*****************************************************************************************************************************************!*\
  !*** external {"root":["ux","Spinner"],"commonjs":["@ux/spinner","default"],"commonjs2":["@ux/spinner","default"],"amd":"@ux/spinner"} ***!
  \*****************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_spinner__;

/***/ }),

/***/ "@ux/tooltip":
/*!*****************************************************************************************************************************************!*\
  !*** external {"root":["ux","Tooltip"],"commonjs":["@ux/tooltip","default"],"commonjs2":["@ux/tooltip","default"],"amd":"@ux/tooltip"} ***!
  \*****************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_tooltip__;

/***/ }),

/***/ "@ux/util":
/*!******************************************************************************************************************************!*\
  !*** external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"} ***!
  \******************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_util__;

/***/ }),

/***/ "prop-types":
/*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"} ***!
  \*********************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"} ***!
  \**************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-dom":
/*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"} ***!
  \*****************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

/***/ }),

/***/ "react-intl":
/*!***********************************************************************************************************************************!*\
  !*** external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"} ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_intl__;

/***/ }),

/***/ "react-trfq":
/*!***********************************************************************************************************************************!*\
  !*** external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"} ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_trfq__;

/***/ })

/******/ });
});